var Uo = Object.defineProperty;
var Pr = (r) => {
  throw TypeError(r);
};
var Co = (r, e, t) => e in r ? Uo(r, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : r[e] = t;
var Tr = (r, e, t) => Co(r, typeof e != "symbol" ? e + "" : e, t), jt = (r, e, t) => e.has(r) || Pr("Cannot " + t);
var a = (r, e, t) => (jt(r, e, "read from private field"), t ? t.call(r) : e.get(r)), L = (r, e, t) => e.has(r) ? Pr("Cannot add the same private member more than once") : e instanceof WeakSet ? e.add(r) : e.set(r, t), q = (r, e, t, n) => (jt(r, e, "write to private field"), n ? n.call(r, t) : e.set(r, t), t), k = (r, e, t) => (jt(r, e, "access private method"), t);
const re = [];
for (let r = 0; r < 256; ++r)
  re.push((r + 256).toString(16).slice(1));
function Ro(r, e = 0) {
  return (re[r[e + 0]] + re[r[e + 1]] + re[r[e + 2]] + re[r[e + 3]] + "-" + re[r[e + 4]] + re[r[e + 5]] + "-" + re[r[e + 6]] + re[r[e + 7]] + "-" + re[r[e + 8]] + re[r[e + 9]] + "-" + re[r[e + 10]] + re[r[e + 11]] + re[r[e + 12]] + re[r[e + 13]] + re[r[e + 14]] + re[r[e + 15]]).toLowerCase();
}
let zt;
const xo = new Uint8Array(16);
function Oo() {
  if (!zt) {
    if (typeof crypto > "u" || !crypto.getRandomValues)
      throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    zt = crypto.getRandomValues.bind(crypto);
  }
  return zt(xo);
}
const Po = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto), Fr = { randomUUID: Po };
function Ce(r, e, t) {
  var o;
  if (Fr.randomUUID && !r)
    return Fr.randomUUID();
  r = r || {};
  const n = r.random ?? ((o = r.rng) == null ? void 0 : o.call(r)) ?? Oo();
  if (n.length < 16)
    throw new Error("Random bytes length must be >= 16");
  return n[6] = n[6] & 15 | 64, n[8] = n[8] & 63 | 128, Ro(n);
}
const To = EventTarget;
var Lr = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function bn(r) {
  return r && r.__esModule && Object.prototype.hasOwnProperty.call(r, "default") ? r.default : r;
}
var St = { exports: {} }, Fo = St.exports, Nr;
function Lo() {
  return Nr || (Nr = 1, function(r) {
    (function(e, t) {
      r.exports ? r.exports = t() : e.log = t();
    })(Fo, function() {
      var e = function() {
      }, t = "undefined", n = typeof window !== t && typeof window.navigator !== t && /Trident\/|MSIE /.test(window.navigator.userAgent), o = [
        "trace",
        "debug",
        "info",
        "warn",
        "error"
      ], i = {}, s = null;
      function l(B, x) {
        var U = B[x];
        if (typeof U.bind == "function")
          return U.bind(B);
        try {
          return Function.prototype.bind.call(U, B);
        } catch {
          return function() {
            return Function.prototype.apply.apply(U, [B, arguments]);
          };
        }
      }
      function u() {
        console.log && (console.log.apply ? console.log.apply(console, arguments) : Function.prototype.apply.apply(console.log, [console, arguments])), console.trace && console.trace();
      }
      function p(B) {
        return B === "debug" && (B = "log"), typeof console === t ? !1 : B === "trace" && n ? u : console[B] !== void 0 ? l(console, B) : console.log !== void 0 ? l(console, "log") : e;
      }
      function d() {
        for (var B = this.getLevel(), x = 0; x < o.length; x++) {
          var U = o[x];
          this[U] = x < B ? e : this.methodFactory(U, B, this.name);
        }
        if (this.log = this.debug, typeof console === t && B < this.levels.SILENT)
          return "No console available for logging";
      }
      function S(B) {
        return function() {
          typeof console !== t && (d.call(this), this[B].apply(this, arguments));
        };
      }
      function R(B, x, U) {
        return p(B) || S.apply(this, arguments);
      }
      function z(B, x) {
        var U = this, m, A, g, y = "loglevel";
        typeof B == "string" ? y += ":" + B : typeof B == "symbol" && (y = void 0);
        function E(N) {
          var G = (o[N] || "silent").toUpperCase();
          if (!(typeof window === t || !y)) {
            try {
              window.localStorage[y] = G;
              return;
            } catch {
            }
            try {
              window.document.cookie = encodeURIComponent(y) + "=" + G + ";";
            } catch {
            }
          }
        }
        function _() {
          var N;
          if (!(typeof window === t || !y)) {
            try {
              N = window.localStorage[y];
            } catch {
            }
            if (typeof N === t)
              try {
                var G = window.document.cookie, I = encodeURIComponent(y), ce = G.indexOf(I + "=");
                ce !== -1 && (N = /^([^;]+)/.exec(
                  G.slice(ce + I.length + 1)
                )[1]);
              } catch {
              }
            return U.levels[N] === void 0 && (N = void 0), N;
          }
        }
        function P() {
          if (!(typeof window === t || !y)) {
            try {
              window.localStorage.removeItem(y);
            } catch {
            }
            try {
              window.document.cookie = encodeURIComponent(y) + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC";
            } catch {
            }
          }
        }
        function O(N) {
          var G = N;
          if (typeof G == "string" && U.levels[G.toUpperCase()] !== void 0 && (G = U.levels[G.toUpperCase()]), typeof G == "number" && G >= 0 && G <= U.levels.SILENT)
            return G;
          throw new TypeError("log.setLevel() called with invalid level: " + N);
        }
        U.name = B, U.levels = {
          TRACE: 0,
          DEBUG: 1,
          INFO: 2,
          WARN: 3,
          ERROR: 4,
          SILENT: 5
        }, U.methodFactory = x || R, U.getLevel = function() {
          return g ?? A ?? m;
        }, U.setLevel = function(N, G) {
          return g = O(N), G !== !1 && E(g), d.call(U);
        }, U.setDefaultLevel = function(N) {
          A = O(N), _() || U.setLevel(N, !1);
        }, U.resetLevel = function() {
          g = null, P(), d.call(U);
        }, U.enableAll = function(N) {
          U.setLevel(U.levels.TRACE, N);
        }, U.disableAll = function(N) {
          U.setLevel(U.levels.SILENT, N);
        }, U.rebuild = function() {
          if (s !== U && (m = O(s.getLevel())), d.call(U), s === U)
            for (var N in i)
              i[N].rebuild();
        }, m = O(
          s ? s.getLevel() : "WARN"
        );
        var V = _();
        V != null && (g = O(V)), d.call(U);
      }
      s = new z(), s.getLogger = function(x) {
        if (typeof x != "symbol" && typeof x != "string" || x === "")
          throw new TypeError("You must supply a name when creating a logger.");
        var U = i[x];
        return U || (U = i[x] = new z(
          x,
          s.methodFactory
        )), U;
      };
      var H = typeof window !== t ? window.log : void 0;
      return s.noConflict = function() {
        return typeof window !== t && window.log === s && (window.log = H), s;
      }, s.getLoggers = function() {
        return i;
      }, s.default = s, s;
    });
  }(St)), St.exports;
}
var No = Lo();
const de = /* @__PURE__ */ bn(No);
let Je = localStorage.getItem("asset_sdk_verbose") === "true";
const ze = {};
de.setDefaultLevel(Je ? de.levels.DEBUG : de.levels.WARN);
function Qo(r) {
  Je = r, localStorage.setItem("asset_sdk_verbose", String(!!r));
  const e = Je ? de.levels.DEBUG : de.levels.WARN;
  de.setLevel(e), Object.values(ze).forEach((t) => {
    t.setLevel(e);
  });
  try {
    localStorage.setItem("asset_sdk_verbose", String(r));
  } catch (t) {
    console.error(`Can't save logger verbosity to localStorage: ${t}`);
  }
}
function qo(r) {
  ze[r] || (ze[r] = de.getLogger(`asset-sdk:${r}`), ze[r].setLevel(Je ? de.levels.DEBUG : de.levels.WARN));
  const e = ze[r], t = `[upload][${r}] `;
  return {
    debug(n, o) {
      e.debug(t, n, o);
    },
    info(n, o) {
      e.info(t, n, o);
    },
    error(n, o, i) {
      const s = {
        ...i,
        ...o && typeof o == "object" && "name" in o && "message" in o ? { errorName: o.name, errorMessage: o.message } : { error: o }
      };
      e.error(t, n, s);
    },
    isVerboseEnabled() {
      return Je;
    }
  };
}
typeof window < "u" && (window.asset_sdk_logger = { setVerbose: Qo, log: de });
const ge = /* @__PURE__ */ Object.create(null);
ge.open = "0";
ge.close = "1";
ge.ping = "2";
ge.pong = "3";
ge.message = "4";
ge.upgrade = "5";
ge.noop = "6";
const Bt = /* @__PURE__ */ Object.create(null);
Object.keys(ge).forEach((r) => {
  Bt[ge[r]] = r;
});
const tr = { type: "error", data: "parser error" }, wn = typeof Blob == "function" || typeof Blob < "u" && Object.prototype.toString.call(Blob) === "[object BlobConstructor]", _n = typeof ArrayBuffer == "function", En = (r) => typeof ArrayBuffer.isView == "function" ? ArrayBuffer.isView(r) : r && r.buffer instanceof ArrayBuffer, Er = ({ type: r, data: e }, t, n) => wn && e instanceof Blob ? t ? n(e) : Qr(e, n) : _n && (e instanceof ArrayBuffer || En(e)) ? t ? n(e) : Qr(new Blob([e]), n) : n(ge[r] + (e || "")), Qr = (r, e) => {
  const t = new FileReader();
  return t.onload = function() {
    const n = t.result.split(",")[1];
    e("b" + (n || ""));
  }, t.readAsDataURL(r);
};
function qr(r) {
  return r instanceof Uint8Array ? r : r instanceof ArrayBuffer ? new Uint8Array(r) : new Uint8Array(r.buffer, r.byteOffset, r.byteLength);
}
let Mt;
function Do(r, e) {
  if (wn && r.data instanceof Blob)
    return r.data.arrayBuffer().then(qr).then(e);
  if (_n && (r.data instanceof ArrayBuffer || En(r.data)))
    return e(qr(r.data));
  Er(r, !1, (t) => {
    Mt || (Mt = new TextEncoder()), e(Mt.encode(t));
  });
}
const Dr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", Me = typeof Uint8Array > "u" ? [] : new Uint8Array(256);
for (let r = 0; r < Dr.length; r++)
  Me[Dr.charCodeAt(r)] = r;
const Ho = (r) => {
  let e = r.length * 0.75, t = r.length, n, o = 0, i, s, l, u;
  r[r.length - 1] === "=" && (e--, r[r.length - 2] === "=" && e--);
  const p = new ArrayBuffer(e), d = new Uint8Array(p);
  for (n = 0; n < t; n += 4)
    i = Me[r.charCodeAt(n)], s = Me[r.charCodeAt(n + 1)], l = Me[r.charCodeAt(n + 2)], u = Me[r.charCodeAt(n + 3)], d[o++] = i << 2 | s >> 4, d[o++] = (s & 15) << 4 | l >> 2, d[o++] = (l & 3) << 6 | u & 63;
  return p;
}, jo = typeof ArrayBuffer == "function", Sr = (r, e) => {
  if (typeof r != "string")
    return {
      type: "message",
      data: Sn(r, e)
    };
  const t = r.charAt(0);
  return t === "b" ? {
    type: "message",
    data: zo(r.substring(1), e)
  } : Bt[t] ? r.length > 1 ? {
    type: Bt[t],
    data: r.substring(1)
  } : {
    type: Bt[t]
  } : tr;
}, zo = (r, e) => {
  if (jo) {
    const t = Ho(r);
    return Sn(t, e);
  } else
    return { base64: !0, data: r };
}, Sn = (r, e) => {
  switch (e) {
    case "blob":
      return r instanceof Blob ? r : new Blob([r]);
    case "arraybuffer":
    default:
      return r instanceof ArrayBuffer ? r : r.buffer;
  }
}, Bn = "", Mo = (r, e) => {
  const t = r.length, n = new Array(t);
  let o = 0;
  r.forEach((i, s) => {
    Er(i, !1, (l) => {
      n[s] = l, ++o === t && e(n.join(Bn));
    });
  });
}, $o = (r, e) => {
  const t = r.split(Bn), n = [];
  for (let o = 0; o < t.length; o++) {
    const i = Sr(t[o], e);
    if (n.push(i), i.type === "error")
      break;
  }
  return n;
};
function Vo() {
  return new TransformStream({
    transform(r, e) {
      Do(r, (t) => {
        const n = t.length;
        let o;
        if (n < 126)
          o = new Uint8Array(1), new DataView(o.buffer).setUint8(0, n);
        else if (n < 65536) {
          o = new Uint8Array(3);
          const i = new DataView(o.buffer);
          i.setUint8(0, 126), i.setUint16(1, n);
        } else {
          o = new Uint8Array(9);
          const i = new DataView(o.buffer);
          i.setUint8(0, 127), i.setBigUint64(1, BigInt(n));
        }
        r.data && typeof r.data != "string" && (o[0] |= 128), e.enqueue(o), e.enqueue(t);
      });
    }
  });
}
let $t;
function yt(r) {
  return r.reduce((e, t) => e + t.length, 0);
}
function mt(r, e) {
  if (r[0].length === e)
    return r.shift();
  const t = new Uint8Array(e);
  let n = 0;
  for (let o = 0; o < e; o++)
    t[o] = r[0][n++], n === r[0].length && (r.shift(), n = 0);
  return r.length && n < r[0].length && (r[0] = r[0].slice(n)), t;
}
function Go(r, e) {
  $t || ($t = new TextDecoder());
  const t = [];
  let n = 0, o = -1, i = !1;
  return new TransformStream({
    transform(s, l) {
      for (t.push(s); ; ) {
        if (n === 0) {
          if (yt(t) < 1)
            break;
          const u = mt(t, 1);
          i = (u[0] & 128) === 128, o = u[0] & 127, o < 126 ? n = 3 : o === 126 ? n = 1 : n = 2;
        } else if (n === 1) {
          if (yt(t) < 2)
            break;
          const u = mt(t, 2);
          o = new DataView(u.buffer, u.byteOffset, u.length).getUint16(0), n = 3;
        } else if (n === 2) {
          if (yt(t) < 8)
            break;
          const u = mt(t, 8), p = new DataView(u.buffer, u.byteOffset, u.length), d = p.getUint32(0);
          if (d > Math.pow(2, 21) - 1) {
            l.enqueue(tr);
            break;
          }
          o = d * Math.pow(2, 32) + p.getUint32(4), n = 3;
        } else {
          if (yt(t) < o)
            break;
          const u = mt(t, o);
          l.enqueue(Sr(i ? u : $t.decode(u), e)), n = 0;
        }
        if (o === 0 || o > r) {
          l.enqueue(tr);
          break;
        }
      }
    }
  });
}
const In = 4;
function K(r) {
  if (r) return Wo(r);
}
function Wo(r) {
  for (var e in K.prototype)
    r[e] = K.prototype[e];
  return r;
}
K.prototype.on = K.prototype.addEventListener = function(r, e) {
  return this._callbacks = this._callbacks || {}, (this._callbacks["$" + r] = this._callbacks["$" + r] || []).push(e), this;
};
K.prototype.once = function(r, e) {
  function t() {
    this.off(r, t), e.apply(this, arguments);
  }
  return t.fn = e, this.on(r, t), this;
};
K.prototype.off = K.prototype.removeListener = K.prototype.removeAllListeners = K.prototype.removeEventListener = function(r, e) {
  if (this._callbacks = this._callbacks || {}, arguments.length == 0)
    return this._callbacks = {}, this;
  var t = this._callbacks["$" + r];
  if (!t) return this;
  if (arguments.length == 1)
    return delete this._callbacks["$" + r], this;
  for (var n, o = 0; o < t.length; o++)
    if (n = t[o], n === e || n.fn === e) {
      t.splice(o, 1);
      break;
    }
  return t.length === 0 && delete this._callbacks["$" + r], this;
};
K.prototype.emit = function(r) {
  this._callbacks = this._callbacks || {};
  for (var e = new Array(arguments.length - 1), t = this._callbacks["$" + r], n = 1; n < arguments.length; n++)
    e[n - 1] = arguments[n];
  if (t) {
    t = t.slice(0);
    for (var n = 0, o = t.length; n < o; ++n)
      t[n].apply(this, e);
  }
  return this;
};
K.prototype.emitReserved = K.prototype.emit;
K.prototype.listeners = function(r) {
  return this._callbacks = this._callbacks || {}, this._callbacks["$" + r] || [];
};
K.prototype.hasListeners = function(r) {
  return !!this.listeners(r).length;
};
const Dt = typeof Promise == "function" && typeof Promise.resolve == "function" ? (e) => Promise.resolve().then(e) : (e, t) => t(e, 0), le = typeof self < "u" ? self : typeof window < "u" ? window : Function("return this")(), Jo = "arraybuffer";
function kn(r, ...e) {
  return e.reduce((t, n) => (r.hasOwnProperty(n) && (t[n] = r[n]), t), {});
}
const Xo = le.setTimeout, Ko = le.clearTimeout;
function Ht(r, e) {
  e.useNativeTimers ? (r.setTimeoutFn = Xo.bind(le), r.clearTimeoutFn = Ko.bind(le)) : (r.setTimeoutFn = le.setTimeout.bind(le), r.clearTimeoutFn = le.clearTimeout.bind(le));
}
const Yo = 1.33;
function Zo(r) {
  return typeof r == "string" ? ei(r) : Math.ceil((r.byteLength || r.size) * Yo);
}
function ei(r) {
  let e = 0, t = 0;
  for (let n = 0, o = r.length; n < o; n++)
    e = r.charCodeAt(n), e < 128 ? t += 1 : e < 2048 ? t += 2 : e < 55296 || e >= 57344 ? t += 3 : (n++, t += 4);
  return t;
}
function Un() {
  return Date.now().toString(36).substring(3) + Math.random().toString(36).substring(2, 5);
}
function ti(r) {
  let e = "";
  for (let t in r)
    r.hasOwnProperty(t) && (e.length && (e += "&"), e += encodeURIComponent(t) + "=" + encodeURIComponent(r[t]));
  return e;
}
function ri(r) {
  let e = {}, t = r.split("&");
  for (let n = 0, o = t.length; n < o; n++) {
    let i = t[n].split("=");
    e[decodeURIComponent(i[0])] = decodeURIComponent(i[1]);
  }
  return e;
}
class ni extends Error {
  constructor(e, t, n) {
    super(e), this.description = t, this.context = n, this.type = "TransportError";
  }
}
class Br extends K {
  /**
   * Transport abstract constructor.
   *
   * @param {Object} opts - options
   * @protected
   */
  constructor(e) {
    super(), this.writable = !1, Ht(this, e), this.opts = e, this.query = e.query, this.socket = e.socket, this.supportsBinary = !e.forceBase64;
  }
  /**
   * Emits an error.
   *
   * @param {String} reason
   * @param description
   * @param context - the error context
   * @return {Transport} for chaining
   * @protected
   */
  onError(e, t, n) {
    return super.emitReserved("error", new ni(e, t, n)), this;
  }
  /**
   * Opens the transport.
   */
  open() {
    return this.readyState = "opening", this.doOpen(), this;
  }
  /**
   * Closes the transport.
   */
  close() {
    return (this.readyState === "opening" || this.readyState === "open") && (this.doClose(), this.onClose()), this;
  }
  /**
   * Sends multiple packets.
   *
   * @param {Array} packets
   */
  send(e) {
    this.readyState === "open" && this.write(e);
  }
  /**
   * Called upon open
   *
   * @protected
   */
  onOpen() {
    this.readyState = "open", this.writable = !0, super.emitReserved("open");
  }
  /**
   * Called with data.
   *
   * @param {String} data
   * @protected
   */
  onData(e) {
    const t = Sr(e, this.socket.binaryType);
    this.onPacket(t);
  }
  /**
   * Called with a decoded packet.
   *
   * @protected
   */
  onPacket(e) {
    super.emitReserved("packet", e);
  }
  /**
   * Called upon close.
   *
   * @protected
   */
  onClose(e) {
    this.readyState = "closed", super.emitReserved("close", e);
  }
  /**
   * Pauses the transport, in order not to lose packets during an upgrade.
   *
   * @param onPause
   */
  pause(e) {
  }
  createUri(e, t = {}) {
    return e + "://" + this._hostname() + this._port() + this.opts.path + this._query(t);
  }
  _hostname() {
    const e = this.opts.hostname;
    return e.indexOf(":") === -1 ? e : "[" + e + "]";
  }
  _port() {
    return this.opts.port && (this.opts.secure && +(this.opts.port !== 443) || !this.opts.secure && Number(this.opts.port) !== 80) ? ":" + this.opts.port : "";
  }
  _query(e) {
    const t = ti(e);
    return t.length ? "?" + t : "";
  }
}
class oi extends Br {
  constructor() {
    super(...arguments), this._polling = !1;
  }
  get name() {
    return "polling";
  }
  /**
   * Opens the socket (triggers polling). We write a PING message to determine
   * when the transport is open.
   *
   * @protected
   */
  doOpen() {
    this._poll();
  }
  /**
   * Pauses polling.
   *
   * @param {Function} onPause - callback upon buffers are flushed and transport is paused
   * @package
   */
  pause(e) {
    this.readyState = "pausing";
    const t = () => {
      this.readyState = "paused", e();
    };
    if (this._polling || !this.writable) {
      let n = 0;
      this._polling && (n++, this.once("pollComplete", function() {
        --n || t();
      })), this.writable || (n++, this.once("drain", function() {
        --n || t();
      }));
    } else
      t();
  }
  /**
   * Starts polling cycle.
   *
   * @private
   */
  _poll() {
    this._polling = !0, this.doPoll(), this.emitReserved("poll");
  }
  /**
   * Overloads onData to detect payloads.
   *
   * @protected
   */
  onData(e) {
    const t = (n) => {
      if (this.readyState === "opening" && n.type === "open" && this.onOpen(), n.type === "close")
        return this.onClose({ description: "transport closed by the server" }), !1;
      this.onPacket(n);
    };
    $o(e, this.socket.binaryType).forEach(t), this.readyState !== "closed" && (this._polling = !1, this.emitReserved("pollComplete"), this.readyState === "open" && this._poll());
  }
  /**
   * For polling, send a close packet.
   *
   * @protected
   */
  doClose() {
    const e = () => {
      this.write([{ type: "close" }]);
    };
    this.readyState === "open" ? e() : this.once("open", e);
  }
  /**
   * Writes a packets payload.
   *
   * @param {Array} packets - data packets
   * @protected
   */
  write(e) {
    this.writable = !1, Mo(e, (t) => {
      this.doWrite(t, () => {
        this.writable = !0, this.emitReserved("drain");
      });
    });
  }
  /**
   * Generates uri for connection.
   *
   * @private
   */
  uri() {
    const e = this.opts.secure ? "https" : "http", t = this.query || {};
    return this.opts.timestampRequests !== !1 && (t[this.opts.timestampParam] = Un()), !this.supportsBinary && !t.sid && (t.b64 = 1), this.createUri(e, t);
  }
}
let Cn = !1;
try {
  Cn = typeof XMLHttpRequest < "u" && "withCredentials" in new XMLHttpRequest();
} catch {
}
const ii = Cn;
function si() {
}
class ai extends oi {
  /**
   * XHR Polling constructor.
   *
   * @param {Object} opts
   * @package
   */
  constructor(e) {
    if (super(e), typeof location < "u") {
      const t = location.protocol === "https:";
      let n = location.port;
      n || (n = t ? "443" : "80"), this.xd = typeof location < "u" && e.hostname !== location.hostname || n !== e.port;
    }
  }
  /**
   * Sends data.
   *
   * @param {String} data to send.
   * @param {Function} called upon flush.
   * @private
   */
  doWrite(e, t) {
    const n = this.request({
      method: "POST",
      data: e
    });
    n.on("success", t), n.on("error", (o, i) => {
      this.onError("xhr post error", o, i);
    });
  }
  /**
   * Starts a poll cycle.
   *
   * @private
   */
  doPoll() {
    const e = this.request();
    e.on("data", this.onData.bind(this)), e.on("error", (t, n) => {
      this.onError("xhr poll error", t, n);
    }), this.pollXhr = e;
  }
}
let xe = class It extends K {
  /**
   * Request constructor
   *
   * @param {Object} options
   * @package
   */
  constructor(e, t, n) {
    super(), this.createRequest = e, Ht(this, n), this._opts = n, this._method = n.method || "GET", this._uri = t, this._data = n.data !== void 0 ? n.data : null, this._create();
  }
  /**
   * Creates the XHR object and sends the request.
   *
   * @private
   */
  _create() {
    var e;
    const t = kn(this._opts, "agent", "pfx", "key", "passphrase", "cert", "ca", "ciphers", "rejectUnauthorized", "autoUnref");
    t.xdomain = !!this._opts.xd;
    const n = this._xhr = this.createRequest(t);
    try {
      n.open(this._method, this._uri, !0);
      try {
        if (this._opts.extraHeaders) {
          n.setDisableHeaderCheck && n.setDisableHeaderCheck(!0);
          for (let o in this._opts.extraHeaders)
            this._opts.extraHeaders.hasOwnProperty(o) && n.setRequestHeader(o, this._opts.extraHeaders[o]);
        }
      } catch {
      }
      if (this._method === "POST")
        try {
          n.setRequestHeader("Content-type", "text/plain;charset=UTF-8");
        } catch {
        }
      try {
        n.setRequestHeader("Accept", "*/*");
      } catch {
      }
      (e = this._opts.cookieJar) === null || e === void 0 || e.addCookies(n), "withCredentials" in n && (n.withCredentials = this._opts.withCredentials), this._opts.requestTimeout && (n.timeout = this._opts.requestTimeout), n.onreadystatechange = () => {
        var o;
        n.readyState === 3 && ((o = this._opts.cookieJar) === null || o === void 0 || o.parseCookies(
          // @ts-ignore
          n.getResponseHeader("set-cookie")
        )), n.readyState === 4 && (n.status === 200 || n.status === 1223 ? this._onLoad() : this.setTimeoutFn(() => {
          this._onError(typeof n.status == "number" ? n.status : 0);
        }, 0));
      }, n.send(this._data);
    } catch (o) {
      this.setTimeoutFn(() => {
        this._onError(o);
      }, 0);
      return;
    }
    typeof document < "u" && (this._index = It.requestsCount++, It.requests[this._index] = this);
  }
  /**
   * Called upon error.
   *
   * @private
   */
  _onError(e) {
    this.emitReserved("error", e, this._xhr), this._cleanup(!0);
  }
  /**
   * Cleans up house.
   *
   * @private
   */
  _cleanup(e) {
    if (!(typeof this._xhr > "u" || this._xhr === null)) {
      if (this._xhr.onreadystatechange = si, e)
        try {
          this._xhr.abort();
        } catch {
        }
      typeof document < "u" && delete It.requests[this._index], this._xhr = null;
    }
  }
  /**
   * Called upon load.
   *
   * @private
   */
  _onLoad() {
    const e = this._xhr.responseText;
    e !== null && (this.emitReserved("data", e), this.emitReserved("success"), this._cleanup());
  }
  /**
   * Aborts the request.
   *
   * @package
   */
  abort() {
    this._cleanup();
  }
};
xe.requestsCount = 0;
xe.requests = {};
if (typeof document < "u") {
  if (typeof attachEvent == "function")
    attachEvent("onunload", Hr);
  else if (typeof addEventListener == "function") {
    const r = "onpagehide" in le ? "pagehide" : "unload";
    addEventListener(r, Hr, !1);
  }
}
function Hr() {
  for (let r in xe.requests)
    xe.requests.hasOwnProperty(r) && xe.requests[r].abort();
}
const ci = function() {
  const r = Rn({
    xdomain: !1
  });
  return r && r.responseType !== null;
}();
class ui extends ai {
  constructor(e) {
    super(e);
    const t = e && e.forceBase64;
    this.supportsBinary = ci && !t;
  }
  request(e = {}) {
    return Object.assign(e, { xd: this.xd }, this.opts), new xe(Rn, this.uri(), e);
  }
}
function Rn(r) {
  const e = r.xdomain;
  try {
    if (typeof XMLHttpRequest < "u" && (!e || ii))
      return new XMLHttpRequest();
  } catch {
  }
  if (!e)
    try {
      return new le[["Active"].concat("Object").join("X")]("Microsoft.XMLHTTP");
    } catch {
    }
}
const xn = typeof navigator < "u" && typeof navigator.product == "string" && navigator.product.toLowerCase() === "reactnative";
class li extends Br {
  get name() {
    return "websocket";
  }
  doOpen() {
    const e = this.uri(), t = this.opts.protocols, n = xn ? {} : kn(this.opts, "agent", "perMessageDeflate", "pfx", "key", "passphrase", "cert", "ca", "ciphers", "rejectUnauthorized", "localAddress", "protocolVersion", "origin", "maxPayload", "family", "checkServerIdentity");
    this.opts.extraHeaders && (n.headers = this.opts.extraHeaders);
    try {
      this.ws = this.createSocket(e, t, n);
    } catch (o) {
      return this.emitReserved("error", o);
    }
    this.ws.binaryType = this.socket.binaryType, this.addEventListeners();
  }
  /**
   * Adds event listeners to the socket
   *
   * @private
   */
  addEventListeners() {
    this.ws.onopen = () => {
      this.opts.autoUnref && this.ws._socket.unref(), this.onOpen();
    }, this.ws.onclose = (e) => this.onClose({
      description: "websocket connection closed",
      context: e
    }), this.ws.onmessage = (e) => this.onData(e.data), this.ws.onerror = (e) => this.onError("websocket error", e);
  }
  write(e) {
    this.writable = !1;
    for (let t = 0; t < e.length; t++) {
      const n = e[t], o = t === e.length - 1;
      Er(n, this.supportsBinary, (i) => {
        try {
          this.doWrite(n, i);
        } catch {
        }
        o && Dt(() => {
          this.writable = !0, this.emitReserved("drain");
        }, this.setTimeoutFn);
      });
    }
  }
  doClose() {
    typeof this.ws < "u" && (this.ws.onerror = () => {
    }, this.ws.close(), this.ws = null);
  }
  /**
   * Generates uri for connection.
   *
   * @private
   */
  uri() {
    const e = this.opts.secure ? "wss" : "ws", t = this.query || {};
    return this.opts.timestampRequests && (t[this.opts.timestampParam] = Un()), this.supportsBinary || (t.b64 = 1), this.createUri(e, t);
  }
}
const Vt = le.WebSocket || le.MozWebSocket;
class hi extends li {
  createSocket(e, t, n) {
    return xn ? new Vt(e, t, n) : t ? new Vt(e, t) : new Vt(e);
  }
  doWrite(e, t) {
    this.ws.send(t);
  }
}
class fi extends Br {
  get name() {
    return "webtransport";
  }
  doOpen() {
    try {
      this._transport = new WebTransport(this.createUri("https"), this.opts.transportOptions[this.name]);
    } catch (e) {
      return this.emitReserved("error", e);
    }
    this._transport.closed.then(() => {
      this.onClose();
    }).catch((e) => {
      this.onError("webtransport error", e);
    }), this._transport.ready.then(() => {
      this._transport.createBidirectionalStream().then((e) => {
        const t = Go(Number.MAX_SAFE_INTEGER, this.socket.binaryType), n = e.readable.pipeThrough(t).getReader(), o = Vo();
        o.readable.pipeTo(e.writable), this._writer = o.writable.getWriter();
        const i = () => {
          n.read().then(({ done: l, value: u }) => {
            l || (this.onPacket(u), i());
          }).catch((l) => {
          });
        };
        i();
        const s = { type: "open" };
        this.query.sid && (s.data = `{"sid":"${this.query.sid}"}`), this._writer.write(s).then(() => this.onOpen());
      });
    });
  }
  write(e) {
    this.writable = !1;
    for (let t = 0; t < e.length; t++) {
      const n = e[t], o = t === e.length - 1;
      this._writer.write(n).then(() => {
        o && Dt(() => {
          this.writable = !0, this.emitReserved("drain");
        }, this.setTimeoutFn);
      });
    }
  }
  doClose() {
    var e;
    (e = this._transport) === null || e === void 0 || e.close();
  }
}
const pi = {
  websocket: hi,
  webtransport: fi,
  polling: ui
}, di = /^(?:(?![^:@\/?#]+:[^:@\/]*@)(http|https|ws|wss):\/\/)?((?:(([^:@\/?#]*)(?::([^:@\/?#]*))?)?@)?((?:[a-f0-9]{0,4}:){2,7}[a-f0-9]{0,4}|[^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/, gi = [
  "source",
  "protocol",
  "authority",
  "userInfo",
  "user",
  "password",
  "host",
  "port",
  "relative",
  "path",
  "directory",
  "file",
  "query",
  "anchor"
];
function rr(r) {
  if (r.length > 8e3)
    throw "URI too long";
  const e = r, t = r.indexOf("["), n = r.indexOf("]");
  t != -1 && n != -1 && (r = r.substring(0, t) + r.substring(t, n).replace(/:/g, ";") + r.substring(n, r.length));
  let o = di.exec(r || ""), i = {}, s = 14;
  for (; s--; )
    i[gi[s]] = o[s] || "";
  return t != -1 && n != -1 && (i.source = e, i.host = i.host.substring(1, i.host.length - 1).replace(/;/g, ":"), i.authority = i.authority.replace("[", "").replace("]", "").replace(/;/g, ":"), i.ipv6uri = !0), i.pathNames = yi(i, i.path), i.queryKey = mi(i, i.query), i;
}
function yi(r, e) {
  const t = /\/{2,9}/g, n = e.replace(t, "/").split("/");
  return (e.slice(0, 1) == "/" || e.length === 0) && n.splice(0, 1), e.slice(-1) == "/" && n.splice(n.length - 1, 1), n;
}
function mi(r, e) {
  const t = {};
  return e.replace(/(?:^|&)([^&=]*)=?([^&]*)/g, function(n, o, i) {
    o && (t[o] = i);
  }), t;
}
const nr = typeof addEventListener == "function" && typeof removeEventListener == "function", kt = [];
nr && addEventListener("offline", () => {
  kt.forEach((r) => r());
}, !1);
class be extends K {
  /**
   * Socket constructor.
   *
   * @param {String|Object} uri - uri or options
   * @param {Object} opts - options
   */
  constructor(e, t) {
    if (super(), this.binaryType = Jo, this.writeBuffer = [], this._prevBufferLen = 0, this._pingInterval = -1, this._pingTimeout = -1, this._maxPayload = -1, this._pingTimeoutTime = 1 / 0, e && typeof e == "object" && (t = e, e = null), e) {
      const n = rr(e);
      t.hostname = n.host, t.secure = n.protocol === "https" || n.protocol === "wss", t.port = n.port, n.query && (t.query = n.query);
    } else t.host && (t.hostname = rr(t.host).host);
    Ht(this, t), this.secure = t.secure != null ? t.secure : typeof location < "u" && location.protocol === "https:", t.hostname && !t.port && (t.port = this.secure ? "443" : "80"), this.hostname = t.hostname || (typeof location < "u" ? location.hostname : "localhost"), this.port = t.port || (typeof location < "u" && location.port ? location.port : this.secure ? "443" : "80"), this.transports = [], this._transportsByName = {}, t.transports.forEach((n) => {
      const o = n.prototype.name;
      this.transports.push(o), this._transportsByName[o] = n;
    }), this.opts = Object.assign({
      path: "/engine.io",
      agent: !1,
      withCredentials: !1,
      upgrade: !0,
      timestampParam: "t",
      rememberUpgrade: !1,
      addTrailingSlash: !0,
      rejectUnauthorized: !0,
      perMessageDeflate: {
        threshold: 1024
      },
      transportOptions: {},
      closeOnBeforeunload: !1
    }, t), this.opts.path = this.opts.path.replace(/\/$/, "") + (this.opts.addTrailingSlash ? "/" : ""), typeof this.opts.query == "string" && (this.opts.query = ri(this.opts.query)), nr && (this.opts.closeOnBeforeunload && (this._beforeunloadEventListener = () => {
      this.transport && (this.transport.removeAllListeners(), this.transport.close());
    }, addEventListener("beforeunload", this._beforeunloadEventListener, !1)), this.hostname !== "localhost" && (this._offlineEventListener = () => {
      this._onClose("transport close", {
        description: "network connection lost"
      });
    }, kt.push(this._offlineEventListener))), this.opts.withCredentials && (this._cookieJar = void 0), this._open();
  }
  /**
   * Creates transport of the given type.
   *
   * @param {String} name - transport name
   * @return {Transport}
   * @private
   */
  createTransport(e) {
    const t = Object.assign({}, this.opts.query);
    t.EIO = In, t.transport = e, this.id && (t.sid = this.id);
    const n = Object.assign({}, this.opts, {
      query: t,
      socket: this,
      hostname: this.hostname,
      secure: this.secure,
      port: this.port
    }, this.opts.transportOptions[e]);
    return new this._transportsByName[e](n);
  }
  /**
   * Initializes transport to use and starts probe.
   *
   * @private
   */
  _open() {
    if (this.transports.length === 0) {
      this.setTimeoutFn(() => {
        this.emitReserved("error", "No transports available");
      }, 0);
      return;
    }
    const e = this.opts.rememberUpgrade && be.priorWebsocketSuccess && this.transports.indexOf("websocket") !== -1 ? "websocket" : this.transports[0];
    this.readyState = "opening";
    const t = this.createTransport(e);
    t.open(), this.setTransport(t);
  }
  /**
   * Sets the current transport. Disables the existing one (if any).
   *
   * @private
   */
  setTransport(e) {
    this.transport && this.transport.removeAllListeners(), this.transport = e, e.on("drain", this._onDrain.bind(this)).on("packet", this._onPacket.bind(this)).on("error", this._onError.bind(this)).on("close", (t) => this._onClose("transport close", t));
  }
  /**
   * Called when connection is deemed open.
   *
   * @private
   */
  onOpen() {
    this.readyState = "open", be.priorWebsocketSuccess = this.transport.name === "websocket", this.emitReserved("open"), this.flush();
  }
  /**
   * Handles a packet.
   *
   * @private
   */
  _onPacket(e) {
    if (this.readyState === "opening" || this.readyState === "open" || this.readyState === "closing")
      switch (this.emitReserved("packet", e), this.emitReserved("heartbeat"), e.type) {
        case "open":
          this.onHandshake(JSON.parse(e.data));
          break;
        case "ping":
          this._sendPacket("pong"), this.emitReserved("ping"), this.emitReserved("pong"), this._resetPingTimeout();
          break;
        case "error":
          const t = new Error("server error");
          t.code = e.data, this._onError(t);
          break;
        case "message":
          this.emitReserved("data", e.data), this.emitReserved("message", e.data);
          break;
      }
  }
  /**
   * Called upon handshake completion.
   *
   * @param {Object} data - handshake obj
   * @private
   */
  onHandshake(e) {
    this.emitReserved("handshake", e), this.id = e.sid, this.transport.query.sid = e.sid, this._pingInterval = e.pingInterval, this._pingTimeout = e.pingTimeout, this._maxPayload = e.maxPayload, this.onOpen(), this.readyState !== "closed" && this._resetPingTimeout();
  }
  /**
   * Sets and resets ping timeout timer based on server pings.
   *
   * @private
   */
  _resetPingTimeout() {
    this.clearTimeoutFn(this._pingTimeoutTimer);
    const e = this._pingInterval + this._pingTimeout;
    this._pingTimeoutTime = Date.now() + e, this._pingTimeoutTimer = this.setTimeoutFn(() => {
      this._onClose("ping timeout");
    }, e), this.opts.autoUnref && this._pingTimeoutTimer.unref();
  }
  /**
   * Called on `drain` event
   *
   * @private
   */
  _onDrain() {
    this.writeBuffer.splice(0, this._prevBufferLen), this._prevBufferLen = 0, this.writeBuffer.length === 0 ? this.emitReserved("drain") : this.flush();
  }
  /**
   * Flush write buffers.
   *
   * @private
   */
  flush() {
    if (this.readyState !== "closed" && this.transport.writable && !this.upgrading && this.writeBuffer.length) {
      const e = this._getWritablePackets();
      this.transport.send(e), this._prevBufferLen = e.length, this.emitReserved("flush");
    }
  }
  /**
   * Ensure the encoded size of the writeBuffer is below the maxPayload value sent by the server (only for HTTP
   * long-polling)
   *
   * @private
   */
  _getWritablePackets() {
    if (!(this._maxPayload && this.transport.name === "polling" && this.writeBuffer.length > 1))
      return this.writeBuffer;
    let t = 1;
    for (let n = 0; n < this.writeBuffer.length; n++) {
      const o = this.writeBuffer[n].data;
      if (o && (t += Zo(o)), n > 0 && t > this._maxPayload)
        return this.writeBuffer.slice(0, n);
      t += 2;
    }
    return this.writeBuffer;
  }
  /**
   * Checks whether the heartbeat timer has expired but the socket has not yet been notified.
   *
   * Note: this method is private for now because it does not really fit the WebSocket API, but if we put it in the
   * `write()` method then the message would not be buffered by the Socket.IO client.
   *
   * @return {boolean}
   * @private
   */
  /* private */
  _hasPingExpired() {
    if (!this._pingTimeoutTime)
      return !0;
    const e = Date.now() > this._pingTimeoutTime;
    return e && (this._pingTimeoutTime = 0, Dt(() => {
      this._onClose("ping timeout");
    }, this.setTimeoutFn)), e;
  }
  /**
   * Sends a message.
   *
   * @param {String} msg - message.
   * @param {Object} options.
   * @param {Function} fn - callback function.
   * @return {Socket} for chaining.
   */
  write(e, t, n) {
    return this._sendPacket("message", e, t, n), this;
  }
  /**
   * Sends a message. Alias of {@link Socket#write}.
   *
   * @param {String} msg - message.
   * @param {Object} options.
   * @param {Function} fn - callback function.
   * @return {Socket} for chaining.
   */
  send(e, t, n) {
    return this._sendPacket("message", e, t, n), this;
  }
  /**
   * Sends a packet.
   *
   * @param {String} type: packet type.
   * @param {String} data.
   * @param {Object} options.
   * @param {Function} fn - callback function.
   * @private
   */
  _sendPacket(e, t, n, o) {
    if (typeof t == "function" && (o = t, t = void 0), typeof n == "function" && (o = n, n = null), this.readyState === "closing" || this.readyState === "closed")
      return;
    n = n || {}, n.compress = n.compress !== !1;
    const i = {
      type: e,
      data: t,
      options: n
    };
    this.emitReserved("packetCreate", i), this.writeBuffer.push(i), o && this.once("flush", o), this.flush();
  }
  /**
   * Closes the connection.
   */
  close() {
    const e = () => {
      this._onClose("forced close"), this.transport.close();
    }, t = () => {
      this.off("upgrade", t), this.off("upgradeError", t), e();
    }, n = () => {
      this.once("upgrade", t), this.once("upgradeError", t);
    };
    return (this.readyState === "opening" || this.readyState === "open") && (this.readyState = "closing", this.writeBuffer.length ? this.once("drain", () => {
      this.upgrading ? n() : e();
    }) : this.upgrading ? n() : e()), this;
  }
  /**
   * Called upon transport error
   *
   * @private
   */
  _onError(e) {
    if (be.priorWebsocketSuccess = !1, this.opts.tryAllTransports && this.transports.length > 1 && this.readyState === "opening")
      return this.transports.shift(), this._open();
    this.emitReserved("error", e), this._onClose("transport error", e);
  }
  /**
   * Called upon transport close.
   *
   * @private
   */
  _onClose(e, t) {
    if (this.readyState === "opening" || this.readyState === "open" || this.readyState === "closing") {
      if (this.clearTimeoutFn(this._pingTimeoutTimer), this.transport.removeAllListeners("close"), this.transport.close(), this.transport.removeAllListeners(), nr && (this._beforeunloadEventListener && removeEventListener("beforeunload", this._beforeunloadEventListener, !1), this._offlineEventListener)) {
        const n = kt.indexOf(this._offlineEventListener);
        n !== -1 && kt.splice(n, 1);
      }
      this.readyState = "closed", this.id = null, this.emitReserved("close", e, t), this.writeBuffer = [], this._prevBufferLen = 0;
    }
  }
}
be.protocol = In;
class Ai extends be {
  constructor() {
    super(...arguments), this._upgrades = [];
  }
  onOpen() {
    if (super.onOpen(), this.readyState === "open" && this.opts.upgrade)
      for (let e = 0; e < this._upgrades.length; e++)
        this._probe(this._upgrades[e]);
  }
  /**
   * Probes a transport.
   *
   * @param {String} name - transport name
   * @private
   */
  _probe(e) {
    let t = this.createTransport(e), n = !1;
    be.priorWebsocketSuccess = !1;
    const o = () => {
      n || (t.send([{ type: "ping", data: "probe" }]), t.once("packet", (S) => {
        if (!n)
          if (S.type === "pong" && S.data === "probe") {
            if (this.upgrading = !0, this.emitReserved("upgrading", t), !t)
              return;
            be.priorWebsocketSuccess = t.name === "websocket", this.transport.pause(() => {
              n || this.readyState !== "closed" && (d(), this.setTransport(t), t.send([{ type: "upgrade" }]), this.emitReserved("upgrade", t), t = null, this.upgrading = !1, this.flush());
            });
          } else {
            const R = new Error("probe error");
            R.transport = t.name, this.emitReserved("upgradeError", R);
          }
      }));
    };
    function i() {
      n || (n = !0, d(), t.close(), t = null);
    }
    const s = (S) => {
      const R = new Error("probe error: " + S);
      R.transport = t.name, i(), this.emitReserved("upgradeError", R);
    };
    function l() {
      s("transport closed");
    }
    function u() {
      s("socket closed");
    }
    function p(S) {
      t && S.name !== t.name && i();
    }
    const d = () => {
      t.removeListener("open", o), t.removeListener("error", s), t.removeListener("close", l), this.off("close", u), this.off("upgrading", p);
    };
    t.once("open", o), t.once("error", s), t.once("close", l), this.once("close", u), this.once("upgrading", p), this._upgrades.indexOf("webtransport") !== -1 && e !== "webtransport" ? this.setTimeoutFn(() => {
      n || t.open();
    }, 200) : t.open();
  }
  onHandshake(e) {
    this._upgrades = this._filterUpgrades(e.upgrades), super.onHandshake(e);
  }
  /**
   * Filters upgrades, returning only those matching client transports.
   *
   * @param {Array} upgrades - server upgrades
   * @private
   */
  _filterUpgrades(e) {
    const t = [];
    for (let n = 0; n < e.length; n++)
      ~this.transports.indexOf(e[n]) && t.push(e[n]);
    return t;
  }
}
let vi = class extends Ai {
  constructor(e, t = {}) {
    const n = typeof e == "object" ? e : t;
    (!n.transports || n.transports && typeof n.transports[0] == "string") && (n.transports = (n.transports || ["polling", "websocket", "webtransport"]).map((o) => pi[o]).filter((o) => !!o)), super(e, n);
  }
};
function bi(r, e = "", t) {
  let n = r;
  t = t || typeof location < "u" && location, r == null && (r = t.protocol + "//" + t.host), typeof r == "string" && (r.charAt(0) === "/" && (r.charAt(1) === "/" ? r = t.protocol + r : r = t.host + r), /^(https?|wss?):\/\//.test(r) || (typeof t < "u" ? r = t.protocol + "//" + r : r = "https://" + r), n = rr(r)), n.port || (/^(http|ws)$/.test(n.protocol) ? n.port = "80" : /^(http|ws)s$/.test(n.protocol) && (n.port = "443")), n.path = n.path || "/";
  const i = n.host.indexOf(":") !== -1 ? "[" + n.host + "]" : n.host;
  return n.id = n.protocol + "://" + i + ":" + n.port + e, n.href = n.protocol + "://" + i + (t && t.port === n.port ? "" : ":" + n.port), n;
}
const wi = typeof ArrayBuffer == "function", _i = (r) => typeof ArrayBuffer.isView == "function" ? ArrayBuffer.isView(r) : r.buffer instanceof ArrayBuffer, On = Object.prototype.toString, Ei = typeof Blob == "function" || typeof Blob < "u" && On.call(Blob) === "[object BlobConstructor]", Si = typeof File == "function" || typeof File < "u" && On.call(File) === "[object FileConstructor]";
function Ir(r) {
  return wi && (r instanceof ArrayBuffer || _i(r)) || Ei && r instanceof Blob || Si && r instanceof File;
}
function Ut(r, e) {
  if (!r || typeof r != "object")
    return !1;
  if (Array.isArray(r)) {
    for (let t = 0, n = r.length; t < n; t++)
      if (Ut(r[t]))
        return !0;
    return !1;
  }
  if (Ir(r))
    return !0;
  if (r.toJSON && typeof r.toJSON == "function" && arguments.length === 1)
    return Ut(r.toJSON(), !0);
  for (const t in r)
    if (Object.prototype.hasOwnProperty.call(r, t) && Ut(r[t]))
      return !0;
  return !1;
}
function Bi(r) {
  const e = [], t = r.data, n = r;
  return n.data = or(t, e), n.attachments = e.length, { packet: n, buffers: e };
}
function or(r, e) {
  if (!r)
    return r;
  if (Ir(r)) {
    const t = { _placeholder: !0, num: e.length };
    return e.push(r), t;
  } else if (Array.isArray(r)) {
    const t = new Array(r.length);
    for (let n = 0; n < r.length; n++)
      t[n] = or(r[n], e);
    return t;
  } else if (typeof r == "object" && !(r instanceof Date)) {
    const t = {};
    for (const n in r)
      Object.prototype.hasOwnProperty.call(r, n) && (t[n] = or(r[n], e));
    return t;
  }
  return r;
}
function Ii(r, e) {
  return r.data = ir(r.data, e), delete r.attachments, r;
}
function ir(r, e) {
  if (!r)
    return r;
  if (r && r._placeholder === !0) {
    if (typeof r.num == "number" && r.num >= 0 && r.num < e.length)
      return e[r.num];
    throw new Error("illegal attachments");
  } else if (Array.isArray(r))
    for (let t = 0; t < r.length; t++)
      r[t] = ir(r[t], e);
  else if (typeof r == "object")
    for (const t in r)
      Object.prototype.hasOwnProperty.call(r, t) && (r[t] = ir(r[t], e));
  return r;
}
const ki = [
  "connect",
  "connect_error",
  "disconnect",
  "disconnecting",
  "newListener",
  "removeListener"
  // used by the Node.js EventEmitter
], Ui = 5;
var Q;
(function(r) {
  r[r.CONNECT = 0] = "CONNECT", r[r.DISCONNECT = 1] = "DISCONNECT", r[r.EVENT = 2] = "EVENT", r[r.ACK = 3] = "ACK", r[r.CONNECT_ERROR = 4] = "CONNECT_ERROR", r[r.BINARY_EVENT = 5] = "BINARY_EVENT", r[r.BINARY_ACK = 6] = "BINARY_ACK";
})(Q || (Q = {}));
class Ci {
  /**
   * Encoder constructor
   *
   * @param {function} replacer - custom replacer to pass down to JSON.parse
   */
  constructor(e) {
    this.replacer = e;
  }
  /**
   * Encode a packet as a single string if non-binary, or as a
   * buffer sequence, depending on packet type.
   *
   * @param {Object} obj - packet object
   */
  encode(e) {
    return (e.type === Q.EVENT || e.type === Q.ACK) && Ut(e) ? this.encodeAsBinary({
      type: e.type === Q.EVENT ? Q.BINARY_EVENT : Q.BINARY_ACK,
      nsp: e.nsp,
      data: e.data,
      id: e.id
    }) : [this.encodeAsString(e)];
  }
  /**
   * Encode packet as string.
   */
  encodeAsString(e) {
    let t = "" + e.type;
    return (e.type === Q.BINARY_EVENT || e.type === Q.BINARY_ACK) && (t += e.attachments + "-"), e.nsp && e.nsp !== "/" && (t += e.nsp + ","), e.id != null && (t += e.id), e.data != null && (t += JSON.stringify(e.data, this.replacer)), t;
  }
  /**
   * Encode packet as 'buffer sequence' by removing blobs, and
   * deconstructing packet into object with placeholders and
   * a list of buffers.
   */
  encodeAsBinary(e) {
    const t = Bi(e), n = this.encodeAsString(t.packet), o = t.buffers;
    return o.unshift(n), o;
  }
}
function jr(r) {
  return Object.prototype.toString.call(r) === "[object Object]";
}
class kr extends K {
  /**
   * Decoder constructor
   *
   * @param {function} reviver - custom reviver to pass down to JSON.stringify
   */
  constructor(e) {
    super(), this.reviver = e;
  }
  /**
   * Decodes an encoded packet string into packet JSON.
   *
   * @param {String} obj - encoded packet
   */
  add(e) {
    let t;
    if (typeof e == "string") {
      if (this.reconstructor)
        throw new Error("got plaintext data when reconstructing a packet");
      t = this.decodeString(e);
      const n = t.type === Q.BINARY_EVENT;
      n || t.type === Q.BINARY_ACK ? (t.type = n ? Q.EVENT : Q.ACK, this.reconstructor = new Ri(t), t.attachments === 0 && super.emitReserved("decoded", t)) : super.emitReserved("decoded", t);
    } else if (Ir(e) || e.base64)
      if (this.reconstructor)
        t = this.reconstructor.takeBinaryData(e), t && (this.reconstructor = null, super.emitReserved("decoded", t));
      else
        throw new Error("got binary data when not reconstructing a packet");
    else
      throw new Error("Unknown type: " + e);
  }
  /**
   * Decode a packet String (JSON data)
   *
   * @param {String} str
   * @return {Object} packet
   */
  decodeString(e) {
    let t = 0;
    const n = {
      type: Number(e.charAt(0))
    };
    if (Q[n.type] === void 0)
      throw new Error("unknown packet type " + n.type);
    if (n.type === Q.BINARY_EVENT || n.type === Q.BINARY_ACK) {
      const i = t + 1;
      for (; e.charAt(++t) !== "-" && t != e.length; )
        ;
      const s = e.substring(i, t);
      if (s != Number(s) || e.charAt(t) !== "-")
        throw new Error("Illegal attachments");
      n.attachments = Number(s);
    }
    if (e.charAt(t + 1) === "/") {
      const i = t + 1;
      for (; ++t && !(e.charAt(t) === "," || t === e.length); )
        ;
      n.nsp = e.substring(i, t);
    } else
      n.nsp = "/";
    const o = e.charAt(t + 1);
    if (o !== "" && Number(o) == o) {
      const i = t + 1;
      for (; ++t; ) {
        const s = e.charAt(t);
        if (s == null || Number(s) != s) {
          --t;
          break;
        }
        if (t === e.length)
          break;
      }
      n.id = Number(e.substring(i, t + 1));
    }
    if (e.charAt(++t)) {
      const i = this.tryParse(e.substr(t));
      if (kr.isPayloadValid(n.type, i))
        n.data = i;
      else
        throw new Error("invalid payload");
    }
    return n;
  }
  tryParse(e) {
    try {
      return JSON.parse(e, this.reviver);
    } catch {
      return !1;
    }
  }
  static isPayloadValid(e, t) {
    switch (e) {
      case Q.CONNECT:
        return jr(t);
      case Q.DISCONNECT:
        return t === void 0;
      case Q.CONNECT_ERROR:
        return typeof t == "string" || jr(t);
      case Q.EVENT:
      case Q.BINARY_EVENT:
        return Array.isArray(t) && (typeof t[0] == "number" || typeof t[0] == "string" && ki.indexOf(t[0]) === -1);
      case Q.ACK:
      case Q.BINARY_ACK:
        return Array.isArray(t);
    }
  }
  /**
   * Deallocates a parser's resources
   */
  destroy() {
    this.reconstructor && (this.reconstructor.finishedReconstruction(), this.reconstructor = null);
  }
}
class Ri {
  constructor(e) {
    this.packet = e, this.buffers = [], this.reconPack = e;
  }
  /**
   * Method to be called when binary data received from connection
   * after a BINARY_EVENT packet.
   *
   * @param {Buffer | ArrayBuffer} binData - the raw binary data received
   * @return {null | Object} returns null if more binary data is expected or
   *   a reconstructed packet object if all buffers have been received.
   */
  takeBinaryData(e) {
    if (this.buffers.push(e), this.buffers.length === this.reconPack.attachments) {
      const t = Ii(this.reconPack, this.buffers);
      return this.finishedReconstruction(), t;
    }
    return null;
  }
  /**
   * Cleans up binary packet reconstruction variables.
   */
  finishedReconstruction() {
    this.reconPack = null, this.buffers = [];
  }
}
const xi = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Decoder: kr,
  Encoder: Ci,
  get PacketType() {
    return Q;
  },
  protocol: Ui
}, Symbol.toStringTag, { value: "Module" }));
function pe(r, e, t) {
  return r.on(e, t), function() {
    r.off(e, t);
  };
}
const Oi = Object.freeze({
  connect: 1,
  connect_error: 1,
  disconnect: 1,
  disconnecting: 1,
  // EventEmitter reserved events: https://nodejs.org/api/events.html#events_event_newlistener
  newListener: 1,
  removeListener: 1
});
class Pn extends K {
  /**
   * `Socket` constructor.
   */
  constructor(e, t, n) {
    super(), this.connected = !1, this.recovered = !1, this.receiveBuffer = [], this.sendBuffer = [], this._queue = [], this._queueSeq = 0, this.ids = 0, this.acks = {}, this.flags = {}, this.io = e, this.nsp = t, n && n.auth && (this.auth = n.auth), this._opts = Object.assign({}, n), this.io._autoConnect && this.open();
  }
  /**
   * Whether the socket is currently disconnected
   *
   * @example
   * const socket = io();
   *
   * socket.on("connect", () => {
   *   console.log(socket.disconnected); // false
   * });
   *
   * socket.on("disconnect", () => {
   *   console.log(socket.disconnected); // true
   * });
   */
  get disconnected() {
    return !this.connected;
  }
  /**
   * Subscribe to open, close and packet events
   *
   * @private
   */
  subEvents() {
    if (this.subs)
      return;
    const e = this.io;
    this.subs = [
      pe(e, "open", this.onopen.bind(this)),
      pe(e, "packet", this.onpacket.bind(this)),
      pe(e, "error", this.onerror.bind(this)),
      pe(e, "close", this.onclose.bind(this))
    ];
  }
  /**
   * Whether the Socket will try to reconnect when its Manager connects or reconnects.
   *
   * @example
   * const socket = io();
   *
   * console.log(socket.active); // true
   *
   * socket.on("disconnect", (reason) => {
   *   if (reason === "io server disconnect") {
   *     // the disconnection was initiated by the server, you need to manually reconnect
   *     console.log(socket.active); // false
   *   }
   *   // else the socket will automatically try to reconnect
   *   console.log(socket.active); // true
   * });
   */
  get active() {
    return !!this.subs;
  }
  /**
   * "Opens" the socket.
   *
   * @example
   * const socket = io({
   *   autoConnect: false
   * });
   *
   * socket.connect();
   */
  connect() {
    return this.connected ? this : (this.subEvents(), this.io._reconnecting || this.io.open(), this.io._readyState === "open" && this.onopen(), this);
  }
  /**
   * Alias for {@link connect()}.
   */
  open() {
    return this.connect();
  }
  /**
   * Sends a `message` event.
   *
   * This method mimics the WebSocket.send() method.
   *
   * @see https://developer.mozilla.org/en-US/docs/Web/API/WebSocket/send
   *
   * @example
   * socket.send("hello");
   *
   * // this is equivalent to
   * socket.emit("message", "hello");
   *
   * @return self
   */
  send(...e) {
    return e.unshift("message"), this.emit.apply(this, e), this;
  }
  /**
   * Override `emit`.
   * If the event is in `events`, it's emitted normally.
   *
   * @example
   * socket.emit("hello", "world");
   *
   * // all serializable datastructures are supported (no need to call JSON.stringify)
   * socket.emit("hello", 1, "2", { 3: ["4"], 5: Uint8Array.from([6]) });
   *
   * // with an acknowledgement from the server
   * socket.emit("hello", "world", (val) => {
   *   // ...
   * });
   *
   * @return self
   */
  emit(e, ...t) {
    var n, o, i;
    if (Oi.hasOwnProperty(e))
      throw new Error('"' + e.toString() + '" is a reserved event name');
    if (t.unshift(e), this._opts.retries && !this.flags.fromQueue && !this.flags.volatile)
      return this._addToQueue(t), this;
    const s = {
      type: Q.EVENT,
      data: t
    };
    if (s.options = {}, s.options.compress = this.flags.compress !== !1, typeof t[t.length - 1] == "function") {
      const d = this.ids++, S = t.pop();
      this._registerAckCallback(d, S), s.id = d;
    }
    const l = (o = (n = this.io.engine) === null || n === void 0 ? void 0 : n.transport) === null || o === void 0 ? void 0 : o.writable, u = this.connected && !(!((i = this.io.engine) === null || i === void 0) && i._hasPingExpired());
    return this.flags.volatile && !l || (u ? (this.notifyOutgoingListeners(s), this.packet(s)) : this.sendBuffer.push(s)), this.flags = {}, this;
  }
  /**
   * @private
   */
  _registerAckCallback(e, t) {
    var n;
    const o = (n = this.flags.timeout) !== null && n !== void 0 ? n : this._opts.ackTimeout;
    if (o === void 0) {
      this.acks[e] = t;
      return;
    }
    const i = this.io.setTimeoutFn(() => {
      delete this.acks[e];
      for (let l = 0; l < this.sendBuffer.length; l++)
        this.sendBuffer[l].id === e && this.sendBuffer.splice(l, 1);
      t.call(this, new Error("operation has timed out"));
    }, o), s = (...l) => {
      this.io.clearTimeoutFn(i), t.apply(this, l);
    };
    s.withError = !0, this.acks[e] = s;
  }
  /**
   * Emits an event and waits for an acknowledgement
   *
   * @example
   * // without timeout
   * const response = await socket.emitWithAck("hello", "world");
   *
   * // with a specific timeout
   * try {
   *   const response = await socket.timeout(1000).emitWithAck("hello", "world");
   * } catch (err) {
   *   // the server did not acknowledge the event in the given delay
   * }
   *
   * @return a Promise that will be fulfilled when the server acknowledges the event
   */
  emitWithAck(e, ...t) {
    return new Promise((n, o) => {
      const i = (s, l) => s ? o(s) : n(l);
      i.withError = !0, t.push(i), this.emit(e, ...t);
    });
  }
  /**
   * Add the packet to the queue.
   * @param args
   * @private
   */
  _addToQueue(e) {
    let t;
    typeof e[e.length - 1] == "function" && (t = e.pop());
    const n = {
      id: this._queueSeq++,
      tryCount: 0,
      pending: !1,
      args: e,
      flags: Object.assign({ fromQueue: !0 }, this.flags)
    };
    e.push((o, ...i) => n !== this._queue[0] ? void 0 : (o !== null ? n.tryCount > this._opts.retries && (this._queue.shift(), t && t(o)) : (this._queue.shift(), t && t(null, ...i)), n.pending = !1, this._drainQueue())), this._queue.push(n), this._drainQueue();
  }
  /**
   * Send the first packet of the queue, and wait for an acknowledgement from the server.
   * @param force - whether to resend a packet that has not been acknowledged yet
   *
   * @private
   */
  _drainQueue(e = !1) {
    if (!this.connected || this._queue.length === 0)
      return;
    const t = this._queue[0];
    t.pending && !e || (t.pending = !0, t.tryCount++, this.flags = t.flags, this.emit.apply(this, t.args));
  }
  /**
   * Sends a packet.
   *
   * @param packet
   * @private
   */
  packet(e) {
    e.nsp = this.nsp, this.io._packet(e);
  }
  /**
   * Called upon engine `open`.
   *
   * @private
   */
  onopen() {
    typeof this.auth == "function" ? this.auth((e) => {
      this._sendConnectPacket(e);
    }) : this._sendConnectPacket(this.auth);
  }
  /**
   * Sends a CONNECT packet to initiate the Socket.IO session.
   *
   * @param data
   * @private
   */
  _sendConnectPacket(e) {
    this.packet({
      type: Q.CONNECT,
      data: this._pid ? Object.assign({ pid: this._pid, offset: this._lastOffset }, e) : e
    });
  }
  /**
   * Called upon engine or manager `error`.
   *
   * @param err
   * @private
   */
  onerror(e) {
    this.connected || this.emitReserved("connect_error", e);
  }
  /**
   * Called upon engine `close`.
   *
   * @param reason
   * @param description
   * @private
   */
  onclose(e, t) {
    this.connected = !1, delete this.id, this.emitReserved("disconnect", e, t), this._clearAcks();
  }
  /**
   * Clears the acknowledgement handlers upon disconnection, since the client will never receive an acknowledgement from
   * the server.
   *
   * @private
   */
  _clearAcks() {
    Object.keys(this.acks).forEach((e) => {
      if (!this.sendBuffer.some((n) => String(n.id) === e)) {
        const n = this.acks[e];
        delete this.acks[e], n.withError && n.call(this, new Error("socket has been disconnected"));
      }
    });
  }
  /**
   * Called with socket packet.
   *
   * @param packet
   * @private
   */
  onpacket(e) {
    if (e.nsp === this.nsp)
      switch (e.type) {
        case Q.CONNECT:
          e.data && e.data.sid ? this.onconnect(e.data.sid, e.data.pid) : this.emitReserved("connect_error", new Error("It seems you are trying to reach a Socket.IO server in v2.x with a v3.x client, but they are not compatible (more information here: https://socket.io/docs/v3/migrating-from-2-x-to-3-0/)"));
          break;
        case Q.EVENT:
        case Q.BINARY_EVENT:
          this.onevent(e);
          break;
        case Q.ACK:
        case Q.BINARY_ACK:
          this.onack(e);
          break;
        case Q.DISCONNECT:
          this.ondisconnect();
          break;
        case Q.CONNECT_ERROR:
          this.destroy();
          const n = new Error(e.data.message);
          n.data = e.data.data, this.emitReserved("connect_error", n);
          break;
      }
  }
  /**
   * Called upon a server event.
   *
   * @param packet
   * @private
   */
  onevent(e) {
    const t = e.data || [];
    e.id != null && t.push(this.ack(e.id)), this.connected ? this.emitEvent(t) : this.receiveBuffer.push(Object.freeze(t));
  }
  emitEvent(e) {
    if (this._anyListeners && this._anyListeners.length) {
      const t = this._anyListeners.slice();
      for (const n of t)
        n.apply(this, e);
    }
    super.emit.apply(this, e), this._pid && e.length && typeof e[e.length - 1] == "string" && (this._lastOffset = e[e.length - 1]);
  }
  /**
   * Produces an ack callback to emit with an event.
   *
   * @private
   */
  ack(e) {
    const t = this;
    let n = !1;
    return function(...o) {
      n || (n = !0, t.packet({
        type: Q.ACK,
        id: e,
        data: o
      }));
    };
  }
  /**
   * Called upon a server acknowledgement.
   *
   * @param packet
   * @private
   */
  onack(e) {
    const t = this.acks[e.id];
    typeof t == "function" && (delete this.acks[e.id], t.withError && e.data.unshift(null), t.apply(this, e.data));
  }
  /**
   * Called upon server connect.
   *
   * @private
   */
  onconnect(e, t) {
    this.id = e, this.recovered = t && this._pid === t, this._pid = t, this.connected = !0, this.emitBuffered(), this.emitReserved("connect"), this._drainQueue(!0);
  }
  /**
   * Emit buffered events (received and emitted).
   *
   * @private
   */
  emitBuffered() {
    this.receiveBuffer.forEach((e) => this.emitEvent(e)), this.receiveBuffer = [], this.sendBuffer.forEach((e) => {
      this.notifyOutgoingListeners(e), this.packet(e);
    }), this.sendBuffer = [];
  }
  /**
   * Called upon server disconnect.
   *
   * @private
   */
  ondisconnect() {
    this.destroy(), this.onclose("io server disconnect");
  }
  /**
   * Called upon forced client/server side disconnections,
   * this method ensures the manager stops tracking us and
   * that reconnections don't get triggered for this.
   *
   * @private
   */
  destroy() {
    this.subs && (this.subs.forEach((e) => e()), this.subs = void 0), this.io._destroy(this);
  }
  /**
   * Disconnects the socket manually. In that case, the socket will not try to reconnect.
   *
   * If this is the last active Socket instance of the {@link Manager}, the low-level connection will be closed.
   *
   * @example
   * const socket = io();
   *
   * socket.on("disconnect", (reason) => {
   *   // console.log(reason); prints "io client disconnect"
   * });
   *
   * socket.disconnect();
   *
   * @return self
   */
  disconnect() {
    return this.connected && this.packet({ type: Q.DISCONNECT }), this.destroy(), this.connected && this.onclose("io client disconnect"), this;
  }
  /**
   * Alias for {@link disconnect()}.
   *
   * @return self
   */
  close() {
    return this.disconnect();
  }
  /**
   * Sets the compress flag.
   *
   * @example
   * socket.compress(false).emit("hello");
   *
   * @param compress - if `true`, compresses the sending data
   * @return self
   */
  compress(e) {
    return this.flags.compress = e, this;
  }
  /**
   * Sets a modifier for a subsequent event emission that the event message will be dropped when this socket is not
   * ready to send messages.
   *
   * @example
   * socket.volatile.emit("hello"); // the server may or may not receive it
   *
   * @returns self
   */
  get volatile() {
    return this.flags.volatile = !0, this;
  }
  /**
   * Sets a modifier for a subsequent event emission that the callback will be called with an error when the
   * given number of milliseconds have elapsed without an acknowledgement from the server:
   *
   * @example
   * socket.timeout(5000).emit("my-event", (err) => {
   *   if (err) {
   *     // the server did not acknowledge the event in the given delay
   *   }
   * });
   *
   * @returns self
   */
  timeout(e) {
    return this.flags.timeout = e, this;
  }
  /**
   * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
   * callback.
   *
   * @example
   * socket.onAny((event, ...args) => {
   *   console.log(`got ${event}`);
   * });
   *
   * @param listener
   */
  onAny(e) {
    return this._anyListeners = this._anyListeners || [], this._anyListeners.push(e), this;
  }
  /**
   * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
   * callback. The listener is added to the beginning of the listeners array.
   *
   * @example
   * socket.prependAny((event, ...args) => {
   *   console.log(`got event ${event}`);
   * });
   *
   * @param listener
   */
  prependAny(e) {
    return this._anyListeners = this._anyListeners || [], this._anyListeners.unshift(e), this;
  }
  /**
   * Removes the listener that will be fired when any event is emitted.
   *
   * @example
   * const catchAllListener = (event, ...args) => {
   *   console.log(`got event ${event}`);
   * }
   *
   * socket.onAny(catchAllListener);
   *
   * // remove a specific listener
   * socket.offAny(catchAllListener);
   *
   * // or remove all listeners
   * socket.offAny();
   *
   * @param listener
   */
  offAny(e) {
    if (!this._anyListeners)
      return this;
    if (e) {
      const t = this._anyListeners;
      for (let n = 0; n < t.length; n++)
        if (e === t[n])
          return t.splice(n, 1), this;
    } else
      this._anyListeners = [];
    return this;
  }
  /**
   * Returns an array of listeners that are listening for any event that is specified. This array can be manipulated,
   * e.g. to remove listeners.
   */
  listenersAny() {
    return this._anyListeners || [];
  }
  /**
   * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
   * callback.
   *
   * Note: acknowledgements sent to the server are not included.
   *
   * @example
   * socket.onAnyOutgoing((event, ...args) => {
   *   console.log(`sent event ${event}`);
   * });
   *
   * @param listener
   */
  onAnyOutgoing(e) {
    return this._anyOutgoingListeners = this._anyOutgoingListeners || [], this._anyOutgoingListeners.push(e), this;
  }
  /**
   * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
   * callback. The listener is added to the beginning of the listeners array.
   *
   * Note: acknowledgements sent to the server are not included.
   *
   * @example
   * socket.prependAnyOutgoing((event, ...args) => {
   *   console.log(`sent event ${event}`);
   * });
   *
   * @param listener
   */
  prependAnyOutgoing(e) {
    return this._anyOutgoingListeners = this._anyOutgoingListeners || [], this._anyOutgoingListeners.unshift(e), this;
  }
  /**
   * Removes the listener that will be fired when any event is emitted.
   *
   * @example
   * const catchAllListener = (event, ...args) => {
   *   console.log(`sent event ${event}`);
   * }
   *
   * socket.onAnyOutgoing(catchAllListener);
   *
   * // remove a specific listener
   * socket.offAnyOutgoing(catchAllListener);
   *
   * // or remove all listeners
   * socket.offAnyOutgoing();
   *
   * @param [listener] - the catch-all listener (optional)
   */
  offAnyOutgoing(e) {
    if (!this._anyOutgoingListeners)
      return this;
    if (e) {
      const t = this._anyOutgoingListeners;
      for (let n = 0; n < t.length; n++)
        if (e === t[n])
          return t.splice(n, 1), this;
    } else
      this._anyOutgoingListeners = [];
    return this;
  }
  /**
   * Returns an array of listeners that are listening for any event that is specified. This array can be manipulated,
   * e.g. to remove listeners.
   */
  listenersAnyOutgoing() {
    return this._anyOutgoingListeners || [];
  }
  /**
   * Notify the listeners for each packet sent
   *
   * @param packet
   *
   * @private
   */
  notifyOutgoingListeners(e) {
    if (this._anyOutgoingListeners && this._anyOutgoingListeners.length) {
      const t = this._anyOutgoingListeners.slice();
      for (const n of t)
        n.apply(this, e.data);
    }
  }
}
function qe(r) {
  r = r || {}, this.ms = r.min || 100, this.max = r.max || 1e4, this.factor = r.factor || 2, this.jitter = r.jitter > 0 && r.jitter <= 1 ? r.jitter : 0, this.attempts = 0;
}
qe.prototype.duration = function() {
  var r = this.ms * Math.pow(this.factor, this.attempts++);
  if (this.jitter) {
    var e = Math.random(), t = Math.floor(e * this.jitter * r);
    r = (Math.floor(e * 10) & 1) == 0 ? r - t : r + t;
  }
  return Math.min(r, this.max) | 0;
};
qe.prototype.reset = function() {
  this.attempts = 0;
};
qe.prototype.setMin = function(r) {
  this.ms = r;
};
qe.prototype.setMax = function(r) {
  this.max = r;
};
qe.prototype.setJitter = function(r) {
  this.jitter = r;
};
class sr extends K {
  constructor(e, t) {
    var n;
    super(), this.nsps = {}, this.subs = [], e && typeof e == "object" && (t = e, e = void 0), t = t || {}, t.path = t.path || "/socket.io", this.opts = t, Ht(this, t), this.reconnection(t.reconnection !== !1), this.reconnectionAttempts(t.reconnectionAttempts || 1 / 0), this.reconnectionDelay(t.reconnectionDelay || 1e3), this.reconnectionDelayMax(t.reconnectionDelayMax || 5e3), this.randomizationFactor((n = t.randomizationFactor) !== null && n !== void 0 ? n : 0.5), this.backoff = new qe({
      min: this.reconnectionDelay(),
      max: this.reconnectionDelayMax(),
      jitter: this.randomizationFactor()
    }), this.timeout(t.timeout == null ? 2e4 : t.timeout), this._readyState = "closed", this.uri = e;
    const o = t.parser || xi;
    this.encoder = new o.Encoder(), this.decoder = new o.Decoder(), this._autoConnect = t.autoConnect !== !1, this._autoConnect && this.open();
  }
  reconnection(e) {
    return arguments.length ? (this._reconnection = !!e, e || (this.skipReconnect = !0), this) : this._reconnection;
  }
  reconnectionAttempts(e) {
    return e === void 0 ? this._reconnectionAttempts : (this._reconnectionAttempts = e, this);
  }
  reconnectionDelay(e) {
    var t;
    return e === void 0 ? this._reconnectionDelay : (this._reconnectionDelay = e, (t = this.backoff) === null || t === void 0 || t.setMin(e), this);
  }
  randomizationFactor(e) {
    var t;
    return e === void 0 ? this._randomizationFactor : (this._randomizationFactor = e, (t = this.backoff) === null || t === void 0 || t.setJitter(e), this);
  }
  reconnectionDelayMax(e) {
    var t;
    return e === void 0 ? this._reconnectionDelayMax : (this._reconnectionDelayMax = e, (t = this.backoff) === null || t === void 0 || t.setMax(e), this);
  }
  timeout(e) {
    return arguments.length ? (this._timeout = e, this) : this._timeout;
  }
  /**
   * Starts trying to reconnect if reconnection is enabled and we have not
   * started reconnecting yet
   *
   * @private
   */
  maybeReconnectOnOpen() {
    !this._reconnecting && this._reconnection && this.backoff.attempts === 0 && this.reconnect();
  }
  /**
   * Sets the current transport `socket`.
   *
   * @param {Function} fn - optional, callback
   * @return self
   * @public
   */
  open(e) {
    if (~this._readyState.indexOf("open"))
      return this;
    this.engine = new vi(this.uri, this.opts);
    const t = this.engine, n = this;
    this._readyState = "opening", this.skipReconnect = !1;
    const o = pe(t, "open", function() {
      n.onopen(), e && e();
    }), i = (l) => {
      this.cleanup(), this._readyState = "closed", this.emitReserved("error", l), e ? e(l) : this.maybeReconnectOnOpen();
    }, s = pe(t, "error", i);
    if (this._timeout !== !1) {
      const l = this._timeout, u = this.setTimeoutFn(() => {
        o(), i(new Error("timeout")), t.close();
      }, l);
      this.opts.autoUnref && u.unref(), this.subs.push(() => {
        this.clearTimeoutFn(u);
      });
    }
    return this.subs.push(o), this.subs.push(s), this;
  }
  /**
   * Alias for open()
   *
   * @return self
   * @public
   */
  connect(e) {
    return this.open(e);
  }
  /**
   * Called upon transport open.
   *
   * @private
   */
  onopen() {
    this.cleanup(), this._readyState = "open", this.emitReserved("open");
    const e = this.engine;
    this.subs.push(
      pe(e, "ping", this.onping.bind(this)),
      pe(e, "data", this.ondata.bind(this)),
      pe(e, "error", this.onerror.bind(this)),
      pe(e, "close", this.onclose.bind(this)),
      // @ts-ignore
      pe(this.decoder, "decoded", this.ondecoded.bind(this))
    );
  }
  /**
   * Called upon a ping.
   *
   * @private
   */
  onping() {
    this.emitReserved("ping");
  }
  /**
   * Called with data.
   *
   * @private
   */
  ondata(e) {
    try {
      this.decoder.add(e);
    } catch (t) {
      this.onclose("parse error", t);
    }
  }
  /**
   * Called when parser fully decodes a packet.
   *
   * @private
   */
  ondecoded(e) {
    Dt(() => {
      this.emitReserved("packet", e);
    }, this.setTimeoutFn);
  }
  /**
   * Called upon socket error.
   *
   * @private
   */
  onerror(e) {
    this.emitReserved("error", e);
  }
  /**
   * Creates a new socket for the given `nsp`.
   *
   * @return {Socket}
   * @public
   */
  socket(e, t) {
    let n = this.nsps[e];
    return n ? this._autoConnect && !n.active && n.connect() : (n = new Pn(this, e, t), this.nsps[e] = n), n;
  }
  /**
   * Called upon a socket close.
   *
   * @param socket
   * @private
   */
  _destroy(e) {
    const t = Object.keys(this.nsps);
    for (const n of t)
      if (this.nsps[n].active)
        return;
    this._close();
  }
  /**
   * Writes a packet.
   *
   * @param packet
   * @private
   */
  _packet(e) {
    const t = this.encoder.encode(e);
    for (let n = 0; n < t.length; n++)
      this.engine.write(t[n], e.options);
  }
  /**
   * Clean up transport subscriptions and packet buffer.
   *
   * @private
   */
  cleanup() {
    this.subs.forEach((e) => e()), this.subs.length = 0, this.decoder.destroy();
  }
  /**
   * Close the current socket.
   *
   * @private
   */
  _close() {
    this.skipReconnect = !0, this._reconnecting = !1, this.onclose("forced close");
  }
  /**
   * Alias for close()
   *
   * @private
   */
  disconnect() {
    return this._close();
  }
  /**
   * Called when:
   *
   * - the low-level engine is closed
   * - the parser encountered a badly formatted packet
   * - all sockets are disconnected
   *
   * @private
   */
  onclose(e, t) {
    var n;
    this.cleanup(), (n = this.engine) === null || n === void 0 || n.close(), this.backoff.reset(), this._readyState = "closed", this.emitReserved("close", e, t), this._reconnection && !this.skipReconnect && this.reconnect();
  }
  /**
   * Attempt a reconnection.
   *
   * @private
   */
  reconnect() {
    if (this._reconnecting || this.skipReconnect)
      return this;
    const e = this;
    if (this.backoff.attempts >= this._reconnectionAttempts)
      this.backoff.reset(), this.emitReserved("reconnect_failed"), this._reconnecting = !1;
    else {
      const t = this.backoff.duration();
      this._reconnecting = !0;
      const n = this.setTimeoutFn(() => {
        e.skipReconnect || (this.emitReserved("reconnect_attempt", e.backoff.attempts), !e.skipReconnect && e.open((o) => {
          o ? (e._reconnecting = !1, e.reconnect(), this.emitReserved("reconnect_error", o)) : e.onreconnect();
        }));
      }, t);
      this.opts.autoUnref && n.unref(), this.subs.push(() => {
        this.clearTimeoutFn(n);
      });
    }
  }
  /**
   * Called upon successful reconnect.
   *
   * @private
   */
  onreconnect() {
    const e = this.backoff.attempts;
    this._reconnecting = !1, this.backoff.reset(), this.emitReserved("reconnect", e);
  }
}
const He = {};
function Ct(r, e) {
  typeof r == "object" && (e = r, r = void 0), e = e || {};
  const t = bi(r, e.path || "/socket.io"), n = t.source, o = t.id, i = t.path, s = He[o] && i in He[o].nsps, l = e.forceNew || e["force new connection"] || e.multiplex === !1 || s;
  let u;
  return l ? u = new sr(n, e) : (He[o] || (He[o] = new sr(n, e)), u = He[o]), t.query && !e.query && (e.query = t.queryKey), u.socket(t.path, e);
}
Object.assign(Ct, {
  Manager: sr,
  Socket: Pn,
  io: Ct,
  connect: Ct
});
const Pi = "/ws", Ti = "/v7/socket.io.v2", zr = "files-messages", Fi = "FileUploadedSuccess", Li = "FileMetadataExtracted", Ni = "UIThumbnailGeneratedEvent", Qi = 6e4 * 2;
var Y, me, Z, nt, ot, Ae, Tn, ar, Fn;
class qi {
  constructor({ getAccessToken: e, logger: t }) {
    L(this, Ae);
    L(this, Y);
    L(this, me, {});
    L(this, Z);
    L(this, nt);
    L(this, ot, async () => {
      var t;
      const e = await ((t = a(this, nt)) == null ? void 0 : t.call(this));
      e && (a(this, Z).auth = { token: e });
    });
    q(this, nt, e || void 0), q(this, Y, t);
    const n = Ce();
    q(this, Z, Ct(Pi, {
      timeout: 5e3,
      path: Ti,
      extraHeaders: { "x-socket-io-affinity-id": n },
      query: { aid: n },
      reconnectionDelay: 2e3,
      reconnectionDelayMax: 1e4,
      transports: ["polling", "websocket"]
    })), k(this, Ae, Tn).call(this);
  }
  async listenFileEvents(e) {
    const t = setTimeout(() => {
      throw new Error(
        `WebSocket - Timeout while waiting for socket connection for fileId: ${e}`
      );
    }, Qi);
    await k(this, Ae, ar).call(this, e), clearTimeout(t);
  }
  async listenForFileUploadSuccess(e) {
    return await this.listenFileEvents(e), new Promise((t) => {
      a(this, Z).on(Fi, (n) => {
        const o = JSON.parse(n);
        (o == null ? void 0 : o.aggregate_root_id) === e && (a(this, Y).debug("WebSocket - File upload success", { fileId: e }), t());
      });
    });
  }
  async listenForMetadata(e) {
    return await this.listenFileEvents(e), new Promise((t) => {
      a(this, Z).on(Li, (n) => {
        const o = JSON.parse(n);
        if ((o == null ? void 0 : o.aggregate_root_id) === e) {
          if (!(o != null && o.metadata)) {
            a(this, Y).error("WebSocket - File metadata is missing", { fileId: e, data: o });
            return;
          }
          a(this, Y).debug("WebSocket - File metadata extracted", { fileId: e, data: o }), t(o.metadata);
        }
      });
    });
  }
  async listenForThumbnail(e) {
    return await this.listenFileEvents(e), new Promise((t) => {
      a(this, Z).on(Ni, (n) => {
        const o = JSON.parse(n);
        if ((o == null ? void 0 : o.aggregate_root_id) === e) {
          if (!(o != null && o.thumbnail_file_uri)) {
            a(this, Y).error("WebSocket - File thumbnail url is missing", { fileId: e });
            return;
          }
          a(this, Y).debug("WebSocket - File thumbnail extracted", { fileId: e }), t(o.thumbnail_file_uri);
        }
      });
    });
  }
  closeFileEvents(e) {
    const t = `${zr}_${e}`;
    a(this, me)[e] && (delete a(this, me)[e], a(this, Z).emit("leave", t), a(this, Y).debug(`Left room ${t}`));
  }
}
Y = new WeakMap(), me = new WeakMap(), Z = new WeakMap(), nt = new WeakMap(), ot = new WeakMap(), Ae = new WeakSet(), Tn = async function() {
  await a(this, ot).call(this);
  let e = 0;
  return new Promise((t, n) => {
    a(this, Z).on("connect", () => {
      a(this, Y).debug("WebSocket - Connected to socket"), k(this, Ae, Fn).call(this), e = 0, t();
    }), a(this, Z).on("disconnect", async (o, i) => {
      if (a(this, Z).active) {
        a(this, Y).debug("WebSocket - Disconnected, waiting for reconnection", {
          reason: o,
          description: i
        });
        return;
      }
      a(this, Y).error("WebSocket - Disconnected from socket, reconnecting", {
        reason: o,
        description: i
      }), await a(this, ot).call(this), a(this, Z).connect();
    }), a(this, Z).on("connect_error", (o) => {
      if (a(this, Z).active) {
        a(this, Y).debug("WebSocket - Connect error, waiting for reconnection", {
          ...o
        }), e++, e === 10 && (a(this, Y).error("WebSocket - Too many connection errors", {
          rooms: { ...a(this, me) },
          error: o.message
        }), n(new Error("WebSocket - Connect error", { cause: o })));
        return;
      }
      a(this, Y).error("WebSocket - Server rejected connection", {
        ...o
      }), n(new Error("WebSocket - Connect error", { cause: o }));
    }), a(this, Z).connect();
  });
}, ar = async function(e, t) {
  if (a(this, me)[e] && !(t != null && t.force))
    return Promise.resolve();
  a(this, me)[e] = !0;
  const n = `${zr}_${e}`;
  a(this, Y).debug(`WebSocket - Joining room ${n}`), await new Promise((o) => {
    a(this, Z).once(`joined ${n}`, o), a(this, Z).emit("join", n);
  }), a(this, Y).debug(`WebSocket - Joined room ${n}`);
}, Fn = function() {
  Object.keys(a(this, me)).forEach((e) => {
    k(this, Ae, ar).call(this, e, { force: !0 });
  });
};
function Di(r) {
  return new qi(r);
}
/*!
 * hash-wasm (https://www.npmjs.com/package/hash-wasm)
 * (c) Dani Biro
 * @license MIT
 */
function Rt(r, e, t, n) {
  function o(i) {
    return i instanceof t ? i : new t(function(s) {
      s(i);
    });
  }
  return new (t || (t = Promise))(function(i, s) {
    function l(d) {
      try {
        p(n.next(d));
      } catch (S) {
        s(S);
      }
    }
    function u(d) {
      try {
        p(n.throw(d));
      } catch (S) {
        s(S);
      }
    }
    function p(d) {
      d.done ? i(d.value) : o(d.value).then(l, u);
    }
    p((n = n.apply(r, [])).next());
  });
}
class W {
  constructor() {
    this.mutex = Promise.resolve();
  }
  lock() {
    let e = () => {
    };
    return this.mutex = this.mutex.then(() => new Promise(e)), new Promise((t) => {
      e = t;
    });
  }
  dispatch(e) {
    return Rt(this, void 0, void 0, function* () {
      const t = yield this.lock();
      try {
        return yield Promise.resolve(e());
      } finally {
        t();
      }
    });
  }
}
var Gt;
function Hi() {
  return typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global;
}
const cr = Hi(), Wt = (Gt = cr.Buffer) !== null && Gt !== void 0 ? Gt : null, ji = cr.TextEncoder ? new cr.TextEncoder() : null;
function Ln(r, e) {
  return (r & 15) + (r >> 6 | r >> 3 & 8) << 4 | (e & 15) + (e >> 6 | e >> 3 & 8);
}
function zi(r, e) {
  const t = e.length >> 1;
  for (let n = 0; n < t; n++) {
    const o = n << 1;
    r[n] = Ln(e.charCodeAt(o), e.charCodeAt(o + 1));
  }
}
function Mi(r, e) {
  if (r.length !== e.length * 2)
    return !1;
  for (let t = 0; t < e.length; t++) {
    const n = t << 1;
    if (e[t] !== Ln(r.charCodeAt(n), r.charCodeAt(n + 1)))
      return !1;
  }
  return !0;
}
const Mr = 87, $r = 48;
function Vr(r, e, t) {
  let n = 0;
  for (let o = 0; o < t; o++) {
    let i = e[o] >>> 4;
    r[n++] = i > 9 ? i + Mr : i + $r, i = e[o] & 15, r[n++] = i > 9 ? i + Mr : i + $r;
  }
  return String.fromCharCode.apply(null, r);
}
const Gr = Wt !== null ? (r) => {
  if (typeof r == "string") {
    const e = Wt.from(r, "utf8");
    return new Uint8Array(e.buffer, e.byteOffset, e.length);
  }
  if (Wt.isBuffer(r))
    return new Uint8Array(r.buffer, r.byteOffset, r.length);
  if (ArrayBuffer.isView(r))
    return new Uint8Array(r.buffer, r.byteOffset, r.byteLength);
  throw new Error("Invalid data type!");
} : (r) => {
  if (typeof r == "string")
    return ji.encode(r);
  if (ArrayBuffer.isView(r))
    return new Uint8Array(r.buffer, r.byteOffset, r.byteLength);
  throw new Error("Invalid data type!");
}, Wr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", $e = new Uint8Array(256);
for (let r = 0; r < Wr.length; r++)
  $e[Wr.charCodeAt(r)] = r;
function $i(r) {
  let e = Math.floor(r.length * 0.75);
  const t = r.length;
  return r[t - 1] === "=" && (e -= 1, r[t - 2] === "=" && (e -= 1)), e;
}
function Vi(r) {
  const e = $i(r), t = r.length, n = new Uint8Array(e);
  let o = 0;
  for (let i = 0; i < t; i += 4) {
    const s = $e[r.charCodeAt(i)], l = $e[r.charCodeAt(i + 1)], u = $e[r.charCodeAt(i + 2)], p = $e[r.charCodeAt(i + 3)];
    n[o] = s << 2 | l >> 4, o += 1, n[o] = (l & 15) << 4 | u >> 2, o += 1, n[o] = (u & 3) << 6 | p & 63, o += 1;
  }
  return n;
}
const At = 16 * 1024, je = 4, Gi = new W(), Jt = /* @__PURE__ */ new Map();
function Wi(r, e) {
  return Rt(this, void 0, void 0, function* () {
    let t = null, n = null, o = !1;
    if (typeof WebAssembly > "u")
      throw new Error("WebAssembly is not supported in this environment!");
    const i = (E, _ = 0) => {
      n.set(E, _);
    }, s = () => n, l = () => t.exports, u = (E) => {
      t.exports.Hash_SetMemorySize(E);
      const _ = t.exports.Hash_GetBuffer(), P = t.exports.memory.buffer;
      n = new Uint8Array(P, _, E);
    }, p = () => new DataView(t.exports.memory.buffer).getUint32(t.exports.STATE_SIZE, !0), d = Gi.dispatch(() => Rt(this, void 0, void 0, function* () {
      if (!Jt.has(r.name)) {
        const _ = Vi(r.data), P = WebAssembly.compile(_);
        Jt.set(r.name, P);
      }
      const E = yield Jt.get(r.name);
      t = yield WebAssembly.instantiate(E, {
        // env: {
        //   emscripten_memcpy_big: (dest, src, num) => {
        //     const memoryBuffer = wasmInstance.exports.memory.buffer;
        //     const memView = new Uint8Array(memoryBuffer, 0);
        //     memView.set(memView.subarray(src, src + num), dest);
        //   },
        //   print_memory: (offset, len) => {
        //     const memoryBuffer = wasmInstance.exports.memory.buffer;
        //     const memView = new Uint8Array(memoryBuffer, 0);
        //     console.log('print_int32', memView.subarray(offset, offset + len));
        //   },
        // },
      });
    })), S = () => Rt(this, void 0, void 0, function* () {
      t || (yield d);
      const E = t.exports.Hash_GetBuffer(), _ = t.exports.memory.buffer;
      n = new Uint8Array(_, E, At);
    }), R = (E = null) => {
      o = !0, t.exports.Hash_Init(E);
    }, z = (E) => {
      let _ = 0;
      for (; _ < E.length; ) {
        const P = E.subarray(_, _ + At);
        _ += P.length, n.set(P), t.exports.Hash_Update(P.length);
      }
    }, H = (E) => {
      if (!o)
        throw new Error("update() called before init()");
      const _ = Gr(E);
      z(_);
    }, B = new Uint8Array(e * 2), x = (E, _ = null) => {
      if (!o)
        throw new Error("digest() called before init()");
      return o = !1, t.exports.Hash_Final(_), E === "binary" ? n.slice(0, e) : Vr(B, n, e);
    }, U = () => {
      if (!o)
        throw new Error("save() can only be called after init() and before digest()");
      const E = t.exports.Hash_GetState(), _ = p(), P = t.exports.memory.buffer, O = new Uint8Array(P, E, _), V = new Uint8Array(je + _);
      return zi(V, r.hash), V.set(O, je), V;
    }, m = (E) => {
      if (!(E instanceof Uint8Array))
        throw new Error("load() expects an Uint8Array generated by save()");
      const _ = t.exports.Hash_GetState(), P = p(), O = je + P, V = t.exports.memory.buffer;
      if (E.length !== O)
        throw new Error(`Bad state length (expected ${O} bytes, got ${E.length})`);
      if (!Mi(r.hash, E.subarray(0, je)))
        throw new Error("This state was written by an incompatible hash implementation");
      const N = E.subarray(je);
      new Uint8Array(V, _, P).set(N), o = !0;
    }, A = (E) => typeof E == "string" ? E.length < At / 4 : E.byteLength < At;
    let g = A;
    switch (r.name) {
      case "argon2":
      case "scrypt":
        g = () => !0;
        break;
      case "blake2b":
      case "blake2s":
        g = (E, _) => _ <= 512 && A(E);
        break;
      case "blake3":
        g = (E, _) => _ === 0 && A(E);
        break;
      case "xxhash64":
      // cannot simplify
      case "xxhash3":
      case "xxhash128":
      case "crc64":
        g = () => !1;
        break;
    }
    const y = (E, _ = null, P = null) => {
      if (!g(E, _))
        return R(_), H(E), x("hex", P);
      const O = Gr(E);
      return n.set(O), t.exports.Hash_Calculate(O.length, _, P), Vr(B, n, e);
    };
    return yield S(), {
      getMemory: s,
      writeMemory: i,
      getExports: l,
      setMemorySize: u,
      init: R,
      update: H,
      digest: x,
      save: U,
      load: m,
      calculate: y,
      hashLength: e
    };
  });
}
new W();
new W();
new W();
new W();
new W();
new W();
new W();
var Ji = "md5", Xi = "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", Ki = "e6508e4b", Yi = {
  name: Ji,
  data: Xi,
  hash: Ki
};
new W();
function Zi() {
  return Wi(Yi, 16).then((r) => {
    r.init();
    const e = {
      init: () => (r.init(), e),
      update: (t) => (r.update(t), e),
      // biome-ignore lint/suspicious/noExplicitAny: Conflict with IHasher type
      digest: (t) => r.digest(t),
      save: () => r.save(),
      load: (t) => (r.load(t), e),
      blockSize: 64,
      digestSize: 16
    };
    return e;
  });
}
new W();
new W();
new W();
new W();
new W();
new W();
new W();
new W();
new W();
new W();
new W();
new W();
new W();
new W();
async function es(r, e) {
  let n = 0;
  const o = await Zi();
  return o.init(), new Promise((i, s) => {
    function l() {
      if (e.aborted)
        return;
      if (n >= r.size) {
        i(o.digest("hex"));
        return;
      }
      const u = r.slice(n, n + 8388608), p = new FileReader();
      p.onload = (d) => {
        var S;
        (S = d.target) != null && S.result ? (o.update(new Uint8Array(d.target.result)), n += u.size, requestAnimationFrame(l)) : s(
          Object.assign(new Error("Hash calculation failed"), {
            code: "HASH_ERROR"
          })
        );
      }, p.onerror = () => {
        s(
          Object.assign(new Error("Hash calculation failed"), {
            code: "HASH_ERROR"
          })
        );
      }, p.readAsArrayBuffer(u);
    }
    l();
  });
}
function ts(r) {
  const e = "asset::upload", t = [
    r.intent,
    r.portalId,
    r.userId,
    r.file.name,
    r.file.type,
    r.file.size,
    r.file.lastModified
  ].join("-"), n = ns(t);
  return `${e}::${n}`;
}
function rs(r) {
  return localStorage.getItem(r) || void 0;
}
function Xt(r, e) {
  e ? localStorage.setItem(r, e) : localStorage.removeItem(r);
}
function ns(r) {
  const e = new TextEncoder().encode(r), t = Array.from(e, (n) => String.fromCodePoint(n)).join("");
  return btoa(t);
}
async function vt(r, e) {
  return await new Promise((t) => {
    setTimeout(t, r);
  }), e;
}
function lc(r) {
  return () => ({
    listenFileEvents: () => vt(10),
    listenForFileUploadSuccess: () => vt(100),
    listenForMetadata: () => vt(150, r),
    listenForThumbnail: () => vt(150, "some-url"),
    closeFileEvents: () => !0
  });
}
var J, we, Pe, _e, it, st, at, ct, ut, lt, Te, X, ht, C, Nn, Qn, ke, oe, qn, Dn, Hn, jn, zn, Mn, $n, Vn, Gn, xt, Wn, ur, Jn, lr;
class hc extends To {
  constructor(t) {
    var n, o, i, s, l;
    super();
    L(this, C);
    L(this, J, /* @__PURE__ */ new Map());
    L(this, we);
    L(this, Pe);
    L(this, _e);
    L(this, it);
    L(this, st);
    L(this, at);
    L(this, ct);
    L(this, ut);
    L(this, lt);
    L(this, Te);
    L(this, X);
    L(this, ht);
    q(this, ut, t.name || ((n = t.options) == null ? void 0 : n.intent) || "Unknown uploader"), q(this, we, t.inputElementId), q(this, _e, ((o = t.options) == null ? void 0 : o.intent) || ""), q(this, at, t.portalId), q(this, ct, t.userId), q(this, it, ((i = t.options) == null ? void 0 : i.isPublic) || !1), q(this, Pe, t.uploaderAdapterProvider), k(this, C, Nn).call(this), q(this, st, ((s = t.options) == null ? void 0 : s.withMetadata) || !1), q(this, Te, t.getAuthorizationToken), q(this, lt, ((l = t.options) == null ? void 0 : l.intent) || ""), q(this, X, qo(a(this, ut))), a(this, X).info("Initialized", { props: t }), document.dispatchEvent(
      new CustomEvent("AssetUploadManagerCreated", { detail: { uploader: this, props: t } })
    ), q(this, ht, (t.webSocketProvider || Di)({
      getAccessToken: a(this, Te),
      logger: a(this, X)
    }));
  }
  /**
   * Initializes an upload session for the given file.
   *
   * @param file The file to be uploaded.
   */
  createUpload(t) {
    const n = Ce();
    a(this, X).info("Creating upload", { uploadId: n, fileName: t.name });
    const o = ts({
      intent: a(this, _e),
      portalId: a(this, at),
      userId: a(this, ct),
      file: t
    }), i = rs(o);
    try {
      const s = {
        onAssetAssigned: (u, p) => {
          k(this, C, qn).call(this, n, u, p);
        },
        onError: (u, p) => {
          k(this, C, ke).call(this, u, n, p);
        },
        onProgress: (u) => {
          k(this, C, Hn).call(this, n, u);
        },
        onSuccess: (u, p) => {
          k(this, C, Mn).call(this, { uploadId: n, assetId: u, fileId: p });
        },
        onThumbnail: (u) => {
          k(this, C, Gn).call(this, n, u);
        },
        getAuthorizationToken: a(this, Te),
        getWebSocket: () => a(this, ht),
        getLogger: () => a(this, X),
        intent: a(this, _e),
        isPublic: a(this, it),
        resumablePayload: i,
        onResumablePayloadChange: (u) => {
          Xt(o, u);
        },
        origin: a(this, lt)
      };
      a(this, st) && (s.onMetadata = (u) => {
        k(this, C, Vn).call(this, n, u);
      });
      const l = a(this, Pe).call(this, t, s);
      a(this, J).set(n, {
        adapter: l,
        file: t,
        fingerPrint: o,
        hash: {
          abortController: new AbortController()
        }
      }), k(this, C, Dn).call(this, n, o, t), a(this, X).info("Upload created", { uploadId: n, fingerPrint: o });
    } catch (s) {
      k(this, C, ke).call(this, s, n, {
        description: "Failed to create upload for file"
      });
    }
    return n;
  }
  /**
   * Starts the upload process for a given UUID.
   *
   * @param uploadId The unique identifier for the uploading asset.
   */
  startUpload(t) {
    try {
      a(this, X).info("Starting upload", { uploadId: t });
      const n = a(this, J).get(t);
      n == null || n.adapter.startUpload();
    } catch (n) {
      k(this, C, ke).call(this, n, t, {
        description: "Failed to start upload"
      });
    }
  }
  /** Starts all available uploads. */
  startAllUploads() {
    a(this, J).forEach((t, n) => this.startUpload(n));
  }
  /**
   * Pause the upload process for a given UUID.
   *
   * @param uploadId The unique identifier for the uploading asset.
   */
  pauseUpload(t) {
    a(this, X).info(`Pausing upload for ${t}`);
    try {
      const n = a(this, J).get(t);
      if (!n)
        throw new Error(`Pause Upload: Upload with uploadId: ${t} not found.`);
      n.adapter.pauseUpload(), k(this, C, jn).call(this, t);
    } catch (n) {
      k(this, C, ke).call(this, n, t, {
        description: "Failed to pause upload"
      });
    }
  }
  /** Pause all available uploads. */
  pauseAllUploads() {
    a(this, J).forEach((t, n) => this.pauseUpload(n));
  }
  /**
   * Resumes the upload process for a given UUID.
   *
   * @param uploadId The unique identifier for the uploading asset.
   */
  resumeUpload(t) {
    a(this, X).info(`Resuming upload for ${t}`);
    try {
      const n = a(this, J).get(t);
      if (!n)
        throw new Error(`Resume Upload: Upload with uploadId: ${t} not found.`);
      n.adapter.resumeUpload(), k(this, C, zn).call(this, t);
    } catch (n) {
      k(this, C, ke).call(this, n, t, {
        description: "Failed to resume upload"
      });
    }
  }
  /** Resume all available uploads. */
  resumeAllUploads() {
    a(this, J).forEach((t, n) => this.resumeUpload(n));
  }
  /**
   * Cancels the upload session for a given UUID.
   *
   * @param uploadId The unique identifier for the uploading asset.
   */
  cancelUpload(t) {
    this.cancelHashCalculation(t), a(this, X).info(`Cancelling upload for ${t}`);
    const n = a(this, J).get(t);
    n && (n.adapter.cancelUpload(), Xt(n == null ? void 0 : n.fingerPrint), a(this, J).delete(t), k(this, C, $n).call(this, t));
  }
  confirmUpload(t) {
    const n = a(this, J).get(t);
    n && (Xt(n == null ? void 0 : n.fingerPrint), a(this, J).delete(t));
  }
  /** Cancels all ongoing upload sessions. */
  cancelAllUploads() {
    a(this, J).forEach((t, n) => this.cancelUpload(n));
  }
  /** Calculates the MD5 hash for a specific upload */
  calculateHash(t) {
    try {
      const n = a(this, J).get(t);
      if (!n)
        throw new Error(`Upload not found: ${t}`);
      if (n.hash.md5) {
        k(this, C, ur).call(this, t, n.hash.md5);
        return;
      }
      k(this, C, oe).call(this, "hashCalculationStarted", {
        uploadId: t,
        file: n.file
      }), es(n.file, n.hash.abortController.signal).then((o) => {
        n.hash && (n.hash.md5 = o), k(this, C, ur).call(this, t, o);
      }).catch((o) => {
        k(this, C, lr).call(this, o, t);
      });
    } catch (n) {
      k(this, C, lr).call(this, n, t);
    }
  }
  /** Cancels an ongoing hash calculation */
  cancelHashCalculation(t) {
    const n = a(this, J).get(t);
    n && (n.hash.abortController.abort(), k(this, C, Jn).call(this, t));
  }
}
J = new WeakMap(), we = new WeakMap(), Pe = new WeakMap(), _e = new WeakMap(), it = new WeakMap(), st = new WeakMap(), at = new WeakMap(), ct = new WeakMap(), ut = new WeakMap(), lt = new WeakMap(), Te = new WeakMap(), X = new WeakMap(), ht = new WeakMap(), C = new WeakSet(), Nn = function() {
  if (!a(this, we))
    return;
  const t = document.querySelector(`#${a(this, we)}`);
  if (!t) {
    const n = new Error(`Input element with ID '${a(this, we)}' not found.`);
    k(this, C, xt).call(this, n);
    return;
  }
  t.addEventListener("change", k(this, C, Qn).bind(this));
}, Qn = function(t) {
  const o = t.target.files;
  o && o.length > 0 && Array.from(o).forEach((i) => {
    this.createUpload(i);
  });
}, ke = function(t, n, o) {
  const i = t instanceof Error;
  if (i && t.name === "AbortError") {
    k(this, C, Wn).call(this, n);
    return;
  }
  const s = a(this, J).get(n), l = t instanceof Error ? t.message : "Unknown Error", u = o.description || l, p = {
    uploadId: n,
    intent: a(this, _e),
    adapter: a(this, Pe).name,
    fileName: s == null ? void 0 : s.file.name,
    fileSize: s == null ? void 0 : s.file.size,
    message: l,
    ...o
  };
  i ? k(this, C, xt).call(this, t, n) : k(this, C, xt).call(this, "An unknown error occurred", n), a(this, X).error(`Handling error - ${u}`, t, p);
}, oe = function(t, n) {
  var o;
  n.uploadId && !n.file && (n.file = (o = a(this, J).get(n.uploadId)) == null ? void 0 : o.file), this.dispatchEvent(new CustomEvent(t, { detail: n }));
}, qn = function(t, n, o) {
  const i = { uploadId: t, assetId: n, fileId: o };
  k(this, C, oe).call(this, "assetAssigned", i);
}, Dn = function(t, n, o) {
  const i = { uploadId: t, fingerPrint: n, file: o };
  k(this, C, oe).call(this, "uploadCreated", i);
}, Hn = function(t, n) {
  a(this, X).isVerboseEnabled() && a(this, X).debug("Upload progress", { uploadId: t, bytesUploaded: n });
  const o = { uploadId: t, bytesUploaded: n };
  k(this, C, oe).call(this, "uploadProgress", o);
}, jn = function(t) {
  a(this, X).info("Upload paused", { uploadId: t });
  const n = { uploadId: t };
  k(this, C, oe).call(this, "uploadPaused", n);
}, zn = function(t) {
  a(this, X).info("Upload resumed", { uploadId: t });
  const n = { uploadId: t };
  k(this, C, oe).call(this, "uploadResumed", n);
}, Mn = function({
  uploadId: t,
  assetId: n,
  fileId: o
}) {
  a(this, X).info("Upload complete", { uploadId: t, assetId: n, fileId: o });
  const i = { uploadId: t, assetId: n, fileId: o };
  k(this, C, oe).call(this, "uploadComplete", i);
}, $n = function(t) {
  a(this, X).info("Upload cancelled", { uploadId: t });
  const n = { uploadId: t };
  k(this, C, oe).call(this, "uploadCancelled", n);
}, Vn = function(t, n) {
  const o = { uploadId: t, metadata: n };
  k(this, C, oe).call(this, "metadataReceived", o);
}, Gn = function(t, n) {
  const o = { uploadId: t, thumbnailUrl: n };
  k(this, C, oe).call(this, "thumbnailReceived", o);
}, xt = function(t, n) {
  const o = typeof t == "string" ? t : t.message, i = { uploadId: n, error: o };
  k(this, C, oe).call(this, "error", i);
}, Wn = function(t) {
  const n = { uploadId: t };
  k(this, C, oe).call(this, "uploadCancelled", n);
}, ur = function(t, n) {
  var o;
  k(this, C, oe).call(this, "hashComplete", {
    uploadId: t,
    hash: n,
    file: (o = a(this, J).get(t)) == null ? void 0 : o.file
  });
}, Jn = function(t) {
  var n;
  k(this, C, oe).call(this, "hashCancelled", {
    uploadId: t,
    file: (n = a(this, J).get(t)) == null ? void 0 : n.file
  });
}, lr = function(t, n) {
  var i;
  const o = {
    uploadId: n,
    error: t.message,
    file: (i = a(this, J).get(n)) == null ? void 0 : i.file
  };
  k(this, C, oe).call(this, "hashError", o), a(this, X).error("Hash calculation error", t, { uploadId: n });
};
function hr(r) {
  "@babel/helpers - typeof";
  return hr = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, hr(r);
}
function os(r, e, t) {
  return Object.defineProperty(r, "prototype", { writable: !1 }), r;
}
function is(r, e) {
  if (!(r instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function ss(r, e, t) {
  return e = Ke(e), as(r, Ur() ? Reflect.construct(e, t || [], Ke(r).constructor) : e.apply(r, t));
}
function as(r, e) {
  if (e && (hr(e) === "object" || typeof e == "function"))
    return e;
  if (e !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return cs(r);
}
function cs(r) {
  if (r === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return r;
}
function us(r, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  r.prototype = Object.create(e && e.prototype, { constructor: { value: r, writable: !0, configurable: !0 } }), Object.defineProperty(r, "prototype", { writable: !1 }), e && Xe(r, e);
}
function fr(r) {
  var e = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
  return fr = function(n) {
    if (n === null || !hs(n)) return n;
    if (typeof n != "function")
      throw new TypeError("Super expression must either be null or a function");
    if (typeof e < "u") {
      if (e.has(n)) return e.get(n);
      e.set(n, o);
    }
    function o() {
      return ls(n, arguments, Ke(this).constructor);
    }
    return o.prototype = Object.create(n.prototype, { constructor: { value: o, enumerable: !1, writable: !0, configurable: !0 } }), Xe(o, n);
  }, fr(r);
}
function ls(r, e, t) {
  if (Ur()) return Reflect.construct.apply(null, arguments);
  var n = [null];
  n.push.apply(n, e);
  var o = new (r.bind.apply(r, n))();
  return t && Xe(o, t.prototype), o;
}
function Ur() {
  try {
    var r = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (Ur = function() {
    return !!r;
  })();
}
function hs(r) {
  try {
    return Function.toString.call(r).indexOf("[native code]") !== -1;
  } catch {
    return typeof r == "function";
  }
}
function Xe(r, e) {
  return Xe = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, o) {
    return n.__proto__ = o, n;
  }, Xe(r, e);
}
function Ke(r) {
  return Ke = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, Ke(r);
}
var Ve = /* @__PURE__ */ function(r) {
  function e(t) {
    var n, o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null, s = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
    if (is(this, e), n = ss(this, e, [t]), n.originalRequest = i, n.originalResponse = s, n.causingError = o, o != null && (t += ", caused by ".concat(o.toString())), i != null) {
      var l = i.getHeader("X-Request-ID") || "n/a", u = i.getMethod(), p = i.getURL(), d = s ? s.getStatus() : "n/a", S = s ? s.getBody() || "" : "n/a";
      t += ", originated from request (method: ".concat(u, ", url: ").concat(p, ", response code: ").concat(d, ", response text: ").concat(S, ", request id: ").concat(l, ")");
    }
    return n.message = t, n;
  }
  return us(e, r), os(e);
}(/* @__PURE__ */ fr(Error));
function Ye(r) {
  "@babel/helpers - typeof";
  return Ye = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Ye(r);
}
function fs(r, e) {
  if (!(r instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function ps(r, e) {
  for (var t = 0; t < e.length; t++) {
    var n = e[t];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(r, gs(n.key), n);
  }
}
function ds(r, e, t) {
  return e && ps(r.prototype, e), Object.defineProperty(r, "prototype", { writable: !1 }), r;
}
function gs(r) {
  var e = ys(r, "string");
  return Ye(e) == "symbol" ? e : e + "";
}
function ys(r, e) {
  if (Ye(r) != "object" || !r) return r;
  var t = r[Symbol.toPrimitive];
  if (t !== void 0) {
    var n = t.call(r, e);
    if (Ye(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(r);
}
var ms = /* @__PURE__ */ function() {
  function r() {
    fs(this, r);
  }
  return ds(r, [{
    key: "listAllUploads",
    value: function() {
      return Promise.resolve([]);
    }
  }, {
    key: "findUploadsByFingerprint",
    value: function(t) {
      return Promise.resolve([]);
    }
  }, {
    key: "removeUpload",
    value: function(t) {
      return Promise.resolve();
    }
  }, {
    key: "addUpload",
    value: function(t, n) {
      return Promise.resolve(null);
    }
  }]);
}();
const Xn = "3.7.7", As = Xn, De = typeof Buffer == "function", Jr = typeof TextDecoder == "function" ? new TextDecoder() : void 0, Xr = typeof TextEncoder == "function" ? new TextEncoder() : void 0, vs = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=", Ge = Array.prototype.slice.call(vs), bt = ((r) => {
  let e = {};
  return r.forEach((t, n) => e[t] = n), e;
})(Ge), bs = /^(?:[A-Za-z\d+\/]{4})*?(?:[A-Za-z\d+\/]{2}(?:==)?|[A-Za-z\d+\/]{3}=?)?$/, ne = String.fromCharCode.bind(String), Kr = typeof Uint8Array.from == "function" ? Uint8Array.from.bind(Uint8Array) : (r) => new Uint8Array(Array.prototype.slice.call(r, 0)), Kn = (r) => r.replace(/=/g, "").replace(/[+\/]/g, (e) => e == "+" ? "-" : "_"), Yn = (r) => r.replace(/[^A-Za-z0-9\+\/]/g, ""), Zn = (r) => {
  let e, t, n, o, i = "";
  const s = r.length % 3;
  for (let l = 0; l < r.length; ) {
    if ((t = r.charCodeAt(l++)) > 255 || (n = r.charCodeAt(l++)) > 255 || (o = r.charCodeAt(l++)) > 255)
      throw new TypeError("invalid character found");
    e = t << 16 | n << 8 | o, i += Ge[e >> 18 & 63] + Ge[e >> 12 & 63] + Ge[e >> 6 & 63] + Ge[e & 63];
  }
  return s ? i.slice(0, s - 3) + "===".substring(s) : i;
}, Cr = typeof btoa == "function" ? (r) => btoa(r) : De ? (r) => Buffer.from(r, "binary").toString("base64") : Zn, pr = De ? (r) => Buffer.from(r).toString("base64") : (r) => {
  let t = [];
  for (let n = 0, o = r.length; n < o; n += 4096)
    t.push(ne.apply(null, r.subarray(n, n + 4096)));
  return Cr(t.join(""));
}, Ot = (r, e = !1) => e ? Kn(pr(r)) : pr(r), ws = (r) => {
  if (r.length < 2) {
    var e = r.charCodeAt(0);
    return e < 128 ? r : e < 2048 ? ne(192 | e >>> 6) + ne(128 | e & 63) : ne(224 | e >>> 12 & 15) + ne(128 | e >>> 6 & 63) + ne(128 | e & 63);
  } else {
    var e = 65536 + (r.charCodeAt(0) - 55296) * 1024 + (r.charCodeAt(1) - 56320);
    return ne(240 | e >>> 18 & 7) + ne(128 | e >>> 12 & 63) + ne(128 | e >>> 6 & 63) + ne(128 | e & 63);
  }
}, _s = /[\uD800-\uDBFF][\uDC00-\uDFFFF]|[^\x00-\x7F]/g, eo = (r) => r.replace(_s, ws), Yr = De ? (r) => Buffer.from(r, "utf8").toString("base64") : Xr ? (r) => pr(Xr.encode(r)) : (r) => Cr(eo(r)), Oe = (r, e = !1) => e ? Kn(Yr(r)) : Yr(r), Zr = (r) => Oe(r, !0), Es = /[\xC0-\xDF][\x80-\xBF]|[\xE0-\xEF][\x80-\xBF]{2}|[\xF0-\xF7][\x80-\xBF]{3}/g, Ss = (r) => {
  switch (r.length) {
    case 4:
      var e = (7 & r.charCodeAt(0)) << 18 | (63 & r.charCodeAt(1)) << 12 | (63 & r.charCodeAt(2)) << 6 | 63 & r.charCodeAt(3), t = e - 65536;
      return ne((t >>> 10) + 55296) + ne((t & 1023) + 56320);
    case 3:
      return ne((15 & r.charCodeAt(0)) << 12 | (63 & r.charCodeAt(1)) << 6 | 63 & r.charCodeAt(2));
    default:
      return ne((31 & r.charCodeAt(0)) << 6 | 63 & r.charCodeAt(1));
  }
}, to = (r) => r.replace(Es, Ss), ro = (r) => {
  if (r = r.replace(/\s+/g, ""), !bs.test(r))
    throw new TypeError("malformed base64.");
  r += "==".slice(2 - (r.length & 3));
  let e, t = "", n, o;
  for (let i = 0; i < r.length; )
    e = bt[r.charAt(i++)] << 18 | bt[r.charAt(i++)] << 12 | (n = bt[r.charAt(i++)]) << 6 | (o = bt[r.charAt(i++)]), t += n === 64 ? ne(e >> 16 & 255) : o === 64 ? ne(e >> 16 & 255, e >> 8 & 255) : ne(e >> 16 & 255, e >> 8 & 255, e & 255);
  return t;
}, Rr = typeof atob == "function" ? (r) => atob(Yn(r)) : De ? (r) => Buffer.from(r, "base64").toString("binary") : ro, no = De ? (r) => Kr(Buffer.from(r, "base64")) : (r) => Kr(Rr(r).split("").map((e) => e.charCodeAt(0))), oo = (r) => no(io(r)), Bs = De ? (r) => Buffer.from(r, "base64").toString("utf8") : Jr ? (r) => Jr.decode(no(r)) : (r) => to(Rr(r)), io = (r) => Yn(r.replace(/[-_]/g, (e) => e == "-" ? "+" : "/")), dr = (r) => Bs(io(r)), Is = (r) => {
  if (typeof r != "string")
    return !1;
  const e = r.replace(/\s+/g, "").replace(/={0,2}$/, "");
  return !/[^\s0-9a-zA-Z\+/]/.test(e) || !/[^\s0-9a-zA-Z\-_]/.test(e);
}, so = (r) => ({
  value: r,
  enumerable: !1,
  writable: !0,
  configurable: !0
}), ao = function() {
  const r = (e, t) => Object.defineProperty(String.prototype, e, so(t));
  r("fromBase64", function() {
    return dr(this);
  }), r("toBase64", function(e) {
    return Oe(this, e);
  }), r("toBase64URI", function() {
    return Oe(this, !0);
  }), r("toBase64URL", function() {
    return Oe(this, !0);
  }), r("toUint8Array", function() {
    return oo(this);
  });
}, co = function() {
  const r = (e, t) => Object.defineProperty(Uint8Array.prototype, e, so(t));
  r("toBase64", function(e) {
    return Ot(this, e);
  }), r("toBase64URI", function() {
    return Ot(this, !0);
  }), r("toBase64URL", function() {
    return Ot(this, !0);
  });
}, ks = () => {
  ao(), co();
}, Us = {
  version: Xn,
  VERSION: As,
  atob: Rr,
  atobPolyfill: ro,
  btoa: Cr,
  btoaPolyfill: Zn,
  fromBase64: dr,
  toBase64: Oe,
  encode: Oe,
  encodeURI: Zr,
  encodeURL: Zr,
  utob: eo,
  btou: to,
  decode: dr,
  isValid: Is,
  fromUint8Array: Ot,
  toUint8Array: oo,
  extendString: ao,
  extendUint8Array: co,
  extendBuiltins: ks
};
var Kt, en;
function Cs() {
  return en || (en = 1, Kt = function(e, t) {
    if (t = t.split(":")[0], e = +e, !e) return !1;
    switch (t) {
      case "http":
      case "ws":
        return e !== 80;
      case "https":
      case "wss":
        return e !== 443;
      case "ftp":
        return e !== 21;
      case "gopher":
        return e !== 70;
      case "file":
        return !1;
    }
    return e !== 0;
  }), Kt;
}
var wt = {}, tn;
function Rs() {
  if (tn) return wt;
  tn = 1;
  var r = Object.prototype.hasOwnProperty, e;
  function t(s) {
    try {
      return decodeURIComponent(s.replace(/\+/g, " "));
    } catch {
      return null;
    }
  }
  function n(s) {
    try {
      return encodeURIComponent(s);
    } catch {
      return null;
    }
  }
  function o(s) {
    for (var l = /([^=?#&]+)=?([^&]*)/g, u = {}, p; p = l.exec(s); ) {
      var d = t(p[1]), S = t(p[2]);
      d === null || S === null || d in u || (u[d] = S);
    }
    return u;
  }
  function i(s, l) {
    l = l || "";
    var u = [], p, d;
    typeof l != "string" && (l = "?");
    for (d in s)
      if (r.call(s, d)) {
        if (p = s[d], !p && (p === null || p === e || isNaN(p)) && (p = ""), d = n(d), p = n(p), d === null || p === null) continue;
        u.push(d + "=" + p);
      }
    return u.length ? l + u.join("&") : "";
  }
  return wt.stringify = i, wt.parse = o, wt;
}
var Yt, rn;
function xs() {
  if (rn) return Yt;
  rn = 1;
  var r = Cs(), e = Rs(), t = /^[\x00-\x20\u00a0\u1680\u2000-\u200a\u2028\u2029\u202f\u205f\u3000\ufeff]+/, n = /[\n\r\t]/g, o = /^[A-Za-z][A-Za-z0-9+-.]*:\/\//, i = /:\d+$/, s = /^([a-z][a-z0-9.+-]*:)?(\/\/)?([\\/]+)?([\S\s]*)/i, l = /^[a-zA-Z]:/;
  function u(m) {
    return (m || "").toString().replace(t, "");
  }
  var p = [
    ["#", "hash"],
    // Extract from the back.
    ["?", "query"],
    // Extract from the back.
    function(A, g) {
      return R(g.protocol) ? A.replace(/\\/g, "/") : A;
    },
    ["/", "pathname"],
    // Extract from the back.
    ["@", "auth", 1],
    // Extract from the front.
    [NaN, "host", void 0, 1, 1],
    // Set left over value.
    [/:(\d*)$/, "port", void 0, 1],
    // RegExp the back.
    [NaN, "hostname", void 0, 1, 1]
    // Set left over.
  ], d = { hash: 1, query: 1 };
  function S(m) {
    var A;
    typeof window < "u" ? A = window : typeof Lr < "u" ? A = Lr : typeof self < "u" ? A = self : A = {};
    var g = A.location || {};
    m = m || g;
    var y = {}, E = typeof m, _;
    if (m.protocol === "blob:")
      y = new B(unescape(m.pathname), {});
    else if (E === "string") {
      y = new B(m, {});
      for (_ in d) delete y[_];
    } else if (E === "object") {
      for (_ in m)
        _ in d || (y[_] = m[_]);
      y.slashes === void 0 && (y.slashes = o.test(m.href));
    }
    return y;
  }
  function R(m) {
    return m === "file:" || m === "ftp:" || m === "http:" || m === "https:" || m === "ws:" || m === "wss:";
  }
  function z(m, A) {
    m = u(m), m = m.replace(n, ""), A = A || {};
    var g = s.exec(m), y = g[1] ? g[1].toLowerCase() : "", E = !!g[2], _ = !!g[3], P = 0, O;
    return E ? _ ? (O = g[2] + g[3] + g[4], P = g[2].length + g[3].length) : (O = g[2] + g[4], P = g[2].length) : _ ? (O = g[3] + g[4], P = g[3].length) : O = g[4], y === "file:" ? P >= 2 && (O = O.slice(2)) : R(y) ? O = g[4] : y ? E && (O = O.slice(2)) : P >= 2 && R(A.protocol) && (O = g[4]), {
      protocol: y,
      slashes: E || R(y),
      slashesCount: P,
      rest: O
    };
  }
  function H(m, A) {
    if (m === "") return A;
    for (var g = (A || "/").split("/").slice(0, -1).concat(m.split("/")), y = g.length, E = g[y - 1], _ = !1, P = 0; y--; )
      g[y] === "." ? g.splice(y, 1) : g[y] === ".." ? (g.splice(y, 1), P++) : P && (y === 0 && (_ = !0), g.splice(y, 1), P--);
    return _ && g.unshift(""), (E === "." || E === "..") && g.push(""), g.join("/");
  }
  function B(m, A, g) {
    if (m = u(m), m = m.replace(n, ""), !(this instanceof B))
      return new B(m, A, g);
    var y, E, _, P, O, V, N = p.slice(), G = typeof A, I = this, ce = 0;
    for (G !== "object" && G !== "string" && (g = A, A = null), g && typeof g != "function" && (g = e.parse), A = S(A), E = z(m || "", A), y = !E.protocol && !E.slashes, I.slashes = E.slashes || y && A.slashes, I.protocol = E.protocol || A.protocol || "", m = E.rest, (E.protocol === "file:" && (E.slashesCount !== 2 || l.test(m)) || !E.slashes && (E.protocol || E.slashesCount < 2 || !R(I.protocol))) && (N[3] = [/(.*)/, "pathname"]); ce < N.length; ce++) {
      if (P = N[ce], typeof P == "function") {
        m = P(m, I);
        continue;
      }
      _ = P[0], V = P[1], _ !== _ ? I[V] = m : typeof _ == "string" ? (O = _ === "@" ? m.lastIndexOf(_) : m.indexOf(_), ~O && (typeof P[2] == "number" ? (I[V] = m.slice(0, O), m = m.slice(O + P[2])) : (I[V] = m.slice(O), m = m.slice(0, O)))) : (O = _.exec(m)) && (I[V] = O[1], m = m.slice(0, O.index)), I[V] = I[V] || y && P[3] && A[V] || "", P[4] && (I[V] = I[V].toLowerCase());
    }
    g && (I.query = g(I.query)), y && A.slashes && I.pathname.charAt(0) !== "/" && (I.pathname !== "" || A.pathname !== "") && (I.pathname = H(I.pathname, A.pathname)), I.pathname.charAt(0) !== "/" && R(I.protocol) && (I.pathname = "/" + I.pathname), r(I.port, I.protocol) || (I.host = I.hostname, I.port = ""), I.username = I.password = "", I.auth && (O = I.auth.indexOf(":"), ~O ? (I.username = I.auth.slice(0, O), I.username = encodeURIComponent(decodeURIComponent(I.username)), I.password = I.auth.slice(O + 1), I.password = encodeURIComponent(decodeURIComponent(I.password))) : I.username = encodeURIComponent(decodeURIComponent(I.auth)), I.auth = I.password ? I.username + ":" + I.password : I.username), I.origin = I.protocol !== "file:" && R(I.protocol) && I.host ? I.protocol + "//" + I.host : "null", I.href = I.toString();
  }
  function x(m, A, g) {
    var y = this;
    switch (m) {
      case "query":
        typeof A == "string" && A.length && (A = (g || e.parse)(A)), y[m] = A;
        break;
      case "port":
        y[m] = A, r(A, y.protocol) ? A && (y.host = y.hostname + ":" + A) : (y.host = y.hostname, y[m] = "");
        break;
      case "hostname":
        y[m] = A, y.port && (A += ":" + y.port), y.host = A;
        break;
      case "host":
        y[m] = A, i.test(A) ? (A = A.split(":"), y.port = A.pop(), y.hostname = A.join(":")) : (y.hostname = A, y.port = "");
        break;
      case "protocol":
        y.protocol = A.toLowerCase(), y.slashes = !g;
        break;
      case "pathname":
      case "hash":
        if (A) {
          var E = m === "pathname" ? "/" : "#";
          y[m] = A.charAt(0) !== E ? E + A : A;
        } else
          y[m] = A;
        break;
      case "username":
      case "password":
        y[m] = encodeURIComponent(A);
        break;
      case "auth":
        var _ = A.indexOf(":");
        ~_ ? (y.username = A.slice(0, _), y.username = encodeURIComponent(decodeURIComponent(y.username)), y.password = A.slice(_ + 1), y.password = encodeURIComponent(decodeURIComponent(y.password))) : y.username = encodeURIComponent(decodeURIComponent(A));
    }
    for (var P = 0; P < p.length; P++) {
      var O = p[P];
      O[4] && (y[O[1]] = y[O[1]].toLowerCase());
    }
    return y.auth = y.password ? y.username + ":" + y.password : y.username, y.origin = y.protocol !== "file:" && R(y.protocol) && y.host ? y.protocol + "//" + y.host : "null", y.href = y.toString(), y;
  }
  function U(m) {
    (!m || typeof m != "function") && (m = e.stringify);
    var A, g = this, y = g.host, E = g.protocol;
    E && E.charAt(E.length - 1) !== ":" && (E += ":");
    var _ = E + (g.protocol && g.slashes || R(g.protocol) ? "//" : "");
    return g.username ? (_ += g.username, g.password && (_ += ":" + g.password), _ += "@") : g.password ? (_ += ":" + g.password, _ += "@") : g.protocol !== "file:" && R(g.protocol) && !y && g.pathname !== "/" && (_ += "@"), (y[y.length - 1] === ":" || i.test(g.hostname) && !g.port) && (y += ":"), _ += y + g.pathname, A = typeof g.query == "object" ? m(g.query) : g.query, A && (_ += A.charAt(0) !== "?" ? "?" + A : A), g.hash && (_ += g.hash), _;
  }
  return B.prototype = { set: x, toString: U }, B.extractProtocol = z, B.location = S, B.trimLeft = u, B.qs = e, Yt = B, Yt;
}
var Os = xs();
const Ps = /* @__PURE__ */ bn(Os);
function Ts() {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(r) {
    var e = Math.random() * 16 | 0, t = r === "x" ? e : e & 3 | 8;
    return t.toString(16);
  });
}
function gr() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
  gr = function() {
    return e;
  };
  var r, e = {}, t = Object.prototype, n = t.hasOwnProperty, o = Object.defineProperty || function(f, c, h) {
    f[c] = h.value;
  }, i = typeof Symbol == "function" ? Symbol : {}, s = i.iterator || "@@iterator", l = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag";
  function p(f, c, h) {
    return Object.defineProperty(f, c, { value: h, enumerable: !0, configurable: !0, writable: !0 }), f[c];
  }
  try {
    p({}, "");
  } catch {
    p = function(h, v, w) {
      return h[v] = w;
    };
  }
  function d(f, c, h, v) {
    var w = c && c.prototype instanceof U ? c : U, b = Object.create(w.prototype), F = new ce(v || []);
    return o(b, "_invoke", { value: V(f, h, F) }), b;
  }
  function S(f, c, h) {
    try {
      return { type: "normal", arg: f.call(c, h) };
    } catch (v) {
      return { type: "throw", arg: v };
    }
  }
  e.wrap = d;
  var R = "suspendedStart", z = "suspendedYield", H = "executing", B = "completed", x = {};
  function U() {
  }
  function m() {
  }
  function A() {
  }
  var g = {};
  p(g, s, function() {
    return this;
  });
  var y = Object.getPrototypeOf, E = y && y(y(ye([])));
  E && E !== t && n.call(E, s) && (g = E);
  var _ = A.prototype = U.prototype = Object.create(g);
  function P(f) {
    ["next", "throw", "return"].forEach(function(c) {
      p(f, c, function(h) {
        return this._invoke(c, h);
      });
    });
  }
  function O(f, c) {
    function h(w, b, F, j) {
      var M = S(f[w], f, b);
      if (M.type !== "throw") {
        var se = M.arg, te = se.value;
        return te && Se(te) == "object" && n.call(te, "__await") ? c.resolve(te.__await).then(function(ae) {
          h("next", ae, F, j);
        }, function(ae) {
          h("throw", ae, F, j);
        }) : c.resolve(te).then(function(ae) {
          se.value = ae, F(se);
        }, function(ae) {
          return h("throw", ae, F, j);
        });
      }
      j(M.arg);
    }
    var v;
    o(this, "_invoke", { value: function(b, F) {
      function j() {
        return new c(function(M, se) {
          h(b, F, M, se);
        });
      }
      return v = v ? v.then(j, j) : j();
    } });
  }
  function V(f, c, h) {
    var v = R;
    return function(w, b) {
      if (v === H) throw Error("Generator is already running");
      if (v === B) {
        if (w === "throw") throw b;
        return { value: r, done: !0 };
      }
      for (h.method = w, h.arg = b; ; ) {
        var F = h.delegate;
        if (F) {
          var j = N(F, h);
          if (j) {
            if (j === x) continue;
            return j;
          }
        }
        if (h.method === "next") h.sent = h._sent = h.arg;
        else if (h.method === "throw") {
          if (v === R) throw v = B, h.arg;
          h.dispatchException(h.arg);
        } else h.method === "return" && h.abrupt("return", h.arg);
        v = H;
        var M = S(f, c, h);
        if (M.type === "normal") {
          if (v = h.done ? B : z, M.arg === x) continue;
          return { value: M.arg, done: h.done };
        }
        M.type === "throw" && (v = B, h.method = "throw", h.arg = M.arg);
      }
    };
  }
  function N(f, c) {
    var h = c.method, v = f.iterator[h];
    if (v === r) return c.delegate = null, h === "throw" && f.iterator.return && (c.method = "return", c.arg = r, N(f, c), c.method === "throw") || h !== "return" && (c.method = "throw", c.arg = new TypeError("The iterator does not provide a '" + h + "' method")), x;
    var w = S(v, f.iterator, c.arg);
    if (w.type === "throw") return c.method = "throw", c.arg = w.arg, c.delegate = null, x;
    var b = w.arg;
    return b ? b.done ? (c[f.resultName] = b.value, c.next = f.nextLoc, c.method !== "return" && (c.method = "next", c.arg = r), c.delegate = null, x) : b : (c.method = "throw", c.arg = new TypeError("iterator result is not an object"), c.delegate = null, x);
  }
  function G(f) {
    var c = { tryLoc: f[0] };
    1 in f && (c.catchLoc = f[1]), 2 in f && (c.finallyLoc = f[2], c.afterLoc = f[3]), this.tryEntries.push(c);
  }
  function I(f) {
    var c = f.completion || {};
    c.type = "normal", delete c.arg, f.completion = c;
  }
  function ce(f) {
    this.tryEntries = [{ tryLoc: "root" }], f.forEach(G, this), this.reset(!0);
  }
  function ye(f) {
    if (f || f === "") {
      var c = f[s];
      if (c) return c.call(f);
      if (typeof f.next == "function") return f;
      if (!isNaN(f.length)) {
        var h = -1, v = function w() {
          for (; ++h < f.length; ) if (n.call(f, h)) return w.value = f[h], w.done = !1, w;
          return w.value = r, w.done = !0, w;
        };
        return v.next = v;
      }
    }
    throw new TypeError(Se(f) + " is not iterable");
  }
  return m.prototype = A, o(_, "constructor", { value: A, configurable: !0 }), o(A, "constructor", { value: m, configurable: !0 }), m.displayName = p(A, u, "GeneratorFunction"), e.isGeneratorFunction = function(f) {
    var c = typeof f == "function" && f.constructor;
    return !!c && (c === m || (c.displayName || c.name) === "GeneratorFunction");
  }, e.mark = function(f) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(f, A) : (f.__proto__ = A, p(f, u, "GeneratorFunction")), f.prototype = Object.create(_), f;
  }, e.awrap = function(f) {
    return { __await: f };
  }, P(O.prototype), p(O.prototype, l, function() {
    return this;
  }), e.AsyncIterator = O, e.async = function(f, c, h, v, w) {
    w === void 0 && (w = Promise);
    var b = new O(d(f, c, h, v), w);
    return e.isGeneratorFunction(c) ? b : b.next().then(function(F) {
      return F.done ? F.value : b.next();
    });
  }, P(_), p(_, u, "Generator"), p(_, s, function() {
    return this;
  }), p(_, "toString", function() {
    return "[object Generator]";
  }), e.keys = function(f) {
    var c = Object(f), h = [];
    for (var v in c) h.push(v);
    return h.reverse(), function w() {
      for (; h.length; ) {
        var b = h.pop();
        if (b in c) return w.value = b, w.done = !1, w;
      }
      return w.done = !0, w;
    };
  }, e.values = ye, ce.prototype = { constructor: ce, reset: function(c) {
    if (this.prev = 0, this.next = 0, this.sent = this._sent = r, this.done = !1, this.delegate = null, this.method = "next", this.arg = r, this.tryEntries.forEach(I), !c) for (var h in this) h.charAt(0) === "t" && n.call(this, h) && !isNaN(+h.slice(1)) && (this[h] = r);
  }, stop: function() {
    this.done = !0;
    var c = this.tryEntries[0].completion;
    if (c.type === "throw") throw c.arg;
    return this.rval;
  }, dispatchException: function(c) {
    if (this.done) throw c;
    var h = this;
    function v(se, te) {
      return F.type = "throw", F.arg = c, h.next = se, te && (h.method = "next", h.arg = r), !!te;
    }
    for (var w = this.tryEntries.length - 1; w >= 0; --w) {
      var b = this.tryEntries[w], F = b.completion;
      if (b.tryLoc === "root") return v("end");
      if (b.tryLoc <= this.prev) {
        var j = n.call(b, "catchLoc"), M = n.call(b, "finallyLoc");
        if (j && M) {
          if (this.prev < b.catchLoc) return v(b.catchLoc, !0);
          if (this.prev < b.finallyLoc) return v(b.finallyLoc);
        } else if (j) {
          if (this.prev < b.catchLoc) return v(b.catchLoc, !0);
        } else {
          if (!M) throw Error("try statement without catch or finally");
          if (this.prev < b.finallyLoc) return v(b.finallyLoc);
        }
      }
    }
  }, abrupt: function(c, h) {
    for (var v = this.tryEntries.length - 1; v >= 0; --v) {
      var w = this.tryEntries[v];
      if (w.tryLoc <= this.prev && n.call(w, "finallyLoc") && this.prev < w.finallyLoc) {
        var b = w;
        break;
      }
    }
    b && (c === "break" || c === "continue") && b.tryLoc <= h && h <= b.finallyLoc && (b = null);
    var F = b ? b.completion : {};
    return F.type = c, F.arg = h, b ? (this.method = "next", this.next = b.finallyLoc, x) : this.complete(F);
  }, complete: function(c, h) {
    if (c.type === "throw") throw c.arg;
    return c.type === "break" || c.type === "continue" ? this.next = c.arg : c.type === "return" ? (this.rval = this.arg = c.arg, this.method = "return", this.next = "end") : c.type === "normal" && h && (this.next = h), x;
  }, finish: function(c) {
    for (var h = this.tryEntries.length - 1; h >= 0; --h) {
      var v = this.tryEntries[h];
      if (v.finallyLoc === c) return this.complete(v.completion, v.afterLoc), I(v), x;
    }
  }, catch: function(c) {
    for (var h = this.tryEntries.length - 1; h >= 0; --h) {
      var v = this.tryEntries[h];
      if (v.tryLoc === c) {
        var w = v.completion;
        if (w.type === "throw") {
          var b = w.arg;
          I(v);
        }
        return b;
      }
    }
    throw Error("illegal catch attempt");
  }, delegateYield: function(c, h, v) {
    return this.delegate = { iterator: ye(c), resultName: h, nextLoc: v }, this.method === "next" && (this.arg = r), x;
  } }, e;
}
function nn(r, e, t, n, o, i, s) {
  try {
    var l = r[i](s), u = l.value;
  } catch (p) {
    t(p);
    return;
  }
  l.done ? e(u) : Promise.resolve(u).then(n, o);
}
function Fs(r) {
  return function() {
    var e = this, t = arguments;
    return new Promise(function(n, o) {
      var i = r.apply(e, t);
      function s(u) {
        nn(i, n, o, s, l, "next", u);
      }
      function l(u) {
        nn(i, n, o, s, l, "throw", u);
      }
      s(void 0);
    });
  };
}
function uo(r, e) {
  return Qs(r) || Ns(r, e) || lo(r, e) || Ls();
}
function Ls() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Ns(r, e) {
  var t = r == null ? null : typeof Symbol < "u" && r[Symbol.iterator] || r["@@iterator"];
  if (t != null) {
    var n, o, i, s, l = [], u = !0, p = !1;
    try {
      if (i = (t = t.call(r)).next, e !== 0) for (; !(u = (n = i.call(t)).done) && (l.push(n.value), l.length !== e); u = !0) ;
    } catch (d) {
      p = !0, o = d;
    } finally {
      try {
        if (!u && t.return != null && (s = t.return(), Object(s) !== s)) return;
      } finally {
        if (p) throw o;
      }
    }
    return l;
  }
}
function Qs(r) {
  if (Array.isArray(r)) return r;
}
function Se(r) {
  "@babel/helpers - typeof";
  return Se = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Se(r);
}
function qs(r, e) {
  var t = typeof Symbol < "u" && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = lo(r)) || e) {
      t && (r = t);
      var n = 0, o = function() {
      };
      return { s: o, n: function() {
        return n >= r.length ? { done: !0 } : { done: !1, value: r[n++] };
      }, e: function(p) {
        throw p;
      }, f: o };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  var i = !0, s = !1, l;
  return { s: function() {
    t = t.call(r);
  }, n: function() {
    var p = t.next();
    return i = p.done, p;
  }, e: function(p) {
    s = !0, l = p;
  }, f: function() {
    try {
      !i && t.return != null && t.return();
    } finally {
      if (s) throw l;
    }
  } };
}
function lo(r, e) {
  if (r) {
    if (typeof r == "string") return on(r, e);
    var t = Object.prototype.toString.call(r).slice(8, -1);
    if (t === "Object" && r.constructor && (t = r.constructor.name), t === "Map" || t === "Set") return Array.from(r);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return on(r, e);
  }
}
function on(r, e) {
  (e == null || e > r.length) && (e = r.length);
  for (var t = 0, n = new Array(e); t < e; t++) n[t] = r[t];
  return n;
}
function sn(r, e) {
  var t = Object.keys(r);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(r);
    e && (n = n.filter(function(o) {
      return Object.getOwnPropertyDescriptor(r, o).enumerable;
    })), t.push.apply(t, n);
  }
  return t;
}
function Ie(r) {
  for (var e = 1; e < arguments.length; e++) {
    var t = arguments[e] != null ? arguments[e] : {};
    e % 2 ? sn(Object(t), !0).forEach(function(n) {
      Ds(r, n, t[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(r, Object.getOwnPropertyDescriptors(t)) : sn(Object(t)).forEach(function(n) {
      Object.defineProperty(r, n, Object.getOwnPropertyDescriptor(t, n));
    });
  }
  return r;
}
function Ds(r, e, t) {
  return e = ho(e), e in r ? Object.defineProperty(r, e, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : r[e] = t, r;
}
function Hs(r, e) {
  if (!(r instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function an(r, e) {
  for (var t = 0; t < e.length; t++) {
    var n = e[t];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(r, ho(n.key), n);
  }
}
function js(r, e, t) {
  return e && an(r.prototype, e), t && an(r, t), Object.defineProperty(r, "prototype", { writable: !1 }), r;
}
function ho(r) {
  var e = zs(r, "string");
  return Se(e) == "symbol" ? e : e + "";
}
function zs(r, e) {
  if (Se(r) != "object" || !r) return r;
  var t = r[Symbol.toPrimitive];
  if (t !== void 0) {
    var n = t.call(r, e);
    if (Se(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(r);
}
var Pt = "tus-v1", Tt = "ietf-draft-03", We = "ietf-draft-05", Ms = {
  endpoint: null,
  uploadUrl: null,
  metadata: {},
  metadataForPartialUploads: {},
  fingerprint: null,
  uploadSize: null,
  onProgress: null,
  onChunkComplete: null,
  onSuccess: null,
  onError: null,
  onUploadUrlAvailable: null,
  overridePatchMethod: !1,
  headers: {},
  addRequestId: !1,
  onBeforeRequest: null,
  onAfterResponse: null,
  onShouldRetry: fo,
  chunkSize: Number.POSITIVE_INFINITY,
  retryDelays: [0, 1e3, 3e3, 5e3],
  parallelUploads: 1,
  parallelUploadBoundaries: null,
  storeFingerprintForResuming: !0,
  removeFingerprintOnSuccess: !1,
  uploadLengthDeferred: !1,
  uploadDataDuringCreation: !1,
  urlStorage: null,
  fileReader: null,
  httpStack: null,
  protocol: Pt
}, Qt = /* @__PURE__ */ function() {
  function r(e, t) {
    Hs(this, r), "resume" in t && console.log("tus: The `resume` option has been removed in tus-js-client v2. Please use the URL storage API instead."), this.options = t, this.options.chunkSize = Number(this.options.chunkSize), this._urlStorage = this.options.urlStorage, this.file = e, this.url = null, this._req = null, this._fingerprint = null, this._urlStorageKey = null, this._offset = null, this._aborted = !1, this._size = null, this._source = null, this._retryAttempt = 0, this._retryTimeout = null, this._offsetBeforeRetry = 0, this._parallelUploads = null, this._parallelUploadUrls = null;
  }
  return js(r, [{
    key: "findPreviousUploads",
    value: function() {
      var t = this;
      return this.options.fingerprint(this.file, this.options).then(function(n) {
        return t._urlStorage.findUploadsByFingerprint(n);
      });
    }
  }, {
    key: "resumeFromPreviousUpload",
    value: function(t) {
      this.url = t.uploadUrl || null, this._parallelUploadUrls = t.parallelUploadUrls || null, this._urlStorageKey = t.urlStorageKey;
    }
  }, {
    key: "start",
    value: function() {
      var t = this, n = this.file;
      if (!n) {
        this._emitError(new Error("tus: no file or stream to upload provided"));
        return;
      }
      if (![Pt, Tt, We].includes(this.options.protocol)) {
        this._emitError(new Error("tus: unsupported protocol ".concat(this.options.protocol)));
        return;
      }
      if (!this.options.endpoint && !this.options.uploadUrl && !this.url) {
        this._emitError(new Error("tus: neither an endpoint or an upload URL is provided"));
        return;
      }
      var o = this.options.retryDelays;
      if (o != null && Object.prototype.toString.call(o) !== "[object Array]") {
        this._emitError(new Error("tus: the `retryDelays` option must either be an array or null"));
        return;
      }
      if (this.options.parallelUploads > 1)
        for (var i = 0, s = ["uploadUrl", "uploadSize", "uploadLengthDeferred"]; i < s.length; i++) {
          var l = s[i];
          if (this.options[l]) {
            this._emitError(new Error("tus: cannot use the ".concat(l, " option when parallelUploads is enabled")));
            return;
          }
        }
      if (this.options.parallelUploadBoundaries) {
        if (this.options.parallelUploads <= 1) {
          this._emitError(new Error("tus: cannot use the `parallelUploadBoundaries` option when `parallelUploads` is disabled"));
          return;
        }
        if (this.options.parallelUploads !== this.options.parallelUploadBoundaries.length) {
          this._emitError(new Error("tus: the `parallelUploadBoundaries` must have the same length as the value of `parallelUploads`"));
          return;
        }
      }
      this.options.fingerprint(n, this.options).then(function(u) {
        return t._fingerprint = u, t._source ? t._source : t.options.fileReader.openFile(n, t.options.chunkSize);
      }).then(function(u) {
        if (t._source = u, t.options.uploadLengthDeferred)
          t._size = null;
        else if (t.options.uploadSize != null) {
          if (t._size = Number(t.options.uploadSize), Number.isNaN(t._size)) {
            t._emitError(new Error("tus: cannot convert `uploadSize` option into a number"));
            return;
          }
        } else if (t._size = t._source.size, t._size == null) {
          t._emitError(new Error("tus: cannot automatically derive upload's size from input. Specify it manually using the `uploadSize` option or use the `uploadLengthDeferred` option"));
          return;
        }
        t.options.parallelUploads > 1 || t._parallelUploadUrls != null ? t._startParallelUpload() : t._startSingleUpload();
      }).catch(function(u) {
        t._emitError(u);
      });
    }
    /**
     * Initiate the uploading procedure for a parallelized upload, where one file is split into
     * multiple request which are run in parallel.
     *
     * @api private
     */
  }, {
    key: "_startParallelUpload",
    value: function() {
      var t, n = this, o = this._size, i = 0;
      this._parallelUploads = [];
      var s = this._parallelUploadUrls != null ? this._parallelUploadUrls.length : this.options.parallelUploads, l = (t = this.options.parallelUploadBoundaries) !== null && t !== void 0 ? t : Vs(this._source.size, s);
      this._parallelUploadUrls && l.forEach(function(d, S) {
        d.uploadUrl = n._parallelUploadUrls[S] || null;
      }), this._parallelUploadUrls = new Array(l.length);
      var u = l.map(function(d, S) {
        var R = 0;
        return n._source.slice(d.start, d.end).then(function(z) {
          var H = z.value;
          return new Promise(function(B, x) {
            var U = Ie(Ie({}, n.options), {}, {
              // If available, the partial upload should be resumed from a previous URL.
              uploadUrl: d.uploadUrl || null,
              // We take manually care of resuming for partial uploads, so they should
              // not be stored in the URL storage.
              storeFingerprintForResuming: !1,
              removeFingerprintOnSuccess: !1,
              // Reset the parallelUploads option to not cause recursion.
              parallelUploads: 1,
              // Reset this option as we are not doing a parallel upload.
              parallelUploadBoundaries: null,
              metadata: n.options.metadataForPartialUploads,
              // Add the header to indicate the this is a partial upload.
              headers: Ie(Ie({}, n.options.headers), {}, {
                "Upload-Concat": "partial"
              }),
              // Reject or resolve the promise if the upload errors or completes.
              onSuccess: B,
              onError: x,
              // Based in the progress for this partial upload, calculate the progress
              // for the entire final upload.
              onProgress: function(g) {
                i = i - R + g, R = g, n._emitProgress(i, o);
              },
              // Wait until every partial upload has an upload URL, so we can add
              // them to the URL storage.
              onUploadUrlAvailable: function() {
                n._parallelUploadUrls[S] = m.url, n._parallelUploadUrls.filter(function(g) {
                  return !!g;
                }).length === l.length && n._saveUploadInUrlStorage();
              }
            }), m = new r(H, U);
            m.start(), n._parallelUploads.push(m);
          });
        });
      }), p;
      Promise.all(u).then(function() {
        p = n._openRequest("POST", n.options.endpoint), p.setHeader("Upload-Concat", "final;".concat(n._parallelUploadUrls.join(" ")));
        var d = cn(n.options.metadata);
        return d !== "" && p.setHeader("Upload-Metadata", d), n._sendRequest(p, null);
      }).then(function(d) {
        if (!Ue(d.getStatus(), 200)) {
          n._emitHttpError(p, d, "tus: unexpected response while creating upload");
          return;
        }
        var S = d.getHeader("Location");
        if (S == null) {
          n._emitHttpError(p, d, "tus: invalid or missing Location header");
          return;
        }
        n.url = fn(n.options.endpoint, S), "Created upload at ".concat(n.url), n._emitSuccess(d);
      }).catch(function(d) {
        n._emitError(d);
      });
    }
    /**
     * Initiate the uploading procedure for a non-parallel upload. Here the entire file is
     * uploaded in a sequential matter.
     *
     * @api private
     */
  }, {
    key: "_startSingleUpload",
    value: function() {
      if (this._aborted = !1, this.url != null) {
        "Resuming upload from previous URL: ".concat(this.url), this._resumeUpload();
        return;
      }
      if (this.options.uploadUrl != null) {
        "Resuming upload from provided URL: ".concat(this.options.uploadUrl), this.url = this.options.uploadUrl, this._resumeUpload();
        return;
      }
      this._createUpload();
    }
    /**
     * Abort any running request and stop the current upload. After abort is called, no event
     * handler will be invoked anymore. You can use the `start` method to resume the upload
     * again.
     * If `shouldTerminate` is true, the `terminate` function will be called to remove the
     * current upload from the server.
     *
     * @param {boolean} shouldTerminate True if the upload should be deleted from the server.
     * @return {Promise} The Promise will be resolved/rejected when the requests finish.
     */
  }, {
    key: "abort",
    value: function(t) {
      var n = this;
      if (this._parallelUploads != null) {
        var o = qs(this._parallelUploads), i;
        try {
          for (o.s(); !(i = o.n()).done; ) {
            var s = i.value;
            s.abort(t);
          }
        } catch (l) {
          o.e(l);
        } finally {
          o.f();
        }
      }
      return this._req !== null && this._req.abort(), this._aborted = !0, this._retryTimeout != null && (clearTimeout(this._retryTimeout), this._retryTimeout = null), !t || this.url == null ? Promise.resolve() : r.terminate(this.url, this.options).then(function() {
        return n._removeFromUrlStorage();
      });
    }
  }, {
    key: "_emitHttpError",
    value: function(t, n, o, i) {
      this._emitError(new Ve(o, i, t, n));
    }
  }, {
    key: "_emitError",
    value: function(t) {
      var n = this;
      if (!this._aborted) {
        if (this.options.retryDelays != null) {
          var o = this._offset != null && this._offset > this._offsetBeforeRetry;
          if (o && (this._retryAttempt = 0), hn(t, this._retryAttempt, this.options)) {
            var i = this.options.retryDelays[this._retryAttempt++];
            this._offsetBeforeRetry = this._offset, this._retryTimeout = setTimeout(function() {
              n.start();
            }, i);
            return;
          }
        }
        if (typeof this.options.onError == "function")
          this.options.onError(t);
        else
          throw t;
      }
    }
    /**
     * Publishes notification if the upload has been successfully completed.
     *
     * @param {object} lastResponse Last HTTP response.
     * @api private
     */
  }, {
    key: "_emitSuccess",
    value: function(t) {
      this.options.removeFingerprintOnSuccess && this._removeFromUrlStorage(), typeof this.options.onSuccess == "function" && this.options.onSuccess({
        lastResponse: t
      });
    }
    /**
     * Publishes notification when data has been sent to the server. This
     * data may not have been accepted by the server yet.
     *
     * @param {number} bytesSent  Number of bytes sent to the server.
     * @param {number} bytesTotal Total number of bytes to be sent to the server.
     * @api private
     */
  }, {
    key: "_emitProgress",
    value: function(t, n) {
      typeof this.options.onProgress == "function" && this.options.onProgress(t, n);
    }
    /**
     * Publishes notification when a chunk of data has been sent to the server
     * and accepted by the server.
     * @param {number} chunkSize  Size of the chunk that was accepted by the server.
     * @param {number} bytesAccepted Total number of bytes that have been
     *                                accepted by the server.
     * @param {number} bytesTotal Total number of bytes to be sent to the server.
     * @api private
     */
  }, {
    key: "_emitChunkComplete",
    value: function(t, n, o) {
      typeof this.options.onChunkComplete == "function" && this.options.onChunkComplete(t, n, o);
    }
    /**
     * Create a new upload using the creation extension by sending a POST
     * request to the endpoint. After successful creation the file will be
     * uploaded
     *
     * @api private
     */
  }, {
    key: "_createUpload",
    value: function() {
      var t = this;
      if (!this.options.endpoint) {
        this._emitError(new Error("tus: unable to create upload because no endpoint is provided"));
        return;
      }
      var n = this._openRequest("POST", this.options.endpoint);
      this.options.uploadLengthDeferred ? n.setHeader("Upload-Defer-Length", "1") : n.setHeader("Upload-Length", "".concat(this._size));
      var o = cn(this.options.metadata);
      o !== "" && n.setHeader("Upload-Metadata", o);
      var i;
      this.options.uploadDataDuringCreation && !this.options.uploadLengthDeferred ? (this._offset = 0, i = this._addChunkToRequest(n)) : ((this.options.protocol === Tt || this.options.protocol === We) && n.setHeader("Upload-Complete", "?0"), i = this._sendRequest(n, null)), i.then(function(s) {
        if (!Ue(s.getStatus(), 200)) {
          t._emitHttpError(n, s, "tus: unexpected response while creating upload");
          return;
        }
        var l = s.getHeader("Location");
        if (l == null) {
          t._emitHttpError(n, s, "tus: invalid or missing Location header");
          return;
        }
        if (t.url = fn(t.options.endpoint, l), "Created upload at ".concat(t.url), typeof t.options.onUploadUrlAvailable == "function" && t.options.onUploadUrlAvailable(), t._size === 0) {
          t._emitSuccess(s), t._source.close();
          return;
        }
        t._saveUploadInUrlStorage().then(function() {
          t.options.uploadDataDuringCreation ? t._handleUploadResponse(n, s) : (t._offset = 0, t._performUpload());
        });
      }).catch(function(s) {
        t._emitHttpError(n, null, "tus: failed to create upload", s);
      });
    }
    /*
     * Try to resume an existing upload. First a HEAD request will be sent
     * to retrieve the offset. If the request fails a new upload will be
     * created. In the case of a successful response the file will be uploaded.
     *
     * @api private
     */
  }, {
    key: "_resumeUpload",
    value: function() {
      var t = this, n = this._openRequest("HEAD", this.url), o = this._sendRequest(n, null);
      o.then(function(i) {
        var s = i.getStatus();
        if (!Ue(s, 200)) {
          if (s === 423) {
            t._emitHttpError(n, i, "tus: upload is currently locked; retry later");
            return;
          }
          if (Ue(s, 400) && t._removeFromUrlStorage(), !t.options.endpoint) {
            t._emitHttpError(n, i, "tus: unable to resume upload (new upload cannot be created without an endpoint)");
            return;
          }
          t.url = null, t._createUpload();
          return;
        }
        var l = Number.parseInt(i.getHeader("Upload-Offset"), 10);
        if (Number.isNaN(l)) {
          t._emitHttpError(n, i, "tus: invalid or missing offset value");
          return;
        }
        var u = Number.parseInt(i.getHeader("Upload-Length"), 10);
        if (Number.isNaN(u) && !t.options.uploadLengthDeferred && t.options.protocol === Pt) {
          t._emitHttpError(n, i, "tus: invalid or missing length value");
          return;
        }
        typeof t.options.onUploadUrlAvailable == "function" && t.options.onUploadUrlAvailable(), t._saveUploadInUrlStorage().then(function() {
          if (l === u) {
            t._emitProgress(u, u), t._emitSuccess(i);
            return;
          }
          t._offset = l, t._performUpload();
        });
      }).catch(function(i) {
        t._emitHttpError(n, null, "tus: failed to resume upload", i);
      });
    }
    /**
     * Start uploading the file using PATCH requests. The file will be divided
     * into chunks as specified in the chunkSize option. During the upload
     * the onProgress event handler may be invoked multiple times.
     *
     * @api private
     */
  }, {
    key: "_performUpload",
    value: function() {
      var t = this;
      if (!this._aborted) {
        var n;
        this.options.overridePatchMethod ? (n = this._openRequest("POST", this.url), n.setHeader("X-HTTP-Method-Override", "PATCH")) : n = this._openRequest("PATCH", this.url), n.setHeader("Upload-Offset", "".concat(this._offset));
        var o = this._addChunkToRequest(n);
        o.then(function(i) {
          if (!Ue(i.getStatus(), 200)) {
            t._emitHttpError(n, i, "tus: unexpected response while uploading chunk");
            return;
          }
          t._handleUploadResponse(n, i);
        }).catch(function(i) {
          t._aborted || t._emitHttpError(n, null, "tus: failed to upload chunk at offset ".concat(t._offset), i);
        });
      }
    }
    /**
     * _addChunktoRequest reads a chunk from the source and sends it using the
     * supplied request object. It will not handle the response.
     *
     * @api private
     */
  }, {
    key: "_addChunkToRequest",
    value: function(t) {
      var n = this, o = this._offset, i = this._offset + this.options.chunkSize;
      return t.setProgressHandler(function(s) {
        n._emitProgress(o + s, n._size);
      }), this.options.protocol === Pt ? t.setHeader("Content-Type", "application/offset+octet-stream") : this.options.protocol === We && t.setHeader("Content-Type", "application/partial-upload"), (i === Number.POSITIVE_INFINITY || i > this._size) && !this.options.uploadLengthDeferred && (i = this._size), this._source.slice(o, i).then(function(s) {
        var l = s.value, u = s.done, p = l != null && l.size ? l.size : 0;
        n.options.uploadLengthDeferred && u && (n._size = n._offset + p, t.setHeader("Upload-Length", "".concat(n._size)));
        var d = n._offset + p;
        return !n.options.uploadLengthDeferred && u && d !== n._size ? Promise.reject(new Error("upload was configured with a size of ".concat(n._size, " bytes, but the source is done after ").concat(d, " bytes"))) : l === null ? n._sendRequest(t) : ((n.options.protocol === Tt || n.options.protocol === We) && t.setHeader("Upload-Complete", u ? "?1" : "?0"), n._emitProgress(n._offset, n._size), n._sendRequest(t, l));
      });
    }
    /**
     * _handleUploadResponse is used by requests that haven been sent using _addChunkToRequest
     * and already have received a response.
     *
     * @api private
     */
  }, {
    key: "_handleUploadResponse",
    value: function(t, n) {
      var o = Number.parseInt(n.getHeader("Upload-Offset"), 10);
      if (Number.isNaN(o)) {
        this._emitHttpError(t, n, "tus: invalid or missing offset value");
        return;
      }
      if (this._emitProgress(o, this._size), this._emitChunkComplete(o - this._offset, o, this._size), this._offset = o, o === this._size) {
        this._emitSuccess(n), this._source.close();
        return;
      }
      this._performUpload();
    }
    /**
     * Create a new HTTP request object with the given method and URL.
     *
     * @api private
     */
  }, {
    key: "_openRequest",
    value: function(t, n) {
      var o = un(t, n, this.options);
      return this._req = o, o;
    }
    /**
     * Remove the entry in the URL storage, if it has been saved before.
     *
     * @api private
     */
  }, {
    key: "_removeFromUrlStorage",
    value: function() {
      var t = this;
      this._urlStorageKey && (this._urlStorage.removeUpload(this._urlStorageKey).catch(function(n) {
        t._emitError(n);
      }), this._urlStorageKey = null);
    }
    /**
     * Add the upload URL to the URL storage, if possible.
     *
     * @api private
     */
  }, {
    key: "_saveUploadInUrlStorage",
    value: function() {
      var t = this;
      if (!this.options.storeFingerprintForResuming || !this._fingerprint || this._urlStorageKey !== null)
        return Promise.resolve();
      var n = {
        size: this._size,
        metadata: this.options.metadata,
        creationTime: (/* @__PURE__ */ new Date()).toString()
      };
      return this._parallelUploads ? n.parallelUploadUrls = this._parallelUploadUrls : n.uploadUrl = this.url, this._urlStorage.addUpload(this._fingerprint, n).then(function(o) {
        t._urlStorageKey = o;
      });
    }
    /**
     * Send a request with the provided body.
     *
     * @api private
     */
  }, {
    key: "_sendRequest",
    value: function(t) {
      var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
      return ln(t, n, this.options);
    }
  }], [{
    key: "terminate",
    value: function(t) {
      var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, o = un("DELETE", t, n);
      return ln(o, null, n).then(function(i) {
        if (i.getStatus() !== 204)
          throw new Ve("tus: unexpected response while terminating upload", null, o, i);
      }).catch(function(i) {
        if (i instanceof Ve || (i = new Ve("tus: failed to terminate upload", i, o, null)), !hn(i, 0, n))
          throw i;
        var s = n.retryDelays[0], l = n.retryDelays.slice(1), u = Ie(Ie({}, n), {}, {
          retryDelays: l
        });
        return new Promise(function(p) {
          return setTimeout(p, s);
        }).then(function() {
          return r.terminate(t, u);
        });
      });
    }
  }]);
}();
function cn(r) {
  return Object.entries(r).map(function(e) {
    var t = uo(e, 2), n = t[0], o = t[1];
    return "".concat(n, " ").concat(Us.encode(String(o)));
  }).join(",");
}
function Ue(r, e) {
  return r >= e && r < e + 100;
}
function un(r, e, t) {
  var n = t.httpStack.createRequest(r, e);
  t.protocol === Tt ? n.setHeader("Upload-Draft-Interop-Version", "5") : t.protocol === We ? n.setHeader("Upload-Draft-Interop-Version", "6") : n.setHeader("Tus-Resumable", "1.0.0");
  for (var o = t.headers || {}, i = 0, s = Object.entries(o); i < s.length; i++) {
    var l = uo(s[i], 2), u = l[0], p = l[1];
    n.setHeader(u, p);
  }
  if (t.addRequestId) {
    var d = Ts();
    n.setHeader("X-Request-ID", d);
  }
  return n;
}
function ln(r, e, t) {
  return yr.apply(this, arguments);
}
function yr() {
  return yr = Fs(/* @__PURE__ */ gr().mark(function r(e, t, n) {
    var o;
    return gr().wrap(function(s) {
      for (; ; ) switch (s.prev = s.next) {
        case 0:
          if (typeof n.onBeforeRequest != "function") {
            s.next = 3;
            break;
          }
          return s.next = 3, n.onBeforeRequest(e);
        case 3:
          return s.next = 5, e.send(t);
        case 5:
          if (o = s.sent, typeof n.onAfterResponse != "function") {
            s.next = 9;
            break;
          }
          return s.next = 9, n.onAfterResponse(e, o);
        case 9:
          return s.abrupt("return", o);
        case 10:
        case "end":
          return s.stop();
      }
    }, r);
  })), yr.apply(this, arguments);
}
function $s() {
  var r = !0;
  return typeof navigator < "u" && navigator.onLine === !1 && (r = !1), r;
}
function hn(r, e, t) {
  return t.retryDelays == null || e >= t.retryDelays.length || r.originalRequest == null ? !1 : t && typeof t.onShouldRetry == "function" ? t.onShouldRetry(r, e, t) : fo(r);
}
function fo(r) {
  var e = r.originalResponse ? r.originalResponse.getStatus() : 0;
  return (!Ue(e, 400) || e === 409 || e === 423) && $s();
}
function fn(r, e) {
  return new Ps(e, r).toString();
}
function Vs(r, e) {
  for (var t = Math.floor(r / e), n = [], o = 0; o < e; o++)
    n.push({
      start: t * o,
      end: t * (o + 1)
    });
  return n[e - 1].end = r, n;
}
Qt.defaultOptions = Ms;
var po = function() {
  return typeof navigator < "u" && typeof navigator.product == "string" && navigator.product.toLowerCase() === "reactnative";
};
function Gs(r) {
  return new Promise(function(e, t) {
    var n = new XMLHttpRequest();
    n.responseType = "blob", n.onload = function() {
      var o = n.response;
      e(o);
    }, n.onerror = function(o) {
      t(o);
    }, n.open("GET", r), n.send();
  });
}
var Ws = function() {
  return typeof window < "u" && (typeof window.PhoneGap < "u" || typeof window.Cordova < "u" || typeof window.cordova < "u");
};
function Js(r) {
  return new Promise(function(e, t) {
    var n = new FileReader();
    n.onload = function() {
      var o = new Uint8Array(n.result);
      e({
        value: o
      });
    }, n.onerror = function(o) {
      t(o);
    }, n.readAsArrayBuffer(r);
  });
}
function Ze(r) {
  "@babel/helpers - typeof";
  return Ze = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Ze(r);
}
function Xs(r, e) {
  if (!(r instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function Ks(r, e) {
  for (var t = 0; t < e.length; t++) {
    var n = e[t];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(r, Zs(n.key), n);
  }
}
function Ys(r, e, t) {
  return e && Ks(r.prototype, e), Object.defineProperty(r, "prototype", { writable: !1 }), r;
}
function Zs(r) {
  var e = ea(r, "string");
  return Ze(e) == "symbol" ? e : e + "";
}
function ea(r, e) {
  if (Ze(r) != "object" || !r) return r;
  var t = r[Symbol.toPrimitive];
  if (t !== void 0) {
    var n = t.call(r, e);
    if (Ze(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(r);
}
var pn = /* @__PURE__ */ function() {
  function r(e) {
    Xs(this, r), this._file = e, this.size = e.size;
  }
  return Ys(r, [{
    key: "slice",
    value: function(t, n) {
      if (Ws())
        return Js(this._file.slice(t, n));
      var o = this._file.slice(t, n), i = n >= this.size;
      return Promise.resolve({
        value: o,
        done: i
      });
    }
  }, {
    key: "close",
    value: function() {
    }
  }]);
}();
function et(r) {
  "@babel/helpers - typeof";
  return et = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, et(r);
}
function ta(r, e) {
  if (!(r instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function ra(r, e) {
  for (var t = 0; t < e.length; t++) {
    var n = e[t];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(r, oa(n.key), n);
  }
}
function na(r, e, t) {
  return e && ra(r.prototype, e), Object.defineProperty(r, "prototype", { writable: !1 }), r;
}
function oa(r) {
  var e = ia(r, "string");
  return et(e) == "symbol" ? e : e + "";
}
function ia(r, e) {
  if (et(r) != "object" || !r) return r;
  var t = r[Symbol.toPrimitive];
  if (t !== void 0) {
    var n = t.call(r, e);
    if (et(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(r);
}
function dn(r) {
  return r === void 0 ? 0 : r.size !== void 0 ? r.size : r.length;
}
function sa(r, e) {
  if (r.concat)
    return r.concat(e);
  if (r instanceof Blob)
    return new Blob([r, e], {
      type: r.type
    });
  if (r.set) {
    var t = new r.constructor(r.length + e.length);
    return t.set(r), t.set(e, r.length), t;
  }
  throw new Error("Unknown data type");
}
var aa = /* @__PURE__ */ function() {
  function r(e) {
    ta(this, r), this._buffer = void 0, this._bufferOffset = 0, this._reader = e, this._done = !1;
  }
  return na(r, [{
    key: "slice",
    value: function(t, n) {
      return t < this._bufferOffset ? Promise.reject(new Error("Requested data is before the reader's current offset")) : this._readUntilEnoughDataOrDone(t, n);
    }
  }, {
    key: "_readUntilEnoughDataOrDone",
    value: function(t, n) {
      var o = this, i = n <= this._bufferOffset + dn(this._buffer);
      if (this._done || i) {
        var s = this._getDataFromBuffer(t, n), l = s == null ? this._done : !1;
        return Promise.resolve({
          value: s,
          done: l
        });
      }
      return this._reader.read().then(function(u) {
        var p = u.value, d = u.done;
        return d ? o._done = !0 : o._buffer === void 0 ? o._buffer = p : o._buffer = sa(o._buffer, p), o._readUntilEnoughDataOrDone(t, n);
      });
    }
  }, {
    key: "_getDataFromBuffer",
    value: function(t, n) {
      t > this._bufferOffset && (this._buffer = this._buffer.slice(t - this._bufferOffset), this._bufferOffset = t);
      var o = dn(this._buffer) === 0;
      return this._done && o ? null : this._buffer.slice(0, n - t);
    }
  }, {
    key: "close",
    value: function() {
      this._reader.cancel && this._reader.cancel();
    }
  }]);
}();
function Be(r) {
  "@babel/helpers - typeof";
  return Be = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Be(r);
}
function mr() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
  mr = function() {
    return e;
  };
  var r, e = {}, t = Object.prototype, n = t.hasOwnProperty, o = Object.defineProperty || function(f, c, h) {
    f[c] = h.value;
  }, i = typeof Symbol == "function" ? Symbol : {}, s = i.iterator || "@@iterator", l = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag";
  function p(f, c, h) {
    return Object.defineProperty(f, c, { value: h, enumerable: !0, configurable: !0, writable: !0 }), f[c];
  }
  try {
    p({}, "");
  } catch {
    p = function(h, v, w) {
      return h[v] = w;
    };
  }
  function d(f, c, h, v) {
    var w = c && c.prototype instanceof U ? c : U, b = Object.create(w.prototype), F = new ce(v || []);
    return o(b, "_invoke", { value: V(f, h, F) }), b;
  }
  function S(f, c, h) {
    try {
      return { type: "normal", arg: f.call(c, h) };
    } catch (v) {
      return { type: "throw", arg: v };
    }
  }
  e.wrap = d;
  var R = "suspendedStart", z = "suspendedYield", H = "executing", B = "completed", x = {};
  function U() {
  }
  function m() {
  }
  function A() {
  }
  var g = {};
  p(g, s, function() {
    return this;
  });
  var y = Object.getPrototypeOf, E = y && y(y(ye([])));
  E && E !== t && n.call(E, s) && (g = E);
  var _ = A.prototype = U.prototype = Object.create(g);
  function P(f) {
    ["next", "throw", "return"].forEach(function(c) {
      p(f, c, function(h) {
        return this._invoke(c, h);
      });
    });
  }
  function O(f, c) {
    function h(w, b, F, j) {
      var M = S(f[w], f, b);
      if (M.type !== "throw") {
        var se = M.arg, te = se.value;
        return te && Be(te) == "object" && n.call(te, "__await") ? c.resolve(te.__await).then(function(ae) {
          h("next", ae, F, j);
        }, function(ae) {
          h("throw", ae, F, j);
        }) : c.resolve(te).then(function(ae) {
          se.value = ae, F(se);
        }, function(ae) {
          return h("throw", ae, F, j);
        });
      }
      j(M.arg);
    }
    var v;
    o(this, "_invoke", { value: function(b, F) {
      function j() {
        return new c(function(M, se) {
          h(b, F, M, se);
        });
      }
      return v = v ? v.then(j, j) : j();
    } });
  }
  function V(f, c, h) {
    var v = R;
    return function(w, b) {
      if (v === H) throw Error("Generator is already running");
      if (v === B) {
        if (w === "throw") throw b;
        return { value: r, done: !0 };
      }
      for (h.method = w, h.arg = b; ; ) {
        var F = h.delegate;
        if (F) {
          var j = N(F, h);
          if (j) {
            if (j === x) continue;
            return j;
          }
        }
        if (h.method === "next") h.sent = h._sent = h.arg;
        else if (h.method === "throw") {
          if (v === R) throw v = B, h.arg;
          h.dispatchException(h.arg);
        } else h.method === "return" && h.abrupt("return", h.arg);
        v = H;
        var M = S(f, c, h);
        if (M.type === "normal") {
          if (v = h.done ? B : z, M.arg === x) continue;
          return { value: M.arg, done: h.done };
        }
        M.type === "throw" && (v = B, h.method = "throw", h.arg = M.arg);
      }
    };
  }
  function N(f, c) {
    var h = c.method, v = f.iterator[h];
    if (v === r) return c.delegate = null, h === "throw" && f.iterator.return && (c.method = "return", c.arg = r, N(f, c), c.method === "throw") || h !== "return" && (c.method = "throw", c.arg = new TypeError("The iterator does not provide a '" + h + "' method")), x;
    var w = S(v, f.iterator, c.arg);
    if (w.type === "throw") return c.method = "throw", c.arg = w.arg, c.delegate = null, x;
    var b = w.arg;
    return b ? b.done ? (c[f.resultName] = b.value, c.next = f.nextLoc, c.method !== "return" && (c.method = "next", c.arg = r), c.delegate = null, x) : b : (c.method = "throw", c.arg = new TypeError("iterator result is not an object"), c.delegate = null, x);
  }
  function G(f) {
    var c = { tryLoc: f[0] };
    1 in f && (c.catchLoc = f[1]), 2 in f && (c.finallyLoc = f[2], c.afterLoc = f[3]), this.tryEntries.push(c);
  }
  function I(f) {
    var c = f.completion || {};
    c.type = "normal", delete c.arg, f.completion = c;
  }
  function ce(f) {
    this.tryEntries = [{ tryLoc: "root" }], f.forEach(G, this), this.reset(!0);
  }
  function ye(f) {
    if (f || f === "") {
      var c = f[s];
      if (c) return c.call(f);
      if (typeof f.next == "function") return f;
      if (!isNaN(f.length)) {
        var h = -1, v = function w() {
          for (; ++h < f.length; ) if (n.call(f, h)) return w.value = f[h], w.done = !1, w;
          return w.value = r, w.done = !0, w;
        };
        return v.next = v;
      }
    }
    throw new TypeError(Be(f) + " is not iterable");
  }
  return m.prototype = A, o(_, "constructor", { value: A, configurable: !0 }), o(A, "constructor", { value: m, configurable: !0 }), m.displayName = p(A, u, "GeneratorFunction"), e.isGeneratorFunction = function(f) {
    var c = typeof f == "function" && f.constructor;
    return !!c && (c === m || (c.displayName || c.name) === "GeneratorFunction");
  }, e.mark = function(f) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(f, A) : (f.__proto__ = A, p(f, u, "GeneratorFunction")), f.prototype = Object.create(_), f;
  }, e.awrap = function(f) {
    return { __await: f };
  }, P(O.prototype), p(O.prototype, l, function() {
    return this;
  }), e.AsyncIterator = O, e.async = function(f, c, h, v, w) {
    w === void 0 && (w = Promise);
    var b = new O(d(f, c, h, v), w);
    return e.isGeneratorFunction(c) ? b : b.next().then(function(F) {
      return F.done ? F.value : b.next();
    });
  }, P(_), p(_, u, "Generator"), p(_, s, function() {
    return this;
  }), p(_, "toString", function() {
    return "[object Generator]";
  }), e.keys = function(f) {
    var c = Object(f), h = [];
    for (var v in c) h.push(v);
    return h.reverse(), function w() {
      for (; h.length; ) {
        var b = h.pop();
        if (b in c) return w.value = b, w.done = !1, w;
      }
      return w.done = !0, w;
    };
  }, e.values = ye, ce.prototype = { constructor: ce, reset: function(c) {
    if (this.prev = 0, this.next = 0, this.sent = this._sent = r, this.done = !1, this.delegate = null, this.method = "next", this.arg = r, this.tryEntries.forEach(I), !c) for (var h in this) h.charAt(0) === "t" && n.call(this, h) && !isNaN(+h.slice(1)) && (this[h] = r);
  }, stop: function() {
    this.done = !0;
    var c = this.tryEntries[0].completion;
    if (c.type === "throw") throw c.arg;
    return this.rval;
  }, dispatchException: function(c) {
    if (this.done) throw c;
    var h = this;
    function v(se, te) {
      return F.type = "throw", F.arg = c, h.next = se, te && (h.method = "next", h.arg = r), !!te;
    }
    for (var w = this.tryEntries.length - 1; w >= 0; --w) {
      var b = this.tryEntries[w], F = b.completion;
      if (b.tryLoc === "root") return v("end");
      if (b.tryLoc <= this.prev) {
        var j = n.call(b, "catchLoc"), M = n.call(b, "finallyLoc");
        if (j && M) {
          if (this.prev < b.catchLoc) return v(b.catchLoc, !0);
          if (this.prev < b.finallyLoc) return v(b.finallyLoc);
        } else if (j) {
          if (this.prev < b.catchLoc) return v(b.catchLoc, !0);
        } else {
          if (!M) throw Error("try statement without catch or finally");
          if (this.prev < b.finallyLoc) return v(b.finallyLoc);
        }
      }
    }
  }, abrupt: function(c, h) {
    for (var v = this.tryEntries.length - 1; v >= 0; --v) {
      var w = this.tryEntries[v];
      if (w.tryLoc <= this.prev && n.call(w, "finallyLoc") && this.prev < w.finallyLoc) {
        var b = w;
        break;
      }
    }
    b && (c === "break" || c === "continue") && b.tryLoc <= h && h <= b.finallyLoc && (b = null);
    var F = b ? b.completion : {};
    return F.type = c, F.arg = h, b ? (this.method = "next", this.next = b.finallyLoc, x) : this.complete(F);
  }, complete: function(c, h) {
    if (c.type === "throw") throw c.arg;
    return c.type === "break" || c.type === "continue" ? this.next = c.arg : c.type === "return" ? (this.rval = this.arg = c.arg, this.method = "return", this.next = "end") : c.type === "normal" && h && (this.next = h), x;
  }, finish: function(c) {
    for (var h = this.tryEntries.length - 1; h >= 0; --h) {
      var v = this.tryEntries[h];
      if (v.finallyLoc === c) return this.complete(v.completion, v.afterLoc), I(v), x;
    }
  }, catch: function(c) {
    for (var h = this.tryEntries.length - 1; h >= 0; --h) {
      var v = this.tryEntries[h];
      if (v.tryLoc === c) {
        var w = v.completion;
        if (w.type === "throw") {
          var b = w.arg;
          I(v);
        }
        return b;
      }
    }
    throw Error("illegal catch attempt");
  }, delegateYield: function(c, h, v) {
    return this.delegate = { iterator: ye(c), resultName: h, nextLoc: v }, this.method === "next" && (this.arg = r), x;
  } }, e;
}
function gn(r, e, t, n, o, i, s) {
  try {
    var l = r[i](s), u = l.value;
  } catch (p) {
    t(p);
    return;
  }
  l.done ? e(u) : Promise.resolve(u).then(n, o);
}
function ca(r) {
  return function() {
    var e = this, t = arguments;
    return new Promise(function(n, o) {
      var i = r.apply(e, t);
      function s(u) {
        gn(i, n, o, s, l, "next", u);
      }
      function l(u) {
        gn(i, n, o, s, l, "throw", u);
      }
      s(void 0);
    });
  };
}
function ua(r, e) {
  if (!(r instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function la(r, e) {
  for (var t = 0; t < e.length; t++) {
    var n = e[t];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(r, fa(n.key), n);
  }
}
function ha(r, e, t) {
  return e && la(r.prototype, e), Object.defineProperty(r, "prototype", { writable: !1 }), r;
}
function fa(r) {
  var e = pa(r, "string");
  return Be(e) == "symbol" ? e : e + "";
}
function pa(r, e) {
  if (Be(r) != "object" || !r) return r;
  var t = r[Symbol.toPrimitive];
  if (t !== void 0) {
    var n = t.call(r, e);
    if (Be(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(r);
}
var da = /* @__PURE__ */ function() {
  function r() {
    ua(this, r);
  }
  return ha(r, [{
    key: "openFile",
    value: function() {
      var e = ca(/* @__PURE__ */ mr().mark(function n(o, i) {
        var s;
        return mr().wrap(function(u) {
          for (; ; ) switch (u.prev = u.next) {
            case 0:
              if (!(po() && o && typeof o.uri < "u")) {
                u.next = 11;
                break;
              }
              return u.prev = 1, u.next = 4, Gs(o.uri);
            case 4:
              return s = u.sent, u.abrupt("return", new pn(s));
            case 8:
              throw u.prev = 8, u.t0 = u.catch(1), new Error("tus: cannot fetch `file.uri` as Blob, make sure the uri is correct and accessible. ".concat(u.t0));
            case 11:
              if (!(typeof o.slice == "function" && typeof o.size < "u")) {
                u.next = 13;
                break;
              }
              return u.abrupt("return", Promise.resolve(new pn(o)));
            case 13:
              if (typeof o.read != "function") {
                u.next = 18;
                break;
              }
              if (i = Number(i), Number.isFinite(i)) {
                u.next = 17;
                break;
              }
              return u.abrupt("return", Promise.reject(new Error("cannot create source for stream without a finite value for the `chunkSize` option")));
            case 17:
              return u.abrupt("return", Promise.resolve(new aa(o, i)));
            case 18:
              return u.abrupt("return", Promise.reject(new Error("source object may only be an instance of File, Blob, or Reader in this environment")));
            case 19:
            case "end":
              return u.stop();
          }
        }, n, null, [[1, 8]]);
      }));
      function t(n, o) {
        return e.apply(this, arguments);
      }
      return t;
    }()
  }]);
}();
function ga(r, e) {
  return po() ? Promise.resolve(ya(r, e)) : Promise.resolve(["tus-br", r.name, r.type, r.size, r.lastModified, e.endpoint].join("-"));
}
function ya(r, e) {
  var t = r.exif ? ma(JSON.stringify(r.exif)) : "noexif";
  return ["tus-rn", r.name || "noname", r.size || "nosize", t, e.endpoint].join("/");
}
function ma(r) {
  var e = 0;
  if (r.length === 0)
    return e;
  for (var t = 0; t < r.length; t++) {
    var n = r.charCodeAt(t);
    e = (e << 5) - e + n, e &= e;
  }
  return e;
}
function tt(r) {
  "@babel/helpers - typeof";
  return tt = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, tt(r);
}
function xr(r, e) {
  if (!(r instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function Aa(r, e) {
  for (var t = 0; t < e.length; t++) {
    var n = e[t];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(r, va(n.key), n);
  }
}
function Or(r, e, t) {
  return e && Aa(r.prototype, e), Object.defineProperty(r, "prototype", { writable: !1 }), r;
}
function va(r) {
  var e = ba(r, "string");
  return tt(e) == "symbol" ? e : e + "";
}
function ba(r, e) {
  if (tt(r) != "object" || !r) return r;
  var t = r[Symbol.toPrimitive];
  if (t !== void 0) {
    var n = t.call(r, e);
    if (tt(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(r);
}
var wa = /* @__PURE__ */ function() {
  function r() {
    xr(this, r);
  }
  return Or(r, [{
    key: "createRequest",
    value: function(t, n) {
      return new _a(t, n);
    }
  }, {
    key: "getName",
    value: function() {
      return "XHRHttpStack";
    }
  }]);
}(), _a = /* @__PURE__ */ function() {
  function r(e, t) {
    xr(this, r), this._xhr = new XMLHttpRequest(), this._xhr.open(e, t, !0), this._method = e, this._url = t, this._headers = {};
  }
  return Or(r, [{
    key: "getMethod",
    value: function() {
      return this._method;
    }
  }, {
    key: "getURL",
    value: function() {
      return this._url;
    }
  }, {
    key: "setHeader",
    value: function(t, n) {
      this._xhr.setRequestHeader(t, n), this._headers[t] = n;
    }
  }, {
    key: "getHeader",
    value: function(t) {
      return this._headers[t];
    }
  }, {
    key: "setProgressHandler",
    value: function(t) {
      "upload" in this._xhr && (this._xhr.upload.onprogress = function(n) {
        n.lengthComputable && t(n.loaded);
      });
    }
  }, {
    key: "send",
    value: function() {
      var t = this, n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
      return new Promise(function(o, i) {
        t._xhr.onload = function() {
          o(new Ea(t._xhr));
        }, t._xhr.onerror = function(s) {
          i(s);
        }, t._xhr.send(n);
      });
    }
  }, {
    key: "abort",
    value: function() {
      return this._xhr.abort(), Promise.resolve();
    }
  }, {
    key: "getUnderlyingObject",
    value: function() {
      return this._xhr;
    }
  }]);
}(), Ea = /* @__PURE__ */ function() {
  function r(e) {
    xr(this, r), this._xhr = e;
  }
  return Or(r, [{
    key: "getStatus",
    value: function() {
      return this._xhr.status;
    }
  }, {
    key: "getHeader",
    value: function(t) {
      return this._xhr.getResponseHeader(t);
    }
  }, {
    key: "getBody",
    value: function() {
      return this._xhr.responseText;
    }
  }, {
    key: "getUnderlyingObject",
    value: function() {
      return this._xhr;
    }
  }]);
}();
function rt(r) {
  "@babel/helpers - typeof";
  return rt = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, rt(r);
}
function Sa(r, e) {
  if (!(r instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function Ba(r, e) {
  for (var t = 0; t < e.length; t++) {
    var n = e[t];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(r, ka(n.key), n);
  }
}
function Ia(r, e, t) {
  return e && Ba(r.prototype, e), Object.defineProperty(r, "prototype", { writable: !1 }), r;
}
function ka(r) {
  var e = Ua(r, "string");
  return rt(e) == "symbol" ? e : e + "";
}
function Ua(r, e) {
  if (rt(r) != "object" || !r) return r;
  var t = r[Symbol.toPrimitive];
  if (t !== void 0) {
    var n = t.call(r, e);
    if (rt(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(r);
}
var Ar = !1;
try {
  Ar = "localStorage" in window;
  var Zt = "tusSupport", yn = localStorage.getItem(Zt);
  localStorage.setItem(Zt, yn), yn === null && localStorage.removeItem(Zt);
} catch (r) {
  if (r.code === r.SECURITY_ERR || r.code === r.QUOTA_EXCEEDED_ERR)
    Ar = !1;
  else
    throw r;
}
var Ca = Ar, Ra = /* @__PURE__ */ function() {
  function r() {
    Sa(this, r);
  }
  return Ia(r, [{
    key: "findAllUploads",
    value: function() {
      var t = this._findEntries("tus::");
      return Promise.resolve(t);
    }
  }, {
    key: "findUploadsByFingerprint",
    value: function(t) {
      var n = this._findEntries("tus::".concat(t, "::"));
      return Promise.resolve(n);
    }
  }, {
    key: "removeUpload",
    value: function(t) {
      return localStorage.removeItem(t), Promise.resolve();
    }
  }, {
    key: "addUpload",
    value: function(t, n) {
      var o = Math.round(Math.random() * 1e12), i = "tus::".concat(t, "::").concat(o);
      return localStorage.setItem(i, JSON.stringify(n)), Promise.resolve(i);
    }
  }, {
    key: "_findEntries",
    value: function(t) {
      for (var n = [], o = 0; o < localStorage.length; o++) {
        var i = localStorage.key(o);
        if (i.indexOf(t) === 0)
          try {
            var s = JSON.parse(localStorage.getItem(i));
            s.urlStorageKey = i, n.push(s);
          } catch {
          }
      }
      return n;
    }
  }]);
}();
function Ne(r) {
  "@babel/helpers - typeof";
  return Ne = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Ne(r);
}
function xa(r, e) {
  if (!(r instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function Oa(r, e) {
  for (var t = 0; t < e.length; t++) {
    var n = e[t];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(r, yo(n.key), n);
  }
}
function Pa(r, e, t) {
  return t && Oa(r, t), Object.defineProperty(r, "prototype", { writable: !1 }), r;
}
function Ta(r, e, t) {
  return e = qt(e), Fa(r, go() ? Reflect.construct(e, t || [], qt(r).constructor) : e.apply(r, t));
}
function Fa(r, e) {
  if (e && (Ne(e) === "object" || typeof e == "function"))
    return e;
  if (e !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return La(r);
}
function La(r) {
  if (r === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return r;
}
function go() {
  try {
    var r = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (go = function() {
    return !!r;
  })();
}
function qt(r) {
  return qt = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, qt(r);
}
function Na(r, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  r.prototype = Object.create(e && e.prototype, { constructor: { value: r, writable: !0, configurable: !0 } }), Object.defineProperty(r, "prototype", { writable: !1 }), e && vr(r, e);
}
function vr(r, e) {
  return vr = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, o) {
    return n.__proto__ = o, n;
  }, vr(r, e);
}
function mn(r, e) {
  var t = Object.keys(r);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(r);
    e && (n = n.filter(function(o) {
      return Object.getOwnPropertyDescriptor(r, o).enumerable;
    })), t.push.apply(t, n);
  }
  return t;
}
function Re(r) {
  for (var e = 1; e < arguments.length; e++) {
    var t = arguments[e] != null ? arguments[e] : {};
    e % 2 ? mn(Object(t), !0).forEach(function(n) {
      Qa(r, n, t[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(r, Object.getOwnPropertyDescriptors(t)) : mn(Object(t)).forEach(function(n) {
      Object.defineProperty(r, n, Object.getOwnPropertyDescriptor(t, n));
    });
  }
  return r;
}
function Qa(r, e, t) {
  return e = yo(e), e in r ? Object.defineProperty(r, e, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : r[e] = t, r;
}
function yo(r) {
  var e = qa(r, "string");
  return Ne(e) == "symbol" ? e : e + "";
}
function qa(r, e) {
  if (Ne(r) != "object" || !r) return r;
  var t = r[Symbol.toPrimitive];
  if (t !== void 0) {
    var n = t.call(r, e);
    if (Ne(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(r);
}
var An = Re(Re({}, Qt.defaultOptions), {}, {
  httpStack: new wa(),
  fileReader: new da(),
  urlStorage: Ca ? new Ra() : new ms(),
  fingerprint: ga
}), Da = /* @__PURE__ */ function(r) {
  function e() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null, n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return xa(this, e), n = Re(Re({}, An), n), Ta(this, e, [t, n]);
  }
  return Na(e, r), Pa(e, null, [{
    key: "terminate",
    value: function(n) {
      var o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      return o = Re(Re({}, An), o), Qt.terminate(n, o);
    }
  }]);
}(Qt);
const _t = "/api/1/asset/assets", Ha = "/api/1/bfg/files/", ja = "BOSS_S3_MULTIPART", za = 7 * 24 * 60 * 60 * 1e3, mo = "X-Api-Correlation-Id";
function Et(r) {
  if (!r.ok)
    throw new Error(r.statusText);
  return r;
}
function Ma({
  isPublic: r,
  getAuthorizationToken: e
}) {
  async function t() {
    const u = {
      "Content-Type": "application/json"
    };
    return !r && e && (u.Authorization = `Bearer ${await (e == null ? void 0 : e())}`), u;
  }
  async function n(u, p) {
    const d = await t();
    return await fetch(_t, {
      method: "POST",
      headers: d,
      body: JSON.stringify({ assetId: u, origin: p })
    }).then(Et).then((R) => R.json());
  }
  async function o(u, p) {
    const d = `${_t}/${u.assetId}/versions/${u.activeVersion.versionId}/upload_url`, S = await t(), R = JSON.stringify({
      storageObjectId: p,
      storageStrategy: ja
    });
    return await fetch(d, {
      method: "POST",
      headers: S,
      body: R
    }).then(Et).then((H) => H.json());
  }
  async function i(u, p, d) {
    const S = await n(u, d);
    return { uploadUrl: await o(S, p), asset: S };
  }
  async function s(u, p) {
    const d = `${_t}/${u}/versions/${p}/metadata_extraction`, S = await t();
    return fetch(d, {
      method: "POST",
      headers: S
    }).then(Et);
  }
  async function l(u, p) {
    var H;
    const d = `${_t}/${u}/versions/${p}/thumbnails`, S = await t();
    return (H = (await fetch(d, {
      method: "GET",
      headers: S
    }).then(Et).then((B) => B.json())).thumbnails.find(
      ({ name: B }) => B === "thul"
    )) == null ? void 0 : H.thumbnailUrl;
  }
  return { createAsset: i, triggerMetadataExtraction: s, triggerThumbnailGeneration: l };
}
function $a(r) {
  if (r)
    try {
      return JSON.parse(r);
    } catch (e) {
      console.error("Error parsing resumable payload", e);
    }
}
var ft, $, T, Fe, ie, Ee, he, pt, D, Ao, vo, br, Ft, bo, wo, Lt, Nt, _o, wr, _r;
class Va {
  constructor(e, t) {
    L(this, D);
    Tr(this, "uploader");
    L(this, ft);
    L(this, $);
    L(this, T, {
      assetId: Ce(),
      storageObjectId: Ce(),
      isUploadComplete: !1
    });
    L(this, Fe);
    L(this, ie);
    L(this, Ee);
    L(this, he);
    L(this, pt);
    var o;
    q(this, $, {
      onAssetAssigned: t.onAssetAssigned,
      onProgress: t.onProgress,
      onSuccess: t.onSuccess,
      onMetadata: t.onMetadata,
      onThumbnail: t.onThumbnail,
      onResumablePayloadChange: t.onResumablePayloadChange,
      onError: (i, s) => {
        t.onError(i, {
          assetId: a(this, T).assetId,
          fileId: a(this, T).storageObjectId,
          ...s
        });
      }
    }), q(this, pt, t.origin || "");
    const n = $a(t.resumablePayload);
    n && q(this, T, { ...a(this, T), ...n }), q(this, Fe, t.getAuthorizationToken), q(this, ie, e), q(this, Ee, Ma({
      getAuthorizationToken: a(this, Fe),
      isPublic: t.isPublic
    })), q(this, he, t.getWebSocket), q(this, ft, (o = t.getLogger) == null ? void 0 : o.call(t));
  }
  async startUpload() {
    var i, s, l;
    await k(this, D, Nt).call(this);
    const e = a(this, T).isUploadComplete, t = a(this, T).expiresAt && a(this, T).expiresAt < Date.now(), n = (s = await ((i = this.uploader) == null ? void 0 : i.tus.findPreviousUploads())) == null ? void 0 : s[0], o = !!n;
    return (l = a(this, ft)) == null || l.debug("Asset Adapter - Starting Upload", {
      fileName: a(this, ie).name,
      isExpired: t,
      canBeResumed: o,
      isUploadComplete: e
    }), e && !t ? k(this, D, _r).call(this) : o && !t ? k(this, D, wr).call(this, n) : k(this, D, wo).call(this);
  }
  async pauseUpload() {
    var e;
    await ((e = this.uploader) == null ? void 0 : e.tus.abort());
  }
  async resumeUpload() {
    var t, n;
    if (a(this, T).isUploadComplete) {
      k(this, D, _r).call(this);
      return;
    }
    await k(this, D, Nt).call(this);
    const e = (n = await ((t = this.uploader) == null ? void 0 : t.tus.findPreviousUploads())) == null ? void 0 : n[0];
    k(this, D, wr).call(this, e);
  }
  async cancelUpload() {
    var e, t, n;
    if (this.uploader) {
      await this.uploader.tus.abort();
      const o = await ((t = (e = this.uploader.tus.options).fingerprint) == null ? void 0 : t.call(e, a(this, ie), {})) || "";
      await ((n = this.uploader.tus.options.urlStorage) == null ? void 0 : n.removeUpload(o)), a(this, he).call(this).closeFileEvents(a(this, T).storageObjectId), a(this, he).call(this).closeFileEvents(a(this, T).assetId);
    }
  }
}
ft = new WeakMap(), $ = new WeakMap(), T = new WeakMap(), Fe = new WeakMap(), ie = new WeakMap(), Ee = new WeakMap(), he = new WeakMap(), pt = new WeakMap(), D = new WeakSet(), Ao = function() {
  a(this, he).call(this).listenForMetadata(a(this, T).assetId).then((e) => {
    var t, n;
    return (n = (t = a(this, $)).onMetadata) == null ? void 0 : n.call(t, e);
  });
}, vo = function() {
  a(this, he).call(this).listenForThumbnail(a(this, T).storageObjectId).then((e) => {
    var t, n;
    return (n = (t = a(this, $)).onThumbnail) == null ? void 0 : n.call(t, e);
  });
}, br = function(e) {
  if (a(this, $).onResumablePayloadChange) {
    const t = e ? JSON.stringify(e) : void 0;
    a(this, $).onResumablePayloadChange(t);
  }
}, Ft = function(e) {
  q(this, T, {
    ...a(this, T),
    ...e
  }), k(this, D, br).call(this, a(this, T));
}, bo = function() {
  q(this, T, {
    assetId: Ce(),
    storageObjectId: Ce(),
    isUploadComplete: !1,
    uploadUrl: void 0,
    expiresAt: void 0
  }), k(this, D, br).call(this, a(this, T));
}, wo = async function() {
  k(this, D, bo).call(this);
  const { uploadUrl: e, asset: t } = await a(this, Ee).createAsset(
    a(this, T).assetId,
    a(this, T).storageObjectId,
    a(this, pt)
  );
  k(this, D, Ft).call(this, {
    versionId: t.activeVersion.versionId,
    expiresAt: Date.now() + za,
    uploadUrl: e
  }), a(this, $).onAssetAssigned(
    a(this, T).assetId,
    a(this, T).storageObjectId
  ), await k(this, D, Lt).call(this), await k(this, D, Nt).call(this), k(this, D, _o).call(this);
}, Lt = async function() {
  await a(this, he).call(this).listenFileEvents(a(this, T).storageObjectId), await a(this, he).call(this).listenFileEvents(a(this, T).assetId), a(this, $).onMetadata && k(this, D, Ao).call(this), a(this, $).onThumbnail && k(this, D, vo).call(this), a(this, he).call(this).listenForFileUploadSuccess(a(this, T).storageObjectId).then(() => {
    k(this, D, Ft).call(this, {
      isUploadComplete: !0
    }), a(this, $).onSuccess(
      a(this, T).assetId,
      a(this, T).storageObjectId
    );
  });
}, Nt = async function() {
  var e;
  this.uploader = {
    tus: new Da(a(this, ie), {
      endpoint: a(this, T).uploadUrl || Ha,
      retryDelays: [0, 3e3, 5e3, 1e4, 2e4],
      chunkSize: 8 * 1024 * 1024,
      metadata: {
        filename: a(this, ie).name,
        filetype: a(this, ie).type
      },
      headers: {
        filename: encodeURI(a(this, ie).name)
      },
      fingerprint: () => Promise.resolve(
        [
          "tus-br",
          a(this, T).storageObjectId,
          a(this, ie).name,
          a(this, ie).type,
          a(this, ie).size,
          a(this, ie).lastModified
        ].join("-")
      ),
      onProgress: a(this, $).onProgress,
      onError: (t) => {
        var n;
        a(this, $).onError(t, {
          description: "TUS Failed to upload file",
          correlationId: t instanceof Ve ? (n = t.originalResponse) == null ? void 0 : n.getHeader(mo) : void 0
        });
      },
      onSuccess: () => {
        k(this, D, Ft).call(this, {
          isUploadComplete: !0
        });
      }
    })
  };
  try {
    const t = await ((e = a(this, Fe)) == null ? void 0 : e.call(this));
    this.uploader.tus.options.headers = {
      fileId: a(this, T).assetId,
      ...this.uploader.tus.options.headers,
      ...t ? { Authorization: `Bearer ${t}` } : {}
    };
  } catch (t) {
    a(this, $).onError(t, {
      description: "Failed to get authorization token"
    });
  }
}, _o = function() {
  var e;
  if (this.uploader)
    try {
      a(this, $).onAssetAssigned(
        a(this, T).assetId,
        a(this, T).storageObjectId
      ), (e = this.uploader) == null || e.tus.start();
    } catch (t) {
      a(this, $).onError(t, {
        description: "TUS Failed to start upload"
      });
    }
}, wr = async function(e) {
  var t;
  try {
    if (!this.uploader)
      throw new Error("Uploader is not initialized on resume");
    if (!e)
      throw new Error("No previous uploads found on resume");
    (t = this.uploader) == null || t.tus.resumeFromPreviousUpload(e), a(this, $).onAssetAssigned(
      a(this, T).assetId,
      a(this, T).storageObjectId
    ), await k(this, D, Lt).call(this), this.uploader.tus.start();
  } catch (n) {
    a(this, $).onError(n, {
      description: "TUS Failed to resume upload"
    });
  }
}, _r = async function() {
  var e, t, n, o;
  await k(this, D, Lt).call(this), a(this, $).onAssetAssigned(
    a(this, T).assetId,
    a(this, T).storageObjectId
  ), (t = (e = a(this, $)).onProgress) == null || t.call(e, a(this, ie).size, a(this, ie).size), a(this, $).onSuccess(a(this, T).assetId, a(this, T).storageObjectId);
  try {
    if (!a(this, T).versionId)
      throw new Error("versionId is missing");
    await a(this, Ee).triggerMetadataExtraction(
      a(this, T).assetId,
      a(this, T).versionId
    );
    const i = await a(this, Ee).triggerThumbnailGeneration(
      a(this, T).assetId,
      a(this, T).versionId
    );
    i && ((o = (n = a(this, $)).onThumbnail) == null || o.call(n, i));
  } catch (i) {
    a(this, $).onError(i, {
      description: "Failed to retrigger extraction"
    });
  }
};
function fc(r, e) {
  return new Va(r, e);
}
const Ga = 3, Wa = 8, Ja = 4, Xa = 10 * 60 * 1e3, Ka = "/v7/file_cmds/upload", Ya = "/v7/public_file_cmds/upload", er = 5 * 1024 * 1024, vn = 100 * 1024 * 1024;
function Za(r) {
  const { isPublic: e = !0 } = r || {}, t = e ? Ya : Ka;
  return {
    prepare: () => `${t}/prepare`,
    upload: (n, o) => `${t}/${n}/chunk/${o}`,
    finalise: (n) => `${t}/${n}/finalise`
  };
}
async function ec(r) {
  const e = await r.arrayBuffer(), t = await crypto.subtle.digest("SHA-256", e);
  return Array.from(new Uint8Array(t)).map((i) => i.toString(16).padStart(2, "0")).join("");
}
async function tc(r, e, t) {
  const n = e * t, o = n + t, i = r.slice(n, o), s = await ec(i);
  return {
    chunk: i,
    hash: s
  };
}
async function rc(r, e, t = Ga) {
  var n;
  for await (const o of Array.from({ length: t }, (i, s) => s))
    try {
      await new Promise((i, s) => {
        var p;
        const l = new XMLHttpRequest();
        l.open("POST", r), (p = e.signal) == null || p.addEventListener("abort", () => {
          l.abort();
        }), l.upload.addEventListener("progress", (d) => {
          d.lengthComputable && (e != null && e.onProgress) && e.onProgress(d.loaded);
        }), l.upload.addEventListener("loadend", (d) => {
          d.lengthComputable && (e != null && e.onProgress) && e.onProgress(d.loaded);
        }), l.addEventListener("loadend", () => {
          l.status < 200 || l.status >= 300 ? s(l.statusText) : i(l.response);
        });
        function u(d) {
          s(d.type);
        }
        l.addEventListener("error", u), l.addEventListener("abort", u), l.addEventListener("timeout", u), Object.entries(e.headers).forEach(([d, S]) => {
          l.setRequestHeader(d, S);
        }), l.send(e.body);
      });
      break;
    } catch (i) {
      if (o === t - 1 || (n = e.signal) != null && n.aborted)
        throw i;
      await new Promise((s) => setTimeout(s, 2 * o * 1e3));
    }
}
function nc(r, e) {
  const t = Math.ceil(r.size / e), n = /* @__PURE__ */ new Map();
  for (let o = 0; o < t; o++) {
    const i = o * e, l = i + e > r.size ? r.size - i : e;
    n.set(o, { size: l, loaded: 0 });
  }
  return n;
}
function oc(r) {
  return Array.from(r.values()).reduce((e, { loaded: t }) => e + t, 0);
}
function Eo(r, e) {
  return new Promise((t) => setTimeout(t, r, e));
}
async function So(r, e, t) {
  const o = r() < Ja, i = Date.now() - e > Xa;
  if (!o) {
    if (i)
      throw new Error("Max queued time exceeded while waiting to upload chunk");
    return await Eo(100, t), So(r, e, t);
  }
}
async function Bo(r, e) {
  if (!r())
    return await Eo(100, e), Bo(r, e);
}
function ic() {
  var e, t;
  const r = Number((t = (e = window.bynder) == null ? void 0 : e.Uploader) == null ? void 0 : t.chunkSize);
  return isNaN(r) || r < er ? er : r > vn ? vn : r;
}
function sc({
  intent: r,
  logger: e,
  getAuthorizationToken: t
}) {
  const n = !t, o = Za({ isPublic: n }), i = ic();
  async function s() {
    return n ? {} : { Authorization: `Bearer ${await (t == null ? void 0 : t())}` };
  }
  async function l({
    fileId: d,
    file: S,
    chunkNumber: R,
    abortSignal: z,
    onProgress: H
  }) {
    const B = await s(), { chunk: x, hash: U } = await tc(S, R, i), m = o.upload(d, R);
    return await rc(m, {
      headers: {
        "Content-Type": "application/octet-stream",
        "Content-SHA256": U,
        ...B
      },
      body: x,
      onProgress: (g) => H == null ? void 0 : H(R, g),
      signal: z
    }).catch((g) => {
      throw new Error("Failed to upload chunk number", { cause: g });
    });
  }
  async function u({
    file: d,
    fileId: S,
    chunkNumbers: R,
    abortSignal: z,
    onProgress: H
  }) {
    let B = 0, x = 0, U = !1;
    for await (const m of R) {
      if (await So(() => B, Date.now(), z), z.aborted)
        return;
      B++, l({
        fileId: S,
        file: d,
        chunkNumber: m,
        abortSignal: z,
        onProgress: H
      }).catch((A) => {
        e == null || e.error("FS Api - Failed to upload chunk", A, {
          fileId: S,
          fileSize: d.size,
          chunkNumber: m,
          chunkSize: i
        });
      }).finally(() => {
        B--, x++, U = x === R.length;
      });
    }
    await Bo(() => U, z);
  }
  async function p({
    retryNumber: d = 0,
    fileId: S,
    file: R,
    totalChunks: z,
    abortSignal: H,
    onProgress: B
  }) {
    if (H.aborted)
      throw new Error("Upload aborted");
    const x = await s(), U = new URLSearchParams();
    U.set("fileName", R.name), U.set("fileSize", R.size.toString()), U.set("chunksCount", z.toString()), r && U.set("intent", r);
    const { missingChunks: m, correlationId: A } = await fetch(o.finalise(S), {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        ...x
      },
      body: U
    }).then(async (g) => {
      try {
        return g.ok ? {} : {
          missingChunks: (await g.json()).missing_chunks,
          correlationId: g.headers.get(mo)
        };
      } catch (y) {
        throw Error(`Failed to finalise the upload: ${y}`);
      }
    });
    if (m) {
      if (d >= Wa)
        throw new Error("Failed to finalise the upload");
      d === 3 && (e == null || e.error(
        "FS Api - More that 3 finalise call retry required",
        new Error("Failed to finalise"),
        {
          fileId: S,
          missingChunks: m,
          retryNumber: d,
          correlationId: A
        }
      ));
      for (const g of m)
        B == null || B(g, 0);
      return await u({
        file: R,
        fileId: S,
        chunkNumbers: m,
        abortSignal: H,
        onProgress: B
      }), p({
        fileId: S,
        file: R,
        totalChunks: z,
        abortSignal: H,
        onProgress: B,
        retryNumber: d + 1
      });
    }
  }
  return {
    prepare: async () => {
      const d = await s(), S = o.prepare();
      try {
        return (await fetch(S, {
          method: "POST",
          headers: {
            "content-type": "application/x-www-form-urlencoded",
            ...d
          }
        }).then((z) => z.json())).file_id;
      } catch (R) {
        throw new Error(`Failed to prepare the upload: ${R}`);
      }
    },
    upload: async ({
      file: d,
      fileId: S,
      abortSignal: R,
      onProgress: z
    }) => {
      const H = Math.ceil(d.size / i), B = nc(d, i);
      function x(m, A) {
        const g = B.get(m);
        if (!g)
          return;
        g.loaded = A;
        const y = oc(B);
        z(y, d.size);
      }
      const U = Array.from({ length: H }, (m, A) => A);
      await u({
        fileId: S,
        file: d,
        chunkNumbers: U,
        abortSignal: R,
        onProgress: x
      });
      try {
        await p({ fileId: S, file: d, totalChunks: H, abortSignal: R });
      } catch (m) {
        throw new Error(`Failed to finalise the upload: ${S}`, {
          cause: m
        });
      }
    }
  };
}
var dt, ee, ue, fe, ve, Le, gt, Qe, Io, ko;
class ac {
  constructor(e, t) {
    L(this, Qe);
    L(this, dt);
    L(this, ee);
    L(this, ue);
    L(this, fe);
    L(this, ve);
    L(this, Le);
    L(this, gt);
    var n;
    q(this, gt, (n = t.getLogger) == null ? void 0 : n.call(t)), q(this, dt, e), q(this, Le, sc({
      intent: t.intent,
      getAuthorizationToken: t.getAuthorizationToken,
      logger: a(this, gt)
    })), q(this, fe, new AbortController()), q(this, ue, {
      onAssetAssigned: t.onAssetAssigned,
      onProgress: t.onProgress,
      onSuccess: t.onSuccess,
      onError: t.onError,
      onMetadata: t.onMetadata,
      onThumbnail: t.onThumbnail
    }), q(this, ve, t.getWebSocket);
  }
  async startUpload() {
    var e, t, n, o;
    try {
      q(this, ee, await a(this, Le).prepare()), (t = (e = a(this, ue)).onAssetAssigned) == null || t.call(e, a(this, ee), a(this, ee));
    } catch (i) {
      (o = (n = a(this, ue)).onError) == null || o.call(n, i, {
        description: "Failed to prepare the file upload"
      });
    }
    a(this, ee) && (await a(this, ve).call(this).listenFileEvents(a(this, ee)), !a(this, fe).signal.aborted && (a(this, ue).onMetadata && k(this, Qe, Io).call(this), a(this, ue).onThumbnail && k(this, Qe, ko).call(this), a(this, ve).call(this).listenForFileUploadSuccess(a(this, ee)).then(() => {
      var i, s;
      a(this, fe).signal.aborted || !a(this, ee) || (s = (i = a(this, ue)).onSuccess) == null || s.call(i, a(this, ee), a(this, ee));
    }), a(this, Le).upload({
      file: a(this, dt),
      fileId: a(this, ee),
      abortSignal: a(this, fe).signal,
      onProgress: (i, s) => {
        var l, u;
        (u = (l = a(this, ue)).onProgress) == null || u.call(l, i, s);
      }
    }).catch((i) => {
      var s, l;
      a(this, fe).signal.aborted || (l = (s = a(this, ue)).onError) == null || l.call(s, i, {
        description: "Failed to upload the file",
        fileId: a(this, ee)
      });
    })));
  }
  pauseUpload() {
    throw new Error("Not supported by FS adapter");
  }
  resumeUpload() {
    throw new Error("Not supported by FS adapter");
  }
  cancelUpload() {
    a(this, fe).abort();
  }
}
dt = new WeakMap(), ee = new WeakMap(), ue = new WeakMap(), fe = new WeakMap(), ve = new WeakMap(), Le = new WeakMap(), gt = new WeakMap(), Qe = new WeakSet(), Io = async function() {
  var t, n;
  if (!a(this, ee))
    throw new Error("The file-id was not properly set! Can't listen for metadata.");
  const e = await a(this, ve).call(this).listenForMetadata(a(this, ee));
  a(this, fe).signal.aborted || (n = (t = a(this, ue)).onMetadata) == null || n.call(t, e);
}, ko = async function() {
  var t, n;
  if (!a(this, ee))
    throw new Error("The file-id was not properly set! Can't listen for thumbnails.");
  const e = await a(this, ve).call(this).listenForThumbnail(a(this, ee));
  a(this, fe).signal.aborted || (n = (t = a(this, ue)).onThumbnail) == null || n.call(t, e);
};
function pc(r, e) {
  return new ac(r, e);
}
export {
  hc as A,
  pc as a,
  lc as b,
  fc as c,
  bn as g,
  Ce as v
};
